// German is the reference language: every key of the DAS Web text tree is declared here; `en` must
// carry the same tree (typed parity, das-web § 9).
export const deDE = {
  mailIntakes: {
    unsupportedFolder:
      'Dieser Abruf verwendet den Ordner „{{folder}}“. Hier können nur Posteingangsabrufe konfiguriert werden.',
    duplicate: 'Dieses Postfach wird bereits von einem anderen Abruf überwacht. Wähle ein anderes Postfach.',
    CursorOnly: 'Nur neue E-Mails',
    Full: 'Alle E-Mails',
    FromCutover: 'Ab einem Datum…',

    help: 'Hinweise zum E-Mail-Abruf',
    include: 'Beim ersten Abruf',

    title: 'Postfach scannen und importieren',
    configure: 'Scan- und Importeinstellungen',
    saved: 'Gespeichert.',
    forbidden: 'Nur Tenant-Admins können Postfächer konfigurieren.',
    loadError: 'Postfächer konnten nicht geladen werden.',
    save: 'Speichern',
    active: 'Automatisch scannen und importieren',
    pauseFirst: 'Zum Bearbeiten pausieren und speichern.',
    cutover: 'E-Mails ab Datum (00:00 UTC)',
    syncHint:
      'Der erste Import gilt für bisher nicht gescannte Postfächer. Bereits verarbeitete E-Mails werden nicht erneut eingelesen. Ein laufender Abruf kann nach dem Pausieren noch enden.',
    conflict: 'Die Einstellungen wurden geändert oder der Abruf ist aktiv. Bitte neu laden.',
    saveError: 'Speichern fehlgeschlagen. Bitte die Einstellungen prüfen und erneut versuchen.',
    invalid: 'Bitte ein Startdatum angeben.',
  },
  compliance: {
    title: 'Compliance-Monitor',
    subtitle:
      'Benutzer, Geräte und Verzeichnisänderungen Ihres Microsoft-365-Tenants, gelesen mit Ihren eigenen Rechten.',
    authorizeTitle: 'Microsoft-Zugriff erforderlich',
    authorizeDescription:
      'Diese Übersicht liest Ihren Microsoft-365-Tenant mit Ihrer Anmeldung. Dafür ist eine einmalige Freigabe je Sitzung nötig.',
    authorize: 'Bei Microsoft freigeben',
    authorizationFailed: 'Die Freigabe bei Microsoft ist fehlgeschlagen. Bitte erneut versuchen.',
    authorizationIncomplete: 'Die Freigabe wurde nicht abgeschlossen. Bitte erneut versuchen.',
    authorizationAccountMismatch:
      'Die Freigabe kam von einem anderen Microsoft-Konto als Ihrer Anmeldung. Bitte mit demselben Konto freigeben.',
    directoryMismatch:
      'Ihre Microsoft-Anmeldung gehört zu einem anderen Verzeichnis als dem, das für diesen Mandanten eingerichtet ist. Bitte mit einem Konto dieses Verzeichnisses freigeben.',
    notConfigured:
      'Für diese Umgebung ist kein Microsoft-Zugriff eingerichtet. Die Übersicht kann hier keine Daten lesen.',
    notPermitted: 'Microsoft hat diesen Abschnitt für Ihre Verzeichnisrollen nicht freigegeben.',
    unavailable: 'Dieser Abschnitt konnte nicht gelesen werden.',
    readAt: 'Stand {{time}}',
    changeWindow: 'Änderungen seit {{time}}',
    directory: 'Verzeichnis: {{name}} ({{id}})',
    directoryUnregistered:
      'Für diesen Mandanten ist kein Microsoft-Verzeichnis eingerichtet. Angezeigt wird das Verzeichnis Ihrer Anmeldung: {{name}} ({{id}}).',
    usersTitle: 'Benutzer',
    usersEmpty: 'Keine Benutzer gefunden.',
    columnUser: 'Benutzer',
    columnAuthTier: 'Anmeldeschutz',
    columnRoles: 'Verzeichnisrollen',
    columnLicenses: 'Lizenzen',
    licensesNone: 'keine',
    columnDevices: 'Geräte',
    columnLastSignIn: 'Letzte Anmeldung',
    signInUnknown: 'unbekannt',
    tierPhishingResistant: 'Phishing-resistent',
    tierStrong: 'Stark',
    tierWeakOnly: 'Nur schwach',
    tierNoMfa: 'Kein zweiter Faktor',
    tierUnknown: 'Unbekannt',
    tierPhishingResistantTitle: 'An den Ursprung gebunden: FIDO2, Windows Hello, Zertifikat oder Passkey.',
    tierStrongTitle:
      'Authenticator-App oder TOTP. Schützt vor Wiedereinspielung, nicht vor Echtzeit-Phishing.',
    tierWeakOnlyTitle:
      'Nur SMS, Anruf oder E-Mail registriert. Abfangbar per SIM-Tausch oder Postfachzugriff.',
    tierNoMfaTitle: 'Kein zweiter Faktor registriert.',
    tierUnknownTitle: 'Microsoft meldet keine Registrierung für diese Person.',
    devicesNone: 'keine',
    devicesCompliant: '{{count}} konform',
    devicesNonCompliant: '{{count}} nicht konform',
    unassignedTitle: 'Geräte ohne zugeordneten Benutzer',
    unassignedEmpty: 'Alle Geräte sind einem Benutzer zugeordnet.',
    columnDevice: 'Gerät',
    columnState: 'Zustand',
    columnOs: 'Betriebssystem',
    columnEnrolled: 'Aufgenommen',
    findingsTitle: 'Gründe für Nichtkonformität',
    findingsEmpty: 'Kein Gerät ist nicht konform.',
    columnPolicy: 'Richtlinie',
    columnSetting: 'Regel',
    settingUnknown: 'Regel nicht gemeldet',
    changesTitle: 'Änderungen',
    changesEmpty: 'Keine Verzeichnisänderungen im Zeitraum.',
    columnWhen: 'Zeitpunkt',
    columnActivity: 'Vorgang',
    columnActor: 'Ausgeführt von',
    columnTarget: 'Betroffenes Objekt',
    columnSource: 'Quell-IP',
    actorUnknown: 'unbekannt',
    filters: 'Filter',
    searchLabel: 'Suchen',
    searchPlaceholder: 'Person, Gerät, Rolle, Vorgang …',
    noMatches: 'Nichts gefunden. Suchbegriff anpassen.',
    rowCount: '{{count}} Zeilen',
    refused: 'Abgelehnt',
    refusedTitle: 'Der Versuch wurde von Microsoft abgelehnt und hat den Zustand nicht verändert.',
  },
  tenantAdministration: {
    openConnection: 'Verbindung prüfen',
    checkResource: 'Zugriff prüfen: {{name}}',
    mailboxResource: 'Postfach: {{name}}',
    filingResource: 'Ablage: {{name}}',

    connectionHealth: 'Microsoft-365-Verbindung',
    notConnected:
      'Microsoft 365 ist nicht verbunden. Wende dich zur Einrichtung an den Plattformadministrator.',
    filing: 'Ablage',

    invoiceSettingsDescription:
      'Empfängerprüfung, automatischen Versand und Weiterleitungsadresse festlegen.',
    companyDescription:
      'Name, Anschrift und USt-IdNr. des eigenen Betriebs für Eingangs- und Ausgangsrechnungen, dazu Bankverbindung und Zahlungsziel.',
    openSettings: 'Einstellungen öffnen',
    title: 'Administration',
    mailTitle: 'Mail-Eingang und Verarbeitung',
    mailDescription:
      'Prüfe den Postfachabruf, eingegangene Mails und den Stand der Rechnungsverarbeitung und des Versands.',
    unavailable: 'Für deinen Zugang sind derzeit keine Administrationsaufgaben verfügbar.',
    absenceTitle: 'Abwesenheitsmails',
    absenceDescription: 'Prüfe Eingang, Verarbeitung, Ablage und Versand der Abwesenheitsmails.',

    decidaloTitle: 'decídalo-Verbindung',
    decidaloDescription:
      'Verifizierte Abwesenheiten gehen an decídalo. Eingerichtet wird die Verbindung vom Betreiber; hier steht, ob und wohin.',
    decidaloNotConfigured: 'decídalo ist für diesen Mandanten nicht eingerichtet.',
    decidaloLoadError: 'Die decídalo-Verbindung konnte nicht geladen werden.',
    decidaloBaseUrl: 'Import-API: {{url}}',
    decidaloDisplayName: 'Bezeichnung: {{name}}',
    decidaloActive: 'Status: aktiv',
    decidaloPaused: 'Status: pausiert — es geht nichts hinaus.',
    decidaloSecretName: 'Schlüsselname: {{name}}',
    decidaloEnabled: 'Projektion: eingeschaltet',
    decidaloDisabled: 'Projektion: nicht eingeschaltet',
    decidaloNotEnabled:
      'Die Verbindung ist aktiv, die Projektion aber nicht eingeschaltet — es geht nichts hinaus. Beides setzt der Betreiber.',

    whatsappTitle: 'WhatsApp-Nummer',
    whatsappDescription:
      'Meldungen per WhatsApp kommen über diese Nummer an. Gebunden wird sie vom Betreiber; hier steht, welche es ist.',
    whatsappNotConfigured: 'Für diesen Mandanten ist keine WhatsApp-Nummer aktiv.',
    whatsappLoadError: 'Die WhatsApp-Nummer konnte nicht geladen werden.',
    whatsappActive: 'Aktiv: {{number}} (seit {{since}})',
    whatsappReleased: 'Freigegeben am {{on}}: {{number}} — nimmt nichts mehr an und sendet nichts mehr.',
  },
  absenceResourcePlan: {
    title: 'Abwesenheitsplan',
    readOnly:
      'Nur-Lese-Vorschau des Ressourcenplans aus SharePoint. Die Jahre stehen als Blätter unten in der Vorschau.',
    previewTitle: 'Vorschau des Ressourcenplans',
    denied: 'Der Abwesenheitsplan ist für diesen Arbeitsbereich nicht freigeschaltet.',
    notFound: 'Der Ressourcenplan wurde am vorgesehenen Ort in SharePoint nicht gefunden.',
    loadError: 'Die Vorschau ist gerade nicht verfügbar.',
    retry: 'Erneut versuchen',
  },
  absenceAutomaticReplies: {
    title: 'Abwesenheitsnotizen',
    intro:
      'Täglicher Abgleich der Outlook-Abwesenheitsnotizen mit genehmigtem Urlaub. Gezählt wird der letzte Versuch je Postfach.',
    none: '—',
    lastSucceeded: 'Letzter erfolgreicher Abgleich',
    nextDue: 'Nächster Abgleich',
    lastAttempt: 'Letzter Versuch an einem Postfach',
    jobError: 'Fehlercode des Abgleichs',
    noJob: 'Der Abgleich ist noch nicht gelaufen.',
    loadError: 'Der Stand des Abgleichs ist gerade nicht verfügbar.',
    notAuthorizedHint:
      'Nicht berechtigt heißt: Die Person ist (noch) nicht in der vom Kunden gepflegten Gruppe, oder die Exchange-Rolle ist noch nicht wirksam. Die Plattform ändert die Gruppe nicht.',
    runNow: 'Jetzt abgleichen',
    scheduled: 'Der Abgleich ist angestoßen und läuft mit dem nächsten Durchgang des Workers.',
    inactive: 'Es gibt noch keinen aktiven Abgleich, der angestoßen werden könnte.',
    runFailed: 'Der Abgleich konnte nicht angestoßen werden.',
    urgentContact: {
      description:
        'Eine allgemeine Adresse des Unternehmens, etwa die Zentrale oder ein Team-Postfach. Sie erscheint in der Outlook-Abwesenheitsnotiz aller Mitarbeitenden bei genehmigtem Urlaub.',
      label: 'Allgemeine E-Mail-Adresse für dringende Anliegen',
      hint: 'Optional, z. B. info@… — keine persönliche Adresse, denn sie gilt für alle. Ohne Eintrag entfällt der Hinweis. Eine persönliche Vertretung für einen Urlaub trägt jede Person selbst in Outlook ein und behält dabei den Zeitraum bei.',
      invalid: 'Bitte genau eine E-Mail-Adresse ohne Namen oder Sonderzeichen wie < > & eingeben.',
      save: 'Speichern',
      remove: 'Entfernen',
      saved: 'Gespeichert. Die Abwesenheitsnotizen werden mit dem nächsten Abgleich angepasst.',
      removed: 'Entfernt. Die Abwesenheitsnotizen werden mit dem nächsten Abgleich angepasst.',
      failed: 'Der Kontakt konnte nicht gespeichert werden.',
      loadError: 'Der Kontakt für dringende Anliegen ist gerade nicht verfügbar.',
    },
    outcome: {
      Applied: 'Gesetzt',
      Unchanged: 'Unverändert',
      OptedOut: 'Abgewählt',
      ManualConflict: 'Von Hand geändert, unberührt',
      Failed: 'Fehlgeschlagen',
    },
    error: {
      'not-authorized': 'Nicht berechtigt',
      'mailbox-unavailable': 'Postfach nicht erreichbar',
      'invalid-target': 'Von Exchange abgelehnt',
      'lease-lost': 'Lauf übernommen',
    },
  },
  absenceProtocol: {
    title: 'Abwesenheitsprotokoll',
    intro:
      'Technisches Verarbeitungsprotokoll. Abwesenheiten und Freigabeentscheidungen werden in SharePoint geführt.',
    observed: 'Stand',
    none: '—',
    mail: 'Mail #{{id}}',
    mailColumn: 'Mail',
    backToList: 'Zum Protokoll',
    received: 'Eingang',
    seen: 'Erstmals erfasst',
    routed: 'Zugeordnet am',
    intakeTitle: 'Eingang und Verarbeitung',
    period: 'Extrahierter Zeitraum',
    periodRange: '{{start}} – {{end}}',
    periodOpenEnd: 'Ab {{start}} · kein Enddatum extrahiert',
    periodOpenStart: 'Bis {{end}} · kein Startdatum extrahiert',
    noPeriod: 'Kein Zeitraum extrahiert',
    approvalReply: 'Freigabe-Antwort – Zeitraum steht im Antrag',
    periodNotLogged: 'Zeitraum nicht protokolliert',
    periodHint:
      'Der Zeitraum ist das Ergebnis der automatischen Auswertung dieser Mail, nicht der Stand im Abwesenheitsjournal und keine Genehmigung.',
    processingTitle: 'Verarbeitung',
    noDispatch: 'Kein Verarbeitungsauftrag protokolliert',
    routingTitle: 'Klassifizierung',
    routing: {
      Pending: 'Noch nicht klassifiziert',
      RetryPending: 'Klassifizierung wird erneut versucht',
      Exhausted: 'Klassifizierung fehlgeschlagen – Versuche ausgeschöpft',
      Absence: 'Als Abwesenheit klassifiziert',
      NotAbsence: 'Keine Abwesenheitsmail',
    },
    processing: {
      Pending: 'Ausstehend',
      InProgress: 'In Bearbeitung',
      Delivered: 'Verarbeitung abgeschlossen',
      Failed: 'Fehlgeschlagen',
    },
    filingTitle: 'Ablage',
    filingMove: 'Ziel und Verschiebung',
    filingTarget: 'Ziel: {{folder}} · {{state}}',
    notLogged: 'Nicht protokolliert',
    reviewLabel: 'Teamleitung',
    review: {
      Open: 'an Teamleitung übergeben',
      Approved: 'von Teamleitung genehmigt am {{date}}',
    },
    filing: {
      Pending: 'Verschiebung ausstehend',
      InProgress: 'Verschiebung läuft',
      Done: 'Verschoben',
      Failed: 'Verschiebung fehlgeschlagen',
    },
    attempts: 'Versuche',
    updated: 'Zuletzt aktualisiert',
    errorCode: 'Fehlercode',
    outlookId: 'Outlook-ID',
    mailbox: 'Postfach-ID',
    outgoingTitle: 'Ausgehende Mails',
    noOutgoing: 'Keine ausgehende Mail protokolliert.',
    noResult: 'Keine Ergebnismail protokolliert.',
    purposeColumn: 'Zweck',
    relationColumn: 'Ausgelöst durch',
    createdColumn: 'Erstellt am',
    stateColumn: 'Versandstatus',
    sentColumn: 'Gesendet am',
    purpose: {
      ApprovalRequest: 'Freigabe-Anfrage',
      DecisionResult: 'Ergebnismail',
      TeamLeadNotice: 'Teamleiter-Information',
      ConflictNotice: 'Terminkonflikt-Information',
      ReviewNotice: 'Klärung an Teamleitung',
      CancellationResult: 'Storno-Quittung',
      CancellationConfirm: 'Storno-Rückfrage',
    },
    relation: {
      Direct: 'Diese Mail',
      Related: 'Mail #{{id}}',
      Scheduled: 'Geplanter Lauf',
    },
    send: {
      Pending: 'Versand ausstehend',
      Preparing: 'Versand wird vorbereitet',
      Ready: 'Bereit zur Übermittlung',
      SubmittedUnknown: 'Versandausgang unbestätigt',
      Sent: 'Gesendet',
      Failed: 'Versand fehlgeschlagen',
    },
    semanticsHint:
      '„Gesendet“ bedeutet den protokollierten Versand, nicht gelesen oder bestätigt. „Verarbeitung abgeschlossen“ bedeutet nicht, dass eine Abwesenheit genehmigt wurde.',
    emptyTenant: 'Keine zugeordneten Abwesenheitsmails protokolliert.',
    emptyTeam: 'Keine Abwesenheitsmails für dein Team protokolliert.',
    notFound: 'Diese Mail wurde nicht gefunden.',
    denied:
      'Für diese Ansicht brauchst du die Tenant-Administration und eine aktivierte Abwesenheitserfassung.',
    loadError: 'Das Abwesenheitsprotokoll konnte nicht geladen werden.',
    newestPage: 'Neueste Mails',
    olderPage: 'Ältere Mails',
  },
  absenceReview: {
    title: 'Urlaubsanträge klären',
    intro: 'Urlaubsanträge Ihres direkten Teams, die zur manuellen Prüfung vorliegen.',
    request: 'Urlaubsantrag von {{name}}',
    requestFallback: 'Urlaubsantrag',
    backToList: 'Zu „Urlaubsanträge klären“',
    received: 'Eingang',
    employee: 'Mitarbeiter',
    period: 'Zeitraum',
    periodRange: '{{start}}–{{end}}',
    periodOpenEnd: 'ab {{start}}',
    morePeriods_one: '{{period}} + {{count}} weiterer',
    morePeriods_other: '{{period}} + {{count}} weitere',
    noPeriodShort: 'kein Zeitraum erkannt',
    none: '—',
    durationColumn: 'Tagesart',
    duration: {
      'whole-day': 'ganztägig',
      'partial-day': 'halbtags',
      unknown: 'unklar',
    },
    statusColumn: 'Status',
    status: {
      requested: 'beantragt',
      approved: 'genehmigt',
    },
    periodsTitle: 'Erkannte Zeiträume',
    noPeriod: 'In der Mail wurde kein Zeitraum erkannt.',
    existingTitle: 'Bestehende Urlaube',
    noExisting: 'Keine bestehenden Urlaube.',
    mailTitle: 'Originalmail',
    showMail: 'Originalmail anzeigen',
    subject: 'Betreff',
    from: 'Absender',
    mailReceived: 'Empfangen',
    mailTable: 'Tabelle aus der Originalmail',
    mailColumn: 'Spalte {{number}}',
    truncated: 'Die Mail wurde gekürzt.',
    omittedAttachments_one: '{{count}} Anhang wird nicht angezeigt.',
    omittedAttachments_other: '{{count}} Anhänge werden nicht angezeigt.',
    mailUnavailable: 'Die Originalmail ist nicht verfügbar.',
    empty: 'Keine offenen Urlaubsanträge in Ihrem Team.',
    notFound: 'Dieser Urlaubsantrag wurde nicht gefunden.',
    noTeamTitle: 'Keine Teamzuordnung.',
    noTeam: 'Nur Teamleitungen sehen hier die offenen Urlaubsanträge ihres direkten Teams.',
    unavailable:
      'Die Teamzuordnung aus Microsoft 365 ist gerade nicht verfügbar. Bitte versuchen Sie es später erneut.',
    loadError: 'Die zu klärenden Urlaubsanträge konnten nicht geladen werden.',
    newestPage: 'Neueste Anträge',
    olderPage: 'Ältere Anträge',
    approveTitle: 'Zeiträume bestätigen',
    approveIntro: 'Prüfen und korrigieren Sie die Zeiträume und wählen Sie für jeden die Tagesart.',
    approveForm: 'Urlaub genehmigen',
    periodNumber: 'Zeitraum {{number}}',
    startDate: 'Beginn',
    endDate: 'Ende',
    removePeriod: 'Entfernen',
    removePeriodLabel: 'Zeitraum {{number}} entfernen',
    addPeriod: 'Zeitraum hinzufügen',
    endBeforeStart: 'Das Ende liegt vor dem Beginn.',
    incomplete: 'Bitte geben Sie für jeden Zeitraum Beginn, Ende und Tagesart an.',
    approve: 'Genehmigen',
    approveHint:
      'Mit der Genehmigung erhält der Mitarbeiter eine Ergebnismail und der Ressourcenplan wird aktualisiert; halbe Tage erhalten keinen Kalendereintrag und keine automatische Antwort.',
    approveAlreadyResolved: 'Dieser Antrag wurde bereits erledigt.',
    approveOverlap:
      'Ein Zeitraum überschneidet einen bestehenden Urlaub. Bitte entfernen oder ändern Sie ihn.',
    approveInvalid:
      'Bitte prüfen Sie die Zeiträume: ein bis zwölf Zeiträume ohne Überschneidung, jeweils mit einem Ende nicht vor dem Beginn und ganztägig oder halbtags.',
    approveFailed: 'Die Genehmigung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    approved: 'Der Urlaub von {{name}} wurde genehmigt.',
    approvedNoMail: 'Der Urlaub von {{name}} wurde genehmigt. Es wurde keine Ergebnismail versendet.',
  },
  invoiceProcessing: {
    notFound: 'Diese Mail wurde nicht gefunden.',
    backToList: 'Zur Mailliste',
    title: 'Mail-Verarbeitung',
    settings: 'Aktuelle Weiterleitungseinstellungen',
    automatic: 'Automatischer Versand',
    recipient: 'Zieladresse',
    enabled: 'Ein',
    disabled: 'Aus',
    missing: 'Nicht eingerichtet',
    settingsHint:
      'Die Zieladresse allein aktiviert den Versand nicht. Diese Einstellungen gelten jetzt; sie belegen nicht die Einstellung zum Zeitpunkt einer früheren Mail.',
    deliveryHint:
      'DAS zeigt den Versandnachweis bei Microsoft, nicht die Zustellung im Zielpostfach. Outlook-Weiterleitungsregeln werden hier nicht geprüft.',
    intakes: 'Überwachte Postfächer',
    noIntakes:
      'Kein überwachtes Postfach eingerichtet. Bitte die M365-Verbindung in der Kundenverwaltung prüfen.',
    mailbox: 'Postfach',
    folder: 'Ordner',
    intakeState: 'Abruf',
    Active: 'Aktiv',
    Paused: 'Pausiert',
    lastRun: 'Letzter Abrufversuch',
    lastSuccess: 'Letzter erfolgreicher Scan',
    never: 'Noch kein Nachweis',
    syncMode: 'Erster Abgleich',
    cutover: 'Berücksichtigt ab',
    Full: 'Alle vorhandenen Mails',
    CursorOnly: 'Nur neue Mails nach dem ersten Abgleich',
    FromCutover: 'Mails ab dem Stichtag',
    mail: 'Mail {{id}}',
    outlookId: 'Outlook Immutable Message ID',
    received: 'Eingang bei Outlook',
    seen: 'Erstmals von DAS erfasst',
    routed: 'Klassifiziert am',
    routingTitle: 'Klassifizierung',
    attempts: 'Fehlversuche',
    processingTitle: 'Rechnungsverarbeitung',
    errorCode: 'Fehlercode',
    errorHint:
      'Der Schritt ist fehlgeschlagen. Prüfe die M365-Verbindung und die Solution-Konfiguration; gib bei einer Supportanfrage Outlook-ID und Fehlercode an.',
    updated: 'Zuletzt aktualisiert',
    noInvoice: 'Noch kein Rechnungsdatensatz vorhanden.',
    noOrder: 'Kein Versandauftrag erfasst. Prüfe Rechnungsstatus und Weiterleitungseinstellungen.',
    notEligible: 'Die Rechnung ist nicht für den automatischen Versand freigegeben.',
    deliveryTitle: 'Weiterleitung',
    noMessages: 'Keine erfassten Mails für diese Auswahl.',
    emptyHint:
      'Prüfe Postfach, Ordner und letzten Abruf. Eine an eine andere Adresse gesendete oder noch nicht abgerufene Mail kann hier nicht erscheinen.',
    denied: 'Für diese Ansicht brauchst du Tenant-Adminrechte.',
    loadError: 'Die Mail-Verarbeitung konnte nicht geladen werden.',
    observed: 'Stand',
    retryHint: 'DAS versucht es beim nächsten aktiven Postfachscan erneut.',
    exhaustedHint: 'Die automatischen Versuche sind beendet. Prüfe den Fehler und kontaktiere den Support.',
    routing: {
      Pending: 'Noch nicht klassifiziert',
      RetryPending: 'Erneuter Versuch vorgesehen',
      Exhausted: 'Versuche ausgeschöpft',
      Invoice: 'Als Rechnung klassifiziert',
      NoInvoiceRoute: 'Nicht an die Rechnungsverarbeitung übergeben',
      Routed: 'Klassifizierung abgeschlossen',
    },
    processing: {
      Pending: 'Wartet auf Verarbeitung',
      InProgress: 'In Verarbeitung',
      Delivered: 'Verarbeitungsschritt abgeschlossen – Rechnungsergebnis unten prüfen',
      Failed: 'Verarbeitung fehlgeschlagen',
    },
    delivery: {
      Pending: 'Versandvorbereitung ausstehend',
      Preparing: 'Versand wird vorbereitet',
      Ready: 'Bereit zur Übermittlung',
      SubmittedUnknown: 'Versandausgang noch unbestätigt – kein erneuter Versand',
      Sent: 'Versand bei Microsoft bestätigt – Empfängerzustellung nicht nachgewiesen',
      Failed: 'Versand fehlgeschlagen',
    },
  },
  m365Setup: {
    folderTooLarge:
      'Dieser Ordner enthält mehr Einträge, als die automatische Einrichtung prüfen kann. Wähle einen kleineren Ablageordner oder kontaktiere den Plattformbetreiber.',
    folder: 'Ablageordner',
    openFolder: 'Ordner öffnen',
    parentFolder: 'Übergeordneter Ordner',
    libraryRoot: 'Noch kein Ordner ausgewählt',
    noSubfolders: 'Keine weiteren Unterordner.',
    folderScope:
      'Die Rechnungs-App erhält Zugriff auf den ausgewählten Ordner einschließlich Unterordnern und Dateien. Dieser Ordner bekommt eigene Berechtigungen; spätere Rechteänderungen an der übergeordneten Bibliothek werden nicht automatisch übernommen.',

    loginFailed:
      'Die Microsoft-Anmeldung ist fehlgeschlagen oder wurde abgebrochen. Öffne den ursprünglichen Einrichtungslink erneut und melde dich mit dem passenden Kundenadmin-Konto an.',
    sessionExpired:
      'Die Rückkehr von Microsoft konnte nicht abgeschlossen werden oder ist abgelaufen. Öffne den ursprünglichen Einrichtungslink im selben Browser erneut.',
    needsReview:
      'Die vorhandene Verbindung muss zuerst vom Plattformbetreiber geprüft werden. Bitte kontaktiere ihn; es wurden keine neuen Microsoft-Freigaben gesetzt.',
    title: 'Microsoft 365 verbinden',
    inviteTitle: 'Microsoft-Einrichtung durch den Kundenadmin',
    inviteDescription:
      'Erstelle einen Kundenlink. Der Microsoft-365-Admin meldet sich dort an und wählt Postfach und Ablage direkt aus Microsoft aus.',
    createLink: 'Einrichtungslink erstellen',
    linkExpiry: 'Der Link ist bis {{date}} gültig. Ein neuer Link ersetzt den bisherigen.',
    openLink: 'Einrichtung öffnen',
    copyLink: 'Link kopieren',
    copied: 'Link kopiert',
    revokeLink: 'Link widerrufen',
    inviteError:
      'Der Einrichtungslink konnte nicht verwaltet werden. Prüfe, ob die Microsoft-Einrichtung für diese Plattform bereitgestellt ist.',
    loginDescription:
      'Verbinde Microsoft 365 für die eingerichtete Lösung. Melde dich bei Microsoft mit dem Administratorkonto der Kundenorganisation an. Microsoft fragt die Berechtigungen für SharePoint und Exchange getrennt ab.',
    connect: 'Mit Microsoft anmelden',
    connecting: 'Anmeldung wird geöffnet …',
    linkError:
      'Der Einrichtungslink konnte nicht geöffnet werden. Er ist möglicherweise abgelaufen oder widerrufen.',
    linkRequired:
      'Öffne den Einrichtungslink aus der Kundenverwaltung. Eine abgelaufene Einrichtung benötigt einen neuen Link.',
    unavailable: 'Die Microsoft-Einrichtung ist momentan nicht erreichbar. Versuche es erneut.',
    organization: 'Microsoft-Organisation',
    customer: 'Kunde',
    permissionsDescription:
      'Die Einrichtung sucht Ressourcen mit deiner Microsoft-Berechtigung. Die eingerichtete Lösung erhält ihren eigenen technischen Zugang zu den freigegebenen Ressourcen.',
    mailSearch: 'Postfachname oder E-Mail-Adresse',
    siteSearch: 'SharePoint-Site suchen',
    site: 'SharePoint-Site',
    search: 'Suchen',
    choose: 'Bitte auswählen',
    shared: 'Gemeinsames Postfach',
    noResults: 'Keine passenden Ressourcen gefunden.',
    discoveryError:
      'Die Ressourcen konnten nicht geladen werden. Prüfe deine Microsoft-Administratorrechte und die Freigabe für diese Einrichtung.',
    confirm: 'Freigeben und Einrichtung prüfen',
    applying: 'Rechte und Verbindung werden geprüft …',
    retryApply: 'Einrichtung erneut prüfen',
    confirmOrganization: 'Ich bestätige die Verbindung von {{organization}} mit {{customer}}.',
    writeTest:
      'Zur Prüfung werden im gewählten Ordner ein Test-Unterordner und darin ein Testdokument angelegt und anschließend wieder entfernt.',
    selectionRequired:
      'Wähle ein Postfach, eine Site, eine Dokumentbibliothek und einen Ablageordner aus und bestätige die Organisation. Bei einem Startdatum muss auch das Datum ausgefüllt sein.',
    applyError:
      'Die Einrichtung ist noch nicht vollständig. Microsoft-Rechte können zeitversetzt wirksam werden. Wiederhole die Prüfung mit derselben Auswahl. Bei geänderter Konfiguration oder abgelaufener Anmeldung starte mit einem neuen Einrichtungslink.',
    credentialError:
      'Der technische Microsoft-Zugang konnte nicht eingerichtet werden. Prüfe die Administratorrechte. Eine bestehende App mit organisationsweiten Rechten benötigt eine Prüfung durch den Plattformbetreiber.',
    sharePointError:
      'Die SharePoint-Freigabe ist noch nicht eingerichtet. Prüfe deine SharePoint-Administratorrechte und wiederhole die Einrichtung.',
    exchangeError:
      'Die Postfachfreigabe ist noch nicht eingerichtet. Prüfe deine Exchange-Administratorrechte und wiederhole die Einrichtung.',
    runtimeError:
      'Die Freigaben wurden eingerichtet, aber der technische Zugriff funktioniert noch nicht. Neue Microsoft-Rechte können verzögert wirksam werden. Wiederhole die Prüfung mit derselben Auswahl.',
    bindingError:
      'Die Zugriffsprüfung war erfolgreich, aber die Konfiguration konnte nicht gespeichert werden. Bitte kontaktiere den Plattformbetreiber, damit er Änderungen an der bestehenden Verbindung prüft.',
    ready:
      'Microsoft 365 ist verbunden. Posteingang und Schreibzugriff auf die Ablage wurden geprüft. Der Rechnungseingang ist gespeichert und bleibt pausiert.',
    outgoing: {
      description:
        'Wähle die SharePoint-Bibliothek, in der DAS Word- und Excel-Rechnungen kurz ablegt, um sie als PDF rendern zu lassen. DAS erhält Schreibzugriff nur auf diese Bibliothek und legt darin den Ordner „_das-platform“ an; Postfächer und andere Bibliotheken bleiben unberührt.',
      library: 'Bibliothek für den Rechnungsausgang',
      grants:
        'Mit dem Bestätigen erhält die DAS-App Ihrer Organisation Schreibzugriff auf die gewählte Bibliothek. Weitere Microsoft-Rechte werden nicht vergeben.',
      ready:
        'Die Bibliothek für den Rechnungsausgang ist verbunden. Rechnungen können jetzt per E-Mail versendet werden, sobald ein Absenderpostfach gewählt ist.',
      libraryNotInSite: 'Die gewählte Bibliothek gehört nicht zur gewählten Website. Bitte erneut auswählen.',
      otherLibrary:
        'Für den Rechnungsausgang wurde bereits eine andere Bibliothek eingerichtet. Bitte wende dich an den Plattformbetreiber, damit er die bestehende Freigabe prüft.',
    },
    absence: {
      mailboxTitle: 'Postfach für Abwesenheitsmeldungen',
      mailbox: 'Abwesenheitspostfach',
      mailboxSearch: 'Abwesenheitspostfach suchen',
      mailboxScope:
        'Die Plattform liest den Posteingang dieses Postfachs und versendet aus demselben Postfach. Antworten der Teamleitung müssen hier ankommen, damit die Freigabe zugeordnet werden kann.',
      teamLeadTitle: 'Bibliothek der Teamleitung',
      teamLeadSite: 'SharePoint-Site der Teamleitung',
      teamLeadSearch: 'Site der Teamleitung suchen',
      teamLeadLibrary: 'Bibliothek der Teamleitung',
      teamLeadPaths:
        'Hier liegen „Stammdaten/Mitarbeiter.xlsx“ und „Abwesenheit/Abwesenheiten.xlsx“. Beide Dateien müssen vor der Einrichtung an genau diesen Pfaden vorhanden sein.',
      employeeTitle: 'Bibliothek der Mitarbeitenden',
      employeeSite: 'SharePoint-Site der Mitarbeitenden',
      employeeSearch: 'Site der Mitarbeitenden suchen',
      employeeLibrary: 'Bibliothek der Mitarbeitenden',
      employeePath: 'Hier liegt „Abwesenheit/Ressourcenplan.xlsx“, der Plan, den alle im Unternehmen sehen.',
      conflictsTitle: 'Terminkonflikte',
      detectConflicts: 'Terminkonflikte erkennen',
      detectConflictsHint:
        'Bei einer Krankmeldung liest die Plattform die Kalender der gemeldeten Person im gemeldeten Zeitraum und benachrichtigt die Teilnehmenden betroffener Termine. Ohne diese Option entsteht kein Kalenderzugriff.',
      probeMailbox: 'Postfach für die Zugriffsprüfung',
      probeSearch: 'Benutzerpostfach für die Prüfung suchen',
      probeHint:
        'Die Kalenderberechtigung wird an einem echten Benutzerpostfach nachgewiesen. Das Abwesenheitspostfach eignet sich nicht: Es ist ein freigegebenes Postfach und liegt außerhalb der Berechtigung.',
      automaticRepliesTitle: 'Abwesenheitsnotizen',
      automaticRepliesScope: 'Exchange-Scope für Abwesenheitsnotizen (optional)',
      automaticRepliesHint:
        'Nur ausfüllen, wenn Ihre Exchange-Verwaltung den Scope „DAS-OOF-…“ über die Gruppe der Mitarbeitenden mit Abwesenheitsnotiz von Hand angelegt und berechtigt hat. Die Einrichtung speichert nur den Namen; sie legt weder Gruppe noch Scope noch Recht an. Leer lassen entfernt eine bestehende Angabe.',
      automaticRepliesInvalid:
        'Der Name beginnt mit „DAS-OOF-“ und enthält nur Buchstaben, Ziffern, „-“ oder „_“.',
      proofHint:
        'Vor dem Speichern liest die Einrichtung die drei Arbeitsmappen mit dem neuen technischen Zugang und schreibt Journal und Ressourcenplan unverändert zurück. Damit ist bewiesen, dass der laufende Betrieb sie wirklich bearbeiten kann.',
      pausedHint:
        'Die Verarbeitung bleibt zunächst pausiert. Der Plattformbetreiber schaltet sie frei, sobald die Einrichtung geprüft ist.',
      selectionRequired:
        'Bitte Postfach, beide Bibliotheken, das Startdatum und die Bestätigung der Organisation angeben. Mit „Terminkonflikte erkennen“ zusätzlich ein Postfach für die Zugriffsprüfung.',
      ready:
        'Microsoft 365 ist verbunden. Postfach, beide Bibliotheken und die drei Arbeitsmappen wurden mit dem neuen Zugang geprüft. Die Abwesenheitsverarbeitung ist gespeichert und bleibt pausiert.',
      mailboxPending:
        'Das Abwesenheitspostfach konnte mit dem neuen technischen Zugang noch nicht gelesen werden. Neue Microsoft-Rechte können verzögert wirksam werden. Wiederhole die Prüfung mit derselben Auswahl.',
      employeesMissing:
        'In der Bibliothek der Teamleitung fehlt „Stammdaten/Mitarbeiter.xlsx“. Lege die Datei genau an diesem Pfad ab und wiederhole die Prüfung.',
      journalMissing:
        'In der Bibliothek der Teamleitung fehlt „Abwesenheit/Abwesenheiten.xlsx“. Lege die Datei genau an diesem Pfad ab und wiederhole die Prüfung.',
      planMissing:
        'In der Bibliothek der Mitarbeitenden fehlt „Abwesenheit/Ressourcenplan.xlsx“. Lege die Datei genau an diesem Pfad ab und wiederhole die Prüfung.',
      journalNotWritable:
        '„Abwesenheit/Abwesenheiten.xlsx“ konnte gelesen, aber nicht zurückgeschrieben werden. Die Datei ist geöffnet, schreibgeschützt oder abweichend berechtigt. Schließe sie und wiederhole die Prüfung.',
      planNotWritable:
        '„Abwesenheit/Ressourcenplan.xlsx“ konnte gelesen, aber nicht zurückgeschrieben werden. Die Datei ist geöffnet, schreibgeschützt oder abweichend berechtigt. Schließe sie und wiederhole die Prüfung.',
      calendarPending:
        'Die Kalenderberechtigung ist noch nicht wirksam. Microsoft benötigt dafür 30 Minuten bis zwei Stunden. Alles andere ist eingerichtet; wiederhole die Prüfung später mit derselben Auswahl.',
      calendarFailed:
        'Die Kalender konnten mit dem neuen technischen Zugang nicht gelesen werden. Prüfe deine Exchange-Administratorrechte und wiederhole die Einrichtung.',
    },
    checklist: {
      title: 'Zugriffs-Checkliste',
      sessionTitle: 'Verbindung prüfen',
      sessionHint:
        'Prüft mit dem bereits eingerichteten technischen Zugang jede Zugriffsart einzeln — ohne neue Rechte zu vergeben und ohne zu speichern.',
      run: 'Verbindung prüfen',
      running: 'Verbindung wird geprüft …',
      showDetails: 'Details für den Support anzeigen',
      hideDetails: 'Details für den Support ausblenden',
      status: { Ok: 'In Ordnung', Warning: 'Hinweis', Failed: 'Fehlgeschlagen', Skipped: 'Übersprungen' },
      unavailable: {
        Failed: 'Die Checkliste konnte nicht ausgeführt werden. Versuche es erneut.',
        NoFrozenSelection:
          'Noch keine festgehaltene Auswahl: Erst nach „Freigeben und Einrichtung prüfen“ gibt es etwas zu prüfen.',
        NoRuntimeCredential:
          'Der technische Zugang wurde noch nicht eingerichtet; die Einrichtung ist vorher gescheitert. Wiederhole „Einrichtung erneut prüfen“.',
        NotConfigured: 'Die Verbindungsprüfung ist in dieser Umgebung nicht verfügbar.',
        NoBinding: 'Für diesen Kunden ist Microsoft 365 für Abwesenheiten noch nicht verbunden.',
        MultipleIdentities:
          'Mehrere technische Identitäten sind gebunden; die Prüfung braucht eine Klärung durch den Betreiber.',
        Timeout: 'Microsoft hat nicht rechtzeitig geantwortet. Versuche es erneut.',
      },
      codes: {
        Unknown: 'Dieser Schritt konnte nicht abgeschlossen werden.',
        AbsenceInboxOk: 'Der Posteingang des Abwesenheitspostfachs ist mit dem technischen Zugang lesbar.',
        AbsenceEmployeesFileOk: '„Stammdaten/Mitarbeiter.xlsx“ wurde gelesen.',
        AbsenceEmployeesFileUnreadable: '„Stammdaten/Mitarbeiter.xlsx“ konnte nicht gelesen werden.',
        AbsenceJournalFileOk: '„Abwesenheit/Abwesenheiten.xlsx“ wurde gelesen.',
        AbsenceJournalFileUnreadable: '„Abwesenheit/Abwesenheiten.xlsx“ konnte nicht gelesen werden.',
        AbsencePlanFileOk: '„Abwesenheit/Ressourcenplan.xlsx“ wurde gelesen.',
        AbsencePlanFileUnreadable: '„Abwesenheit/Ressourcenplan.xlsx“ konnte nicht gelesen werden.',
        AbsenceJournalWriteOk: '„Abwesenheit/Abwesenheiten.xlsx“ wurde unverändert zurückgeschrieben.',
        AbsencePlanWriteOk: '„Abwesenheit/Ressourcenplan.xlsx“ wurde unverändert zurückgeschrieben.',
        WriteSkipped: 'Nicht geprüft, weil eine Datei zuvor nicht gelesen werden konnte.',
        CalendarReadOk: 'Der Kalender des Prüfpostfachs wurde gelesen.',
        CalendarReadSkipped: 'Kein Kalenderzugriff gewählt oder kein Prüfpostfach; nicht geprüft.',
        ExchangeRoleAssignmentDenied:
          'Das angemeldete Konto darf in Exchange keine Rollen zuweisen. Weise ihm zusätzlich zu Globaler Administrator die Entra-Rolle Exchange-Administrator zu (Entra Admin Center → Benutzer → Zugewiesene Rollen) und melde dich für die Einrichtung neu an — bestehende Anmeldungen übernehmen die Rolle nicht.',
        ExchangeConnectFailed:
          'Exchange hat die Anmeldung der Einrichtungs-App abgewiesen. Erteile die Administratorzustimmung (Entra → Unternehmensanwendungen → DAS Platform M365 Setup → Berechtigungen) und melde dich für die Einrichtung neu an.',
        ExchangePermissionPending:
          'Die Exchange-Berechtigung ist gesetzt, aber noch nicht wirksam. Microsoft benötigt dafür 30 Minuten bis zwei Stunden; wiederhole die Prüfung später mit derselben Auswahl.',
        ExchangeUnscopedAssignment:
          'In Exchange besteht eine organisationsweite Rollenzuweisung für den technischen Zugang. Das muss der Plattformbetreiber prüfen, bevor es weitergeht.',
        ExchangeReview:
          'In Exchange besteht bereits eine abweichende Berechtigung für dieses Postfach. Das muss der Plattformbetreiber prüfen.',
        ExchangeWrongDirectory:
          'Die Exchange-Anmeldung gehört zu einem anderen Microsoft-Verzeichnis als die Einrichtung. Melde dich mit dem Konto des Kundenverzeichnisses an.',
        ExchangeHostUnavailable:
          'Der Exchange-Dienst der Plattform ist momentan nicht erreichbar. Versuche es später erneut.',
        ExchangeVerifyFailed:
          'Die Exchange-Berechtigung konnte nicht nachgewiesen werden. Wiederhole die Prüfung; bleibt es dabei, kontaktiere den Plattformbetreiber.',
        LibraryNotInSite:
          'Die gewählte Bibliothek gehört nicht zur gewählten Site. Wähle Site und Bibliothek erneut.',
        MailboxNotFound: 'Das gewählte Postfach wurde in Exchange nicht gefunden. Wähle es erneut.',
        ProbeMailboxNotUser:
          'Das Postfach für die Zugriffsprüfung muss ein Benutzerpostfach sein, kein freigegebenes.',
        SetupBusy: 'Eine andere Einrichtung läuft gerade. Warte kurz und versuche es erneut.',
        SelectionChanged:
          'Die Auswahl weicht von der festgehaltenen ab. Wiederhole mit derselben Auswahl oder lass einen neuen Einrichtungslink erstellen.',
        CalendarCapabilityMissing:
          'Der Kalenderzugriff ist für diesen Kunden nicht freigeschaltet. Der Plattformbetreiber schaltet „Terminkonflikte erkennen“ frei, oder die Einrichtung läuft ohne Kalender.',
        CalendarOptionLocked:
          'Eine frühere Einrichtung hatte den Kalenderzugriff gewählt; er lässt sich nicht mehr abwählen. Schließe mit Kalenderzugriff ab oder lass die Berechtigung vom Plattformbetreiber zurücknehmen.',
        OtherLibraryGranted:
          'Eine frühere Einrichtung hat eine andere Bibliothek berechtigt. Wähle genau dieselben Bibliotheken — vertauschte Sites lassen sich tauschen — oder lass die Rechte vom Plattformbetreiber prüfen.',
        SolutionNotEntitled:
          'Die Lösung ist für diesen Kunden nicht freigeschaltet. Der Plattformbetreiber schaltet sie zuerst frei.',
      },
      details: {
        Missing: 'Die Datei liegt nicht an diesem Pfad.',
        RemoteItemSeen:
          'Die Datei verweist auf eine andere Bibliothek (Verknüpfung). Lege die Datei selbst in der gewählten Bibliothek ab oder binde die Bibliothek, auf die die Verknüpfung zeigt.',
        Forbidden:
          'Microsoft verweigert dem technischen Zugang den Zugriff auf diese Datei; ihre Berechtigungen weichen von der Bibliothek ab.',
        ContentByIdFailedPathSucceeded:
          'Die Datei ist über ihren Pfad lesbar, nicht über ihre ID — die Verarbeitung liest über die ID. Bitte die Support-Details weitergeben.',
        BothContentFormsFailed:
          'Die Datei antwortet weder über ihre ID noch über ihren Pfad, obwohl ihre Metadaten lesbar sind. Bislang beobachtete Ursache: Der Ordner der Datei trägt kein eigenes Recht für den technischen Zugang — ein Recht auf dem Wurzelordner der Bibliothek allein erreicht die Ordner darunter nicht. Wiederhole die Einrichtung mit derselben Auswahl: über denselben Link, solange er noch offen ist, sonst über einen neuen Link des Plattformbetreibers. Die Support-Details nennen den HTTP-Status und was ein direkter Abruf der Download-Adresse geantwortet hat.',
        Locked: 'Die Datei ist geöffnet oder gesperrt. Schließe sie und wiederhole die Prüfung.',
        Unreadable: 'Die Datei konnte nicht gelesen werden.',
        Pending: 'Die Berechtigung ist noch nicht wirksam; Microsoft benötigt 30 Minuten bis zwei Stunden.',
        Unknown: 'Die Ursache ist offen; die Support-Details helfen bei der Klärung.',
      },
    },
  },
  administration: {
    m365CheckUnavailable: 'Die Verbindungsprüfung ist in dieser Umgebung nicht verfügbar.',
    capExternalOrders: 'Aufträge nach außen übertragen',
    capReporting: 'Meldungen bearbeiten',
    issues: 'Meldungen',
    m365Title: 'Microsoft 365 für den Rechnungseingang',
    m365Description:
      'Hier kannst du bereits verbundene Postfächer und SharePoint-Bibliotheken prüfen und zuordnen.',
    m365Missing:
      'Microsoft 365 ist noch nicht verbunden. Erstelle oben einen Einrichtungslink; der Kundenadmin wählt Postfach und Ablage direkt bei Microsoft aus.',
    m365Mailbox: 'Rechnungspostfach',
    m365Inbox: 'Der Rechnungseingang liest den Posteingang dieses Postfachs.',
    m365Drive: 'SharePoint-Dokumentbibliothek für die Ablage',
    m365Start: 'Nachrichten bei der ersten Verarbeitung',
    m365NewOnly: 'Nur neue Nachrichten nach der Erstsynchronisation',
    m365FromDate: 'Nachrichten ab einem Datum',
    m365All: 'Alle vorhandenen Nachrichten',
    m365Date: 'Ab Datum (lokale Zeit)',
    m365DateRequired: 'Bitte ein gültiges Datum auswählen.',
    m365FullWarning: 'Beim späteren Start wird auch der gesamte vorhandene Posteingang verarbeitet.',
    m365PausedHint: 'Speichern bereitet den Rechnungseingang vor. Die Verarbeitung bleibt pausiert.',
    m365Save: 'Auswahl speichern',
    m365Saved: 'Die Auswahl wurde gespeichert. Der Rechnungseingang ist pausiert.',
    m365SaveError:
      'Die Auswahl konnte nicht gespeichert werden. Prüfe, ob Invoice Ingestion für diesen Kunden freigeschaltet ist.',
    m365Conflict:
      'Die bestehende Konfiguration lässt sich hier gerade nicht ändern. Lade die Kundenansicht neu; ein aktiver Eingang muss zuerst pausiert werden.',
    senderTitle: 'Rechnungsausgang: Absenderpostfächer',
    senderDescription:
      'Von diesen Postfächern werden ausgehende Rechnungen und Erinnerungen bei fehlenden Angaben per E-Mail versendet. Zur Auswahl stehen die Postfächer, die die Microsoft-365-Einrichtung dieses Kunden bereits verbunden hat; andere Verbindungen bleiben unverändert.',
    libraryTitle: 'Rechnungsausgang: Dokumentbibliothek',
    libraryDescription:
      'In dieser SharePoint-Bibliothek lässt der Rechnungsausgang Word- und Excel-Rechnungen als PDF rendern; die Datei liegt dort nur für die Umwandlung. Für den E-Mail-Versand wird sie nicht gebraucht. Verbunden wird sie nur über den Einrichtungslink: Der Microsoft-365-Admin des Kunden wählt sie selbst aus.',
    libraryName: 'Verbundene Bibliothek',
    libraryNone:
      'Noch ist keine Bibliothek für den Rechnungsausgang verbunden. Erstelle oben einen Einrichtungslink für den Microsoft-365-Admin des Kunden.',
    senderMailbox: 'Absenderpostfach für Rechnungen',
    senderReminderMailbox: 'Absenderpostfach für Erinnerungen',
    senderNotSent: 'Nicht versenden',
    senderCheck: 'Zugriff prüfen: {{purpose}}',
    senderNone:
      'Noch ist kein Absenderpostfach für Rechnungen gespeichert — Rechnungen können bis dahin nicht per E-Mail versendet werden.',
    senderReminderNone:
      'Noch ist kein Absenderpostfach für Erinnerungen gespeichert — fällige Erinnerungen werden bis dahin angezeigt, aber nicht versendet.',
    senderMissing:
      'Für diesen Kunden ist noch kein Postfach verbunden. Verbinde zuerst ein Postfach über den Einrichtungslink oben.',
    senderSave: 'Absenderpostfächer speichern',
    senderSaved: 'Die Absenderpostfächer wurden gespeichert.',
    senderSaveError:
      'Die Absenderpostfächer konnten nicht gespeichert werden. Prüfe, ob Invoice Outgoing für diesen Kunden freigeschaltet ist.',
    senderConflict:
      'Die Microsoft-365-Konfiguration hat sich inzwischen geändert. Lade die Kundenansicht neu und speichere erneut.',
    m365ProcessingTitle: 'Verarbeitung des Rechnungseingangs',
    m365ProcessingEnabled: 'Verarbeitung aktiv',
    m365ProcessingOn: 'Aktiv: Neue Verarbeitungsläufe für das gespeicherte Postfach sind freigegeben.',
    m365ProcessingOff:
      'Pausiert: Einschalten startet die Verarbeitung mit der oben gespeicherten Verbindung. Änderungen an der Auswahl unten zuerst speichern.',
    m365ProcessingNewOnly:
      'Beim ersten Start wird der vorhandene Posteingang übersprungen. Die Testrechnung erst nach abgeschlossener Erstsynchronisation senden.',
    m365ProcessingAll: 'Beim ersten Start werden auch bereits vorhandene Nachrichten verarbeitet.',
    m365ProcessingCutover:
      'Beim ersten Start werden Nachrichten ab dem gespeicherten Startdatum verarbeitet.',
    m365ProcessingPauseHint:
      'Ausschalten verhindert neue Abrufläufe. Bereits laufende oder angestoßene Verarbeitung kann noch enden. Beim erneuten Einschalten wird der gespeicherte Synchronisationsstand fortgesetzt.',
    m365ProcessingConflict:
      'Umschalten nicht bestätigt. Prüfe den aktuellen Verbindungsstand und ob „Rechnungseingang“ mit „Belege verarbeiten“ freigeschaltet ist.',
    m365ProcessingError:
      'Umschalten konnte nicht bestätigt werden. Prüfe den angezeigten Status und versuche es erneut.',
    m365Active: 'Der Rechnungseingang ist aktiv. Vor einer Änderung muss er pausiert werden.',
    m365Check: 'Zugriff prüfen',
    m365Checking: 'Zugriff wird geprüft …',
    m365Readable:
      'Der lesende Zugriff funktioniert. Ablage und Versand werden im anschließenden Rechnungstest geprüft.',
    m365Denied: 'Microsoft verweigert den Zugriff. Für diese Ressource fehlt eine wirksame Freigabe.',
    m365CredentialError: 'Die Anmeldung des eingerichteten Microsoft-365-Zugangs ist fehlgeschlagen.',
    m365ProbeError: 'Der Zugriff konnte nicht bestätigt werden. Prüfe die Verbindung und versuche es erneut.',
    m365Open: 'Ablage in SharePoint öffnen',
    absenceM365Title: 'Microsoft 365 für Abwesenheiten',
    absenceM365Description:
      'Hier siehst du die verbundenen Ressourcen der Abwesenheitslösung und schaltest die Verarbeitung frei.',
    absenceM365InviteTitle: 'Abwesenheiten: Einrichtung durch den Kundenadmin',
    absenceM365CreateLink: 'Einrichtungslink für Abwesenheiten erstellen',
    absenceM365Missing:
      'Microsoft 365 ist für Abwesenheiten noch nicht verbunden. Erstelle oben einen Einrichtungslink; der Kundenadmin wählt Postfach und Bibliotheken direkt bei Microsoft aus.',
    absenceM365Mailbox: 'Abwesenheitspostfach',
    absenceM365TeamLeadDrive: 'Bibliothek der Teamleitung',
    absenceM365EmployeeDrive: 'Bibliothek der Mitarbeitenden',
    absenceM365Calendar: 'Kalenderzugriff',
    absenceM365CalendarNone: 'Nicht eingerichtet',
    absenceM365CheckMailbox: 'Zugriff auf das Abwesenheitspostfach prüfen',
    absenceM365CheckTeamLead: 'Zugriff auf die Bibliothek der Teamleitung prüfen',
    absenceM365CheckEmployee: 'Zugriff auf die Bibliothek der Mitarbeitenden prüfen',
    absenceM365Readable: 'Zugriff bestätigt.',
    absenceM365Checklist: 'Checkliste prüfen',
    absenceM365Checking: 'Checkliste wird geprüft …',
    absenceM365ChecklistLabel: 'Zugriffs-Checkliste für Abwesenheiten prüfen',
    absenceM365ChecklistHint:
      'Prüft mit dem technischen Zugang des Kunden dieselben sieben Zugriffe wie die Einrichtung — lesen, unverändert zurückschreiben — und zeigt jede Zeile einzeln.',
    absenceM365ProcessingEnabled: 'Abwesenheiten verarbeiten',
    absenceM365ProcessingOn:
      'Abwesenheitsmeldungen werden verarbeitet: Journal und Ressourcenplan werden fortgeschrieben, Freigabe- und Ergebnismails versendet.',
    absenceM365ProcessingOff:
      'Die Verarbeitung ist pausiert. Eingehende Meldungen bleiben liegen und werden nach dem Einschalten ab dem gespeicherten Stand verarbeitet.',
    title: 'DAS Plattformverwaltung',
    operatorContext: 'Plattformbetreiber',
    customers: 'Kunden',
    users: 'Benutzer',
    person: 'Person',
    role: 'Rolle',
    overview: 'Übersicht',
    address: 'Tenant-Adresse',
    status: 'Status',
    search: 'Kunden suchen',
    login: 'Mit Microsoft anmelden',
    loginDescription: 'Melden Sie sich mit Ihrem Betreiberkonto an.',
    unavailable: 'Die Verwaltung ist momentan nicht erreichbar.',
    forbidden: 'Für diese Aktion fehlen die Betreiberrechte.',
    sessionExpired: 'Die Sitzung ist abgelaufen. Bitte erneut anmelden.',
    requestError:
      'Die Aktion konnte nicht bestätigt werden. Prüfen Sie den aktuellen Status und versuchen Sie es erneut.',
    createError: 'Anlage nicht bestätigt. Erneut versuchen setzt dieselbe Anlage fort.',
    partialCreation:
      'Der Kunde wurde angelegt. Einige Solutions konnten noch nicht freigeschaltet werden. Prüfen Sie die Schalter unten.',
    unknown: 'Nicht verfügbar',
    pending: 'Wartet auf Freigabe',
    processing: 'Wird eingerichtet',
    completed: 'Freigeschaltet',
    failed: 'Einrichtung fehlgeschlagen',
    rejected: 'Abgelehnt',
    ready: 'Bereit',
    suspended: 'Pausiert',
    enabled: 'Freigeschaltet',
    save: 'Speichern',
    retry: 'Einrichtung wiederholen',
    approve: 'Rolle freigeben',
    reject: 'Ablehnen',
    notFound: 'Eintrag nicht gefunden',
    notFoundDescription: 'Der Eintrag ist nicht mehr verfügbar.',
    firstAdminHint:
      'Der erste Admin meldet sich an dieser Tenant-Adresse an und fragt Zugang an. Unter Benutzer geben Sie seine Rolle frei.',
    usersHint:
      'Anfragen gehören bereits zum Tenant ihrer Anmeldedomäne. Sie vergeben nur Rolle und Freigabe.',
    noRequests: 'Noch keine Zugangsanfragen. Neue Benutzer melden sich an ihrer Tenant-Adresse an.',
    connectorHint:
      'Die Freischaltung aktiviert die gewählten Funktionen. Benötigte M365-Verbindungen werden separat eingerichtet.',
    roleDescription:
      'Das gewählte Profil ersetzt die bisherigen Benutzerrechte. Solution-Freischaltungen bleiben zusätzlich erforderlich.',
    membershipFailed:
      'Der Zugang konnte nicht eingerichtet werden. Der zentrale Admin kann den Auftrag erneut freigeben.',
    openWorkspace: 'Arbeitsbereich öffnen',
    profileAdmin: 'Tenant-Administrator',
    profileReader: 'Rechnungseingang lesen',
    profileAdminReader: 'Tenant-Administrator und Rechnungseingang',
    profileBilling: 'Rechnungsausgang bearbeiten',
    incoming: 'Rechnungseingang',
    outgoing: 'Rechnungsausgang',
    funding: 'Förder-Radar',
    absence: 'Abwesenheiten',
    capIngestion: 'Belege verarbeiten',
    capReports: 'Auswertungen',
    capEInvoice: 'E-Rechnung',
    capScan: 'Förderprogramme suchen',
    capRecording: 'Abwesenheiten erfassen',
    capCalendar: 'Urlaub als Kalendereinladung',
    capConflicts: 'Terminkonflikte erkennen',
    capDecidaloProjection: 'Abwesenheiten an decídalo übertragen',
    capDecidaloProjectionHint:
      'Überträgt verifizierte Abwesenheiten an den gebundenen decídalo-Mandanten des Kunden. ' +
      'Wirkt nur mit aktiver decídalo-Verbindung und ab dem nächsten relevanten Mail-Ereignis; ' +
      'vorhandene Abwesenheiten werden nicht nachträglich übertragen.',
    capabilityHint: 'Was diese Fähigkeit vergibt',
    capConflictsHint:
      'Voraussetzung für den Kalenderzugriff: Die Einrichtung darf danach ein Leserecht auf die ' +
      'Kalender aller Benutzerpostfächer des Kundenverzeichnisses anfordern. Ohne diese ' +
      'Fähigkeit weist sie die Kalenderoption ab.',
    capCalendarHint:
      'Genehmigter Urlaub geht vom Absender-Postfach als ganztägige Abwesend-Einladung an die ' +
      'Person. Dafür braucht die Plattform ein Kalender-Schreibrecht auf genau diesem Postfach, ' +
      'das von Hand vergeben wird. Abschalten wirkt ab der nächsten Genehmigung; versandte ' +
      'Einladungen bleiben bestehen.',
    capAutomaticReplies: 'Abwesenheitsnotiz bei Urlaub',
    capAutomaticRepliesHint:
      'Genehmigter Urlaub setzt zusätzlich die Outlook-Abwesenheitsnotiz im Postfach der Person, ' +
      'mit einem festen neutralen Text. Dafür braucht die Plattform ein Schreibrecht auf die ' +
      'Postfacheinstellungen der Mitglieder einer vom Kunden gepflegten Gruppe, das von Hand ' +
      'vergeben wird. Von Hand geänderte Notizen bleiben unangetastet.',
    capBilling: 'Rechnungen erstellen',
    capPlatformAi: 'KI-Modell der Plattform',
    capPlatformAiHint:
      'Kostenentscheidung: Der Arbeitsbereich darf danach das Anthropic-Modell der Plattform fuer den ' +
      'Rechnungsimport einschalten. Die Modellaufrufe laufen ueber den Anthropic-Vertrag der Plattform, ' +
      'auf ihre Rechnung und unter ihrer Auftragsverarbeitung. Ohne diese Faehigkeit bleibt dem ' +
      'Arbeitsbereich nur eine eigene Azure-OpenAI-Ressource.',
    createCustomer: 'Kunden anlegen',
    createDescription: 'Der Arbeitsbereich wird automatisch eingerichtet.',
    creating: 'Wird angelegt …',
    customerName: 'Kundenname',
    nameRequired: 'Bitte einen Kundennamen mit höchstens 200 Zeichen eingeben.',
    solutions: 'Solutions',
    solutionsDescription: 'Verbindungen werden gesondert eingerichtet. Freischaltungen bleiben änderbar.',
    requestAccess: 'Zugang anfragen',
    requestDescription: 'Ein Administrator prüft Ihren Zugang und vergibt Ihre Rolle.',
    signedInAs: 'Angemeldet als {{name}}',
    requestedTenant: 'Zugang für {{tenant}}',
    requestSending: 'Anfrage wird gesendet …',
    requestPending: 'Ihre Anfrage ist eingegangen und wartet auf Freigabe.',
    requestProcessing: 'Ihre Anfrage wurde freigegeben. Der Zugang wird jetzt eingerichtet.',
    requestApproved: 'Ihr Zugang wurde eingerichtet.',
    requestRejected: 'Ihre Anfrage wurde abgelehnt. Wenden Sie sich zur Klärung an Ihren Ansprechpartner.',
  },
  access: {
    bindingMismatchDescription:
      'Der Arbeitsbereich ist technisch nicht korrekt eingerichtet. Ihre Daten wurden nicht verändert.',
    bindingMismatchTitle: 'Arbeitsbereich momentan nicht erreichbar',
    identityHint: 'Für den Support: Ihre Anmeldung',
    noAccessDescription: 'Ihr Konto ist für diesen Arbeitsbereich nicht freigeschaltet.',
    noAccessTitle: 'Kein Zugang zu diesem Arbeitsbereich',
    noModulesDescription:
      'Ihr Konto gehört zu diesem Arbeitsbereich, aber es ist noch kein Modul für Sie freigeschaltet.',
    noModulesTitle: 'Noch nichts freigeschaltet',
    notReadyDescription:
      'Der Arbeitsbereich wird gerade eingerichtet oder ist pausiert. Bitte versuchen Sie es später erneut.',
    notReadyTitle: 'Arbeitsbereich noch nicht bereit',
    unknownHostDescription: 'Unter dieser Adresse gibt es keinen Arbeitsbereich. Prüfen Sie den Link.',
    unknownHostTitle: 'Arbeitsbereich nicht gefunden',
    workspaces: 'Zu Ihren Arbeitsbereichen',
  },
  auth: {
    errorBindingDescription:
      'Die Anmeldung wurde in einem anderen Browser oder Tab begonnen und kann hier nicht abgeschlossen werden. Starten Sie die Anmeldung erneut.',
    errorExpiredDescription:
      'Die Anmeldung hat zu lange gedauert oder wurde bereits verwendet. Starten Sie sie erneut.',
    errorProviderDescription:
      'Der Anmeldedienst hat die Anmeldung nicht abgeschlossen. Versuchen Sie es erneut oder wenden Sie sich an den Support.',
    errorTitle: 'Anmeldung nicht abgeschlossen',
    redirecting: 'Sie werden zur Anmeldung weitergeleitet',
    retry: 'Erneut anmelden',
    sessionExpiredDescription: 'Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an.',
    sessionExpiredTitle: 'Erneute Anmeldung erforderlich',
    signIn: 'Anmelden',
    signOut: 'Abmelden',
    signOutFailed: 'Abmelden ist fehlgeschlagen. Sie sind weiterhin angemeldet – versuchen Sie es erneut.',
    signedOutDescription:
      'Sie sind abgemeldet. Schließen Sie den Tab oder melden Sie sich erneut an, um weiterzuarbeiten.',
    signedOutTitle: 'Abgemeldet',
  },
  bootstrap: {
    loading: 'Arbeitsbereich wird vorbereitet',
    retry: 'Erneut versuchen',
    unavailableDescription:
      'Der Arbeitsbereich kann momentan nicht geladen werden. Ihre Daten wurden nicht verändert.',
    unavailableTitle: 'Arbeitsbereich momentan nicht erreichbar',
  },
  common: {
    cancel: 'Abbrechen',
    clear: 'Zurücksetzen',
    comboClose: 'Liste schließen',
    resizeColumn: 'Breite der Spalte {{column}} ändern',
    comboNoOptions: 'Kein Treffer',
    comboOpen: 'Liste öffnen',
    loading: 'Ansicht wird geladen',
    productEyebrow: 'Arbeitsbereich',
    refresh: 'Aktualisieren',
    save: 'Speichern',
    supportId: 'Support-Kennung',
    unsupportedScreenDescription:
      'DAS Web ist für Desktop und Tablet ausgelegt. Öffnen Sie den Arbeitsbereich auf einem größeren Bildschirm.',
    unsupportedScreenTitle: 'Bildschirm zu klein',
  },
  entry: {
    chooseDescription: 'Sie sind mehreren Arbeitsbereichen zugeordnet. Wählen Sie einen aus.',
    chooseTitle: 'Arbeitsbereich wählen',
    noWorkspaceDescription:
      'Ihrer Anmeldung ist noch kein Arbeitsbereich zugeordnet. Bitten Sie Ihren Ansprechpartner um die Freischaltung.',
    noWorkspaceTitle: 'Kein Arbeitsbereich zugeordnet',
    openWorkspace: 'Arbeitsbereich {{name}} öffnen',
    signInDescription: 'Melden Sie sich an, um Ihre Arbeitsbereiche zu sehen.',
    signInTitle: 'Willkommen bei DAS Web',
    workspaceList: 'Ihre Arbeitsbereiche',
  },
  fundingRadar: {
    actions: 'Aktionen',
    backToList: 'Zum Förder-Bestand',
    backToProfiles: 'Zurück',
    createSearchAction: 'Erweiterte Suche',
    currentRound: 'Aktuelle Runde',
    deadline: 'Frist',
    deadlineExpected: 'voraussichtlich',
    deadlineExpectedFrom: 'voraussichtlich ab {{date}}',
    deadlineExpectedWithText: 'voraussichtlich ({{text}})',
    deadlineRolling: 'laufend',
    deadlineUnknown: 'unbekannt',
    detailTitle: 'Förderprogramm',
    editProfile: 'Gespeicherte Suche bearbeiten',
    emptyDescription:
      'Dieser Bestand füllt sich durch einen vollständigen Suchlauf über alle gespeicherten Suchen. Der Lauf dauert einige Minuten, verursacht Recherchekosten und läuft höchstens einmal täglich; vorhandene Einträge werden dabei nur aktualisiert, nie gelöscht.',
    emptyFilteredDescription:
      'Im gespeicherten Bestand gibt es dazu nichts. Sie können live im Web weitersuchen oder die Filter zurücksetzen, um den gesamten Bestand zu sehen.',
    emptyFilteredReset: 'Filter zurücksetzen',
    emptyFilteredTitle: 'Keine Programme mit diesen Filtern',
    emptyNoPermissionDescription:
      'Dieser Bestand füllt sich durch einen vollständigen Suchlauf über alle gespeicherten Suchen. Ihnen fehlt die Berechtigung, einen Suchlauf zu starten.',
    emptyProfileDescription:
      'Diese gespeicherte Suche hat bisher nichts gefunden. Sie läuft beim nächsten vollständigen Suchlauf wieder mit; passen Sie Thema oder Regionen an, wenn Sie andere Treffer erwarten.',
    emptyProfileTitle: 'Noch keine Treffer für diese Suche',
    emptyTitle: 'Der letzte Suchlauf hat keine Förderprogramme gefunden',
    firstSeen: 'Erstmals gesehen',
    fundingAmount: 'Fördersumme',
    lastSeen: 'Zuletzt gesehen',
    listTitle: 'Förder-Radar',
    emptyNoProfileRightDescription:
      'Dieser Bestand füllt sich durch gespeicherte Suchen. Sie dürfen selbst live im Web suchen, aber in diesem Arbeitsbereich keine gespeicherten Suchen anlegen — die erste Suche muss jemand mit dieser Berechtigung einrichten.',
    profileRunsWeekly: 'Läuft wöchentlich mit',
    profileRunsWeeklyDescription:
      'Nimmt diese Suche am wöchentlichen Suchlauf teil? Ausgeschaltet bleibt sie im Bestand und lässt sich jederzeit einzeln erneut ausführen, verursacht aber keine wiederkehrenden Recherchekosten. Die automatisch angelegte Startsuche beginnt ausgeschaltet.',
    profileRunsWeeklyOff: 'Nur auf Zuruf',
    starterAdopting: 'Ergebnis wird in Ihre erste gespeicherte Suche übernommen …',
    starterEmptyDescription:
      'Die automatische Erstsuche hat nichts Passendes gefunden. Starten Sie eine eigene Suche mit einem genaueren Thema und passenden Regionen — daraus wird auf Wunsch eine gespeicherte Suche, die künftig mitläuft.',
    starterFailedDescription:
      'Die automatische Erstsuche konnte nicht abgeschlossen werden. Sie können jederzeit selbst eine Suche starten.',
    starterFailedTitle: 'Die erste Suche ist fehlgeschlagen',
    starterForbiddenDescription:
      'Die automatische Erstsuche wurde abgelehnt. Ihnen fehlt eine der dafür nötigen Berechtigungen.',
    starterIntro:
      'Ihr Bestand ist noch leer, deshalb läuft gerade automatisch eine erste, schnelle Suche. Ihr Ergebnis wird als Ihre erste gespeicherte Suche abgelegt — sie läuft zunächst nicht wöchentlich mit, das schalten Sie bei Bedarf selbst ein.',
    starterOwnSearchAction: 'Eigene Suche starten',
    starterMeanwhileHint:
      'Sie müssen nicht warten: Der Lauf läuft weiter, auch wenn Sie diese Seite verlassen oder schließen. Sie können währenddessen etwas anderes suchen.',
    liveSearchAction: 'Live nach „{{term}}“ suchen',
    liveSearchOffer:
      'Nichts Passendes dabei? Sie können live im Web nach „{{term}}“ suchen. Das dauert bis zu mehrere Minuten, und die Ergebnisse werden nicht in diesem Bestand gespeichert.',
    metaNeverScanned: 'Noch kein Suchlauf ausgeführt',
    metaProfiles_one: '{{count}} aktive gespeicherte Suche',
    metaProfiles_other: '{{count}} aktive gespeicherte Suchen',
    metaLastScan: 'Letzter Suchlauf: {{dateTime}}',
    loadErrorDescription: 'Die Daten konnten nicht geladen werden. Ihre Daten wurden nicht verändert.',
    loadErrorTitle: 'Förder-Radar momentan nicht erreichbar',
    filterLabel: 'Suchen',
    filters: 'Filter',
    filterPlaceholder: 'Programm, Träger oder Region',
    manageProfiles: 'Gespeicherte Suchen',
    moreActions: 'Weitere Aktionen',
    neverNotified: 'Noch nie gemeldet',
    newBadge: 'Neu',
    newBadgeTitle: 'Erstmals im letzten Suchlauf gefunden',
    newProfile: 'Gespeicherte Suche anlegen',
    notFoundDescription: 'Dieses Förderprogramm gibt es nicht oder es gehört nicht zu diesem Arbeitsbereich.',
    notFoundTitle: 'Förderprogramm nicht gefunden',
    notificationNeverReported: '{{profileName}}: noch nie gemeldet',
    notificationReportedSince: '{{profileName}}: erstmals gemeldet am {{date}}',
    notificationsTitle: 'Benachrichtigungen',
    notifiedSince: 'Erstmals gemeldet am {{date}}',
    pastRound: 'Frühere Runde ({{date}})',
    profileAddRecipient: 'Empfänger hinzufügen',
    profileAddRegion: 'Region hinzufügen',
    profileActive: 'Aktiv',
    profileCreate: 'Gespeicherte Suche anlegen',
    profileForbiddenDescription: 'Sie dürfen in diesem Arbeitsbereich keine gespeicherten Suchen verwalten.',
    profileLastRun: 'Letzter Durchlauf',
    profileLastRunNever: 'Noch nie',
    profileName: 'Name der Suche',
    profileNameRequired: 'Bitte geben Sie einen Namen für die Suche ein (höchstens {{max}} Zeichen).',
    profileNotFoundDescription:
      'Diese gespeicherte Suche gibt es nicht oder sie gehört nicht zu diesem Arbeitsbereich.',
    profileNotFoundTitle: 'Gespeicherte Suche nicht gefunden',
    profilePauseDescription:
      'Eine pausierte Suche läuft im nächsten Suchlauf nicht mit; Funde und Historie bleiben erhalten.',
    profilePaused: 'Pausiert',
    profileRecipientAdd: 'E-Mail-Adresse',
    profileRecipientDuplicate: 'Diese E-Mail-Adresse ist bereits in der Liste.',
    profileRecipientInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    profileRecipientsEmpty:
      'Noch keine Empfänger hinterlegt — der Bestand wird trotzdem aufgebaut. Empfänger später hinzufügen, um den Mailversand einzuschalten.',
    profileRegionAdd: 'Region',
    profileRegionDuplicate: 'Diese Region ist bereits in der Liste.',
    profileRegionTooLong: 'Eine Region darf höchstens {{max}} Zeichen lang sein.',
    profileRegionsEmpty: 'Noch keine Regionen hinterlegt.',
    profileRemoveRecipient: '{{value}} entfernen',
    profileRemoveRegion: '{{value}} entfernen',
    profileRunAction: 'Ausführen',
    profileRunAriaLabel: '„{{name}}“ ausführen',
    profileRunFailed:
      '„{{name}}“ konnte nicht ausgeführt werden. Recherche oder E-Mail-Versand sind fehlgeschlagen.',
    profileRunning: 'Wird ausgeführt …',
    profileRunSuccess:
      '„{{name}}“ wurde ausgeführt: {{new}} neue(r) Fund(e), {{mailsSent}} E-Mail(s) versendet.',
    profileSaveErrorDescription: 'Die Suche konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    profileSaveErrorTitle: 'Speichern nicht möglich',
    profileSaved: 'Die Suche wurde gespeichert.',
    profileSaving: 'Wird gespeichert',
    profileStatus: 'Status',
    profileTopic: 'Verein, Website oder Thema',
    profileTopicRequired: 'Bitte geben Sie ein Thema ein (höchstens {{max}} Zeichen).',
    profilesEmptyDescription: 'Legen Sie die erste gespeicherte Suche für diesen Arbeitsbereich an.',
    profilesEmptyTitle: 'Noch keine gespeicherten Suchen',
    profilesListTitle: 'Gespeicherte Suchen',
    profilesTable: 'Gespeicherte Suchen',
    programName: 'Programm',
    programPage: 'Programmseite',
    region: 'Region',
    rerunSavedSearch: 'Diese Suche neu ausführen',
    rerunSavedSearchShort: 'Neu ausführen',
    repeat: 'Wiederholung',
    repeatAnnounced: 'Neuauflage angekündigt',
    repeatAnnouncedWithDate: 'Neuauflage angekündigt für {{date}}',
    repeatDerivedAnnual: 'Aus eigener Beobachtung bisher jährlich ({{rounds}} Runden)',
    repeatDerivedIrregular: 'Aus eigener Beobachtung bisher unregelmäßig ({{rounds}} Runden)',
    repeatEvidence: 'Beleg zur Ankündigung',
    repeatNone: 'Keine Wiederholung bekannt',
    // The worklist's merged status-and-deadline sentence (one column instead of two near-duplicates).
    outlookDeadlinePassed: 'Frist abgelaufen',
    outlookDeadlinePassedWithDate: 'Frist abgelaufen ({{date}})',
    outlookOpenExpected: 'Offen, Frist {{expected}}',
    outlookOpenRolling: 'Offen, laufende Antragstellung',
    outlookOpenUntil: 'Offen bis {{date}}',
    outlookUnclear: 'Frist unklar',
    scanErrorDescription: 'Der Scan konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
    scanErrorTitle: 'Scan fehlgeschlagen',
    scanForbiddenDescription: 'Sie dürfen in diesem Arbeitsbereich keinen Scan auslösen.',
    scanAlreadyRanToday:
      'Heute ist bereits ein Suchlauf gelaufen — es wurde nichts erneut recherchiert. Der nächste läuft morgen.',
    scanNoProfiles: 'Der Scan wurde ausgeführt, aber es gibt noch keine aktive gespeicherte Suche.',
    scanNow: 'Alle gespeicherten Suchen durchsuchen',
    scanNowDescription:
      'Durchsucht alle gespeicherten Suchen und ergänzt den Bestand. Vorhandene Einträge werden nur aktualisiert, nie gelöscht. Dauert einige Minuten und läuft höchstens einmal täglich.',
    scanProfileErrors: '{{count}} gespeicherte Suche(n) konnten nicht ausgeführt werden.',
    scanRunning: 'Scan läuft…',
    scanSuccess: 'Scan abgeschlossen: {{new}} neue(r) Fund(e), {{mailsSent}} E-Mail(s) versendet.',
    searchBackToList: 'Zum Förder-Bestand',
    searchDiscardedNotice: '{{count}} Ergebnis(se) wurden verworfen (keine lesbare Frist).',
    searchTopicDefault: 'Vereins- und Ehrenamtsförderung',
    searchEmptyDescription:
      'Es wurden keine passenden Programme gefunden. Versuchen Sie einen anderen Verein, eine andere Website oder ein anderes Thema.',
    searchEmptyTitle: 'Keine Ergebnisse',
    searchErrorDescription: 'Die Suche konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    searchErrorTitle: 'Suche fehlgeschlagen',
    searchForbiddenDescription: 'Sie dürfen in diesem Arbeitsbereich nicht suchen.',
    searchNameLabel: 'Name der Suche (optional)',
    searchNamePlaceholder: 'Leer lassen — dann wird das Thema als Name verwendet',
    searchNotSavedHint:
      'Ergebnisse dieser Suche werden nicht gespeichert. Was Sie dauerhaft beobachten wollen, legen Sie als gespeicherte Suche an.',
    searchJobGone: 'Diese Suche ist nicht mehr verfügbar. Starten Sie sie unten neu.',
    searchKeepsRunningHint:
      'Sie können diese Seite verlassen; die Suche läuft weiter und ist über diesen Link wieder abrufbar.',
    searchPending: 'Suche läuft…',
    searchComposing: 'Websuche fertig — die Antwort wird zusammengestellt …',
    searchRegionsEmpty: 'Keine Region angegeben — es wird ohne regionale Einschränkung gesucht.',
    searchRun: 'Suchen',
    searchSave: 'Suche speichern',
    searchScope: 'Umfang',
    searchScopeExtensive: 'Umfangreich — mehrere Minuten, nutzt das volle Suchbudget dieses Arbeitsbereichs',
    searchScopeQuick: 'Schnell — eine Websuche, meist ein bis zwei Minuten',
    searchProgress: 'Websuche {{started}} von bis zu {{max}} gestartet, {{completed}} abgeschlossen …',
    searchResultsTable: 'Suchergebnisse',
    searchTitle: 'Förderprogramme finden',
    searchTopicLabel: 'Verein, Website oder Thema',
    searchTopicPlaceholder: 'z. B. TSV Musterstadt oder www.tsv-musterstadt.example',
    searchTopicRequired:
      'Bitte geben Sie einen Verein, eine Website oder ein Thema ein (höchstens {{max}} Zeichen).',
    sponsor: 'Träger',
    status: 'Status',
    statusAll: 'Alle Status',
    statusDeadlinePassed: 'Frist abgelaufen',
    statusOpen: 'Offen',
    statusRepeatAnnounced: 'Neuauflage angekündigt',
    statusUnclear: 'Unklar',
    summary: 'Zusammenfassung',
    summaryText: 'Kurzbeschreibung',
    table: 'Förderprogramme',
  },
  company: {
    title: 'Firmendaten',
    identity: 'Eigener Betrieb',
    intro:
      'Diese Angaben gelten für beide Richtungen: Die Rechnungsprüfung vergleicht den Rechnungsempfänger eingehender Rechnungen damit, und jede ausgehende Rechnung nennt den Betrieb als Aussteller. Trage den eigenen Betrieb ein, nicht einen Lieferanten oder Kunden.',
    payment: 'Bankverbindung und Zahlungsziel',
    iban: 'IBAN',
    bic: 'BIC (optional)',
    paymentTerm: 'Zahlungsziel in Tagen',
    saved: 'Die Firmendaten wurden gespeichert.',
    forbidden:
      'Für die Firmendaten brauchst du Tenant-Adminrechte und eine aktivierte Lösung für Eingangs- oder Ausgangsrechnungen.',
    loadError: 'Die Firmendaten konnten nicht geladen werden. Versuche es erneut.',
    saveError:
      'Die Firmendaten konnten nicht gespeichert werden. Prüfe die Verbindung und versuche es erneut.',
    invalid:
      'Prüfe die Firmendaten: Der Ländercode besteht aus zwei Buchstaben (z. B. DE), die USt-IdNr. beginnt mit dem Länderkürzel, die BIC hat 8 oder 11 Zeichen.',
    invalidTerm: 'Gib das Zahlungsziel als ganze Zahl zwischen 0 und 365 Tagen an.',
    conflict:
      'Die Firmendaten wurden inzwischen geändert. Lade den aktuellen Stand, bevor du erneut speicherst.',
  },
  invoiceSettings: {
    eInvoiceUnavailable: 'ERechnung ist nicht freigeschaltet.',
    automaticStoredUnavailable:
      'Gespeichert aktiv, derzeit nicht verfügbar: ERechnung ist nicht freigeschaltet. Die Empfängeradresse bleibt erforderlich.',
    automaticUnavailable: 'Nicht verfügbar',
    back: 'Zurück',
    editCompany: 'Firmendaten verwalten',

    title: 'Rechnungseinstellungen',
    help: 'Hilfe: {{section}}',
    recipient: 'E-Mail-Adresse für die Weiterleitung',
    forwardingHint:
      'Nach dem Aktivieren und Speichern werden neu verarbeitete, geeignete Rechnungen aus dem angebundenen Postfach weitergeleitet. Kopien stehen unter „Gesendete Elemente“. Frühere Rechnungen werden nicht nachträglich versendet. Ausschalten stoppt weder bereits vorgemerkte Sendungen noch den E-Mail-Import.',
    delivery: 'Weiterleitung an die Buchhaltung',
    automatic: 'Automatischer Versand',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    saved: 'Die Rechnungseinstellungen wurden gespeichert.',
    forbidden:
      'Für diese Einstellungen brauchst du Tenant-Adminrechte und die aktivierte Lösung Eingangsrechnungen.',
    loadError: 'Die Rechnungseinstellungen konnten nicht geladen werden. Versuche es erneut.',
    saveError:
      'Die Einstellungen konnten nicht gespeichert werden. Prüfe die Verbindung und versuche es erneut.',
    invalid: 'Prüfe die E-Mail-Adresse.',
    invalidRecipient:
      'Gib eine einzelne gültige E-Mail-Adresse ein. Bei aktivem Versand ist sie erforderlich.',
    conflict:
      'Die Einstellungen wurden inzwischen geändert. Lade den aktuellen Stand, bevor du erneut speicherst.',
    checkMode: 'Empfängerprüfung',
    checkExact: 'Genau',
    checkTolerant: 'Leichte Abweichungen',
    checkDisabled: 'Ausgeschaltet',
    saveEffect: 'Gilt für künftig geprüfte Rechnungen. Bestehende Rechnungen bleiben unverändert.',
    checkStatus: {
      off: 'Empfängerprüfung ausgeschaltet – der Rechnungsempfänger wird nicht geprüft',
      missingName: 'Firmenname fehlt – Prüfung nicht möglich',
      missingExactAddress: 'Anschrift unvollständig – Prüfung führt zu offenen Punkten',
      nameOnly: 'Anschrift unvollständig – nur Namensprüfung',
      complete: 'Firmendaten vollständig – Name und Anschrift werden geprüft',
    },
    checkModeHint:
      'Genau: Firmenname und vollständige Anschrift müssen übereinstimmen. Groß-/Kleinschreibung und Leerzeichen werden ignoriert.\n\nLeichte Abweichungen: Übliche Abkürzungen sind erlaubt. Ohne hinterlegte Anschrift wird nur der Firmenname geprüft.\n\nAusgeschaltet: Der Rechnungsempfänger wird nicht geprüft. Rechnungen an andere Firmen werden verarbeitet und bei aktivem Versand weitergeleitet.',
    buyerVatId: 'USt-IdNr. (optional)',
    buyerName: 'Firmenname',
    buyerStreet: 'Straße und Hausnummer',
    buyerPostcode: 'Postleitzahl',
    buyerCity: 'Ort',
    buyerCountry: 'Ländercode (z. B. DE)',
  },
  issues: {
    filterQueryTooLong:
      'Die Suche in der Adresse ist länger als {{max}} Zeichen und wird so nicht angenommen. Setzen Sie die Filter zurück oder kürzen Sie die Suche.',
    filterCategoryTooLong:
      'Die Kategorie in der Adresse ist länger als {{max}} Zeichen und wird so nicht angenommen. Setzen Sie die Filter zurück.',
    actionConfirmTitle: 'Schritt ausführen?',
    actionFailed: 'Der Schritt konnte nicht ausgeführt werden. Die Meldung ist unverändert.',
    actionReasonLabel: 'Grund',
    actionReasonRequired: 'Dieser Schritt braucht einen Grund.',
    actions: 'Aktionen',
    actionsNone: 'Für Sie ist an dieser Meldung gerade nichts zu tun.',
    actionsSection: 'Nächste Schritte',
    answerAction: 'Dem Melder antworten',
    answerDescription: 'Diese Antwort liest der Melder.',
    answerFromHouse: 'Antwort an den Melder',
    answerFromReporter: 'Vom Melder',
    answerLabel: 'Antwort',
    answerTitle: 'Dem Melder antworten?',
    answersEmpty: 'Dem Melder wurde noch nichts geschrieben.',
    answersHint: 'Nur dieser Faden erreicht den Melder; Kommentare am Auftrag bleiben im Haus.',
    answersSection: 'Faden zum Melder',
    backToList: 'Zu den Meldungen',
    category: 'Kategorie',
    categoryLoadErrorDescription:
      'Die Kategorien dieses Arbeitsbereichs konnten nicht geladen werden, deshalb ist das Erfassen gerade nicht möglich. Versuchen Sie es später erneut.',
    categoryLoadErrorTitle: 'Kategorien nicht verfügbar',
    categoryRetiredDescription:
      'Die gewählte Kategorie wird nicht mehr verwendet. Wählen Sie eine andere Kategorie und speichern Sie erneut.',
    categoryRetiredTitle: 'Kategorie nicht mehr verfügbar',
    create: 'Meldung erfassen',
    createForbiddenDescription:
      'Ihr Konto darf in diesem Arbeitsbereich keine Meldungen erfassen. Bitten Sie Ihren Ansprechpartner um die Freischaltung.',
    createForbiddenTitle: 'Erfassen nicht möglich',
    createTitle: 'Neue Meldung',
    created: 'Die Meldung wurde erfasst.',
    createdAt: 'Gemeldet am',
    detailTitle: 'Meldung',
    duplicateActions: 'Aktionen',
    duplicateCandidates: 'Dublettenkandidaten',
    duplicateCheck: 'Auf Dubletten prüfen',
    duplicateFailed: 'Die Verknüpfung konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
    duplicateLoadError: 'Die Kandidaten konnten nicht geladen werden.',
    duplicateMark: 'Als Dublette verknüpfen',
    duplicateMarkDescription:
      'Diese Meldung wird als Dublette von „{{title}}“ geführt und nimmt danach keine Aufträge mehr an.',
    duplicateMarkFor: 'Als Dublette von „{{title}}“ verknüpfen',
    duplicateMarkTitle: 'Als Dublette verknüpfen?',
    duplicateNoCandidates:
      'Keine offene Meldung derselben Kategorie aus den letzten vierzehn Tagen kommt infrage.',
    duplicateNoOrders:
      'Solange die Verknüpfung besteht, nimmt diese Meldung keine Aufträge an — die Arbeit gehört an die verknüpfte Meldung.',
    duplicateNone: 'Diese Meldung ist keine Dublette.',
    duplicateOf: 'Ist Dublette von Meldung',
    duplicateProximity: 'Ortsnähe',
    duplicateSection: 'Dublette',
    duplicateTruncated:
      'Es gibt mehr Kandidaten als hier gezeigt; die älteren fehlen. Ortsnähe kürzt die Liste nie.',
    duplicateUnmark: 'Verknüpfung aufheben',
    duplicateUnmarkDescription:
      'Die Verknüpfung wird entfernt. Diese Meldung nimmt danach wieder Aufträge an.',
    duplicateUnmarkTitle: 'Verknüpfung aufheben?',
    emptyDescription: 'Hier erscheinen die Meldungen, die Sie sehen dürfen. Bisher ist keine dabei.',
    emptyFilteredDescription: 'Ändern Sie den Suchbegriff oder die Filter, um mehr Meldungen zu sehen.',
    emptyFilteredTitle: 'Keine Meldung passt zu dieser Suche',
    emptyTitle: 'Noch keine Meldungen',
    eventAnswer: 'Antwort',
    eventComment: 'Kommentar',
    eventEscalated: 'Eskaliert',
    eventOrdered: 'Auftrag',
    eventRouted: 'Zugeordnet',
    eventStatusChanged: 'Statuswechsel',
    explanationAnswered: 'Die Antwort ist beim Melder. Der Abschluss erfolgt von Hand.',
    explanationClosed: 'Der Fall ist abgeschlossen. Hier ist nichts mehr zu tun.',
    explanationDeferred: 'Der Fall ist zurückgestellt. Er bewegt sich erst, wenn ihn jemand wieder aufnimmt.',
    explanationDone: 'Die Arbeit ist erledigt. Die Antwort an den Melder erfolgt von Hand.',
    explanationDuplicate: 'Der Fall ist als Dublette verknüpft. Bearbeitet wird der andere Fall.',
    explanationInProgress: 'Der Auftrag wird bearbeitet. Der Abschluss wird von Hand eingetragen.',
    explanationInReview: 'Der Fall wird geprüft. Die Freigabe erfolgt von Hand.',
    explanationOrdered: 'Der Auftrag ist erteilt. Die Bearbeitung wird von Hand eingetragen.',
    explanationReceived:
      'Die Meldung ist eingegangen und wartet auf Bearbeitung. Für Sie ist hier derzeit nichts zu tun.',
    explanationRejected: 'Der Fall ist abgelehnt. Der Grund steht oben.',
    explanationReleased: 'Der Fall ist freigegeben und wartet darauf, dass ihn jemand übernimmt.',
    explanationTaken: 'Der Fall ist übernommen. Der Auftrag wird von Hand erteilt.',
    explanationUnknown:
      'Der Zustand dieses Falls ist dieser Oberfläche nicht bekannt. Bitte melden Sie das Ihrem Ansprechpartner.',
    filterCategory: 'Kategorie',
    filterCategoryAll: 'Alle Kategorien',
    filterReset: 'Filter zurücksetzen',
    filterStatus: 'Status',
    filterStatusAll: 'Alle Status',
    filterStatusUnknown:
      'Der Status „{{status}}“ aus dem Link ist unbekannt und wurde nicht angewendet. Die Liste ist deshalb ungefiltert.',
    filterText: 'Suche',
    filterTextPlaceholder: 'Titel, Ort oder Beschreibung',
    filters: 'Filter',
    forbiddenDescription:
      'Ihr Konto ist für die Meldungen dieses Arbeitsbereichs nicht freigeschaltet. Bitten Sie Ihren Ansprechpartner um die Freischaltung.',
    forbiddenTitle: 'Kein Zugriff auf Meldungen',
    freeText: 'Beschreibung',
    freeTextOptional: 'Beschreibung (optional)',
    historyEmpty: 'Noch keine Einträge — der Fall hat sich seit dem Eingang nicht bewegt.',
    historySection: 'Verlauf',
    identityChoice: 'Nach Wahl des Melders',
    identityLabel: 'Als Bezeichnung',
    identityName: 'Mit Namen',
    listTitle: 'Meldungen',
    loadErrorDescription: 'Die Meldungen konnten nicht geladen werden. Ihre Daten wurden nicht verändert.',
    loadErrorTitle: 'Meldungen momentan nicht erreichbar',
    new: 'Neu',
    noCategoriesDescription:
      'In diesem Arbeitsbereich ist noch keine Kategorie eingerichtet, unter der gemeldet werden kann. Bitten Sie Ihren Ansprechpartner, Kategorien anzulegen.',
    noCategoriesTitle: 'Noch keine Kategorie eingerichtet',
    notEntitledDescription: 'Meldungen sind für diesen Arbeitsbereich nicht freigeschaltet.',
    notEntitledTitle: 'Meldungen sind hier nicht verfügbar',
    notFoundDescription: 'Diese Meldung ist über diesen Zugang nicht abrufbar.',
    notFoundTitle: 'Meldung nicht gefunden',
    orderActions: 'Aktionen',
    orderChangeState: 'Zustand ändern',
    orderChangeStateDescription:
      'Der neue Zustand gilt für den Auftrag an {{office}} und steht im Verlauf des Falls.',
    orderChangeStateFor: 'Zustand des Auftrags an {{office}} ändern',
    orderChangeStateTitle: 'Zustand des Auftrags ändern?',
    orderComment: 'Kommentieren',
    orderCommentDescription: 'Der Kommentar erscheint im Verlauf des Falls.',
    orderCommentField: 'Kommentar',
    orderCommentFor: 'Auftrag an {{office}} kommentieren',
    orderCommentTitle: 'Kommentar hinzufügen',
    orderCreate: 'Auftrag erteilen',
    orderCreateTitle: 'Auftrag erteilen',
    orderDeadline: 'Frist',
    orderDeadlineField: 'Frist in Tagen (optional)',
    orderDeadlineInvalid: 'Bitte geben Sie die Frist als Anzahl von Tagen an.',
    orderExtract: 'Auftragstext',
    orderExtractField: 'Auftragstext',
    orderExtractHint:
      'Der Auftragstext ist Ihr eigener Text. Die Beschreibung des Melders geht nicht mit hinaus.',
    orderExtractRequired: 'Bitte formulieren Sie den Auftragstext.',
    orderFailed: 'Der Auftrag konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    orderOffice: 'Amt',
    orderOfficeEscalation: '{{office}} (Eskalationsziel)',
    orderOfficeField: 'Amt (Schlüssel)',
    orderOfficeNoSuggestion: 'Diese Meldung nennt kein Amt. Bitte geben Sie den Schlüssel des Amtes an.',
    orderOfficeOrdered: '{{office}} (hat schon einen Auftrag)',
    orderOfficeRequired: 'Bitte geben Sie das Amt an.',
    orderOfficeResponsible: '{{office}} (zuständiges Amt)',
    orderOfficeSuggestions: 'Ämter dieser Meldung:',
    orderReasonField: 'Begründung für den zweiten Auftrag',
    orderReasonRequired:
      'Dieses Amt hat für diese Meldung schon einen Auftrag. Bitte begründen Sie den zweiten.',
    orderState: 'Zustand',
    orderStateAccepted: 'Angenommen',
    orderStateApproved: 'Abgenommen',
    orderStateDone: 'Erledigt',
    orderStateInProgress: 'In Arbeit',
    orderStateIssued: 'Erteilt',
    orderStateOverdue: 'Überfällig',
    orderStateRefused: 'Abgelehnt',
    ordersDuplicateBlocked:
      'Für diese Meldung wird kein Auftrag erteilt: Sie ist als Dublette verknüpft. Beauftragen Sie die verknüpfte Meldung.',
    ordersEmpty: 'Für diese Meldung wurde noch kein Auftrag erteilt.',
    ordersSection: 'Aufträge',
    photoAlt: 'Foto der Meldung, angehängt am {{date}}',
    photoAttach: 'Foto anhängen',
    photoChoose: 'Foto auswählen',
    photoEmpty: 'Die gewählte Datei ist leer.',
    photoHint: 'JPEG, PNG oder WebP, höchstens 8 MB. Bis zu fünf Fotos je Meldung.',
    photoLimitReached: 'Diese Meldung hat bereits {{count}} Fotos — mehr nimmt sie nicht auf.',
    photoLimitRefused: 'Diese Meldung hat bereits die höchste Anzahl Fotos.',
    photoRetry: 'Erneut laden',
    photoTooLarge: 'Das Foto ist größer als 8 MB.',
    photoTypeMismatch: 'Der Inhalt der Datei passt nicht zu ihrer Endung.',
    photoTypeRefused: 'Nur JPEG, PNG und WebP sind möglich.',
    photoUnavailable: 'Dieses Foto konnte nicht geladen werden.',
    photosEmpty: 'Zu dieser Meldung gibt es kein Foto.',
    photosSection: 'Fotos',
    place: 'Ort',
    placeOptional: 'Ort (optional)',
    proximityElsewhere: 'Anderer Ort',
    proximityNearby: 'In der Nähe',
    proximitySamePlace: 'Gleicher Ort',
    refusalAlreadyDuplicate: 'Diese Meldung ist schon als Dublette einer anderen Meldung verknüpft.',
    refusalNotDuplicate: 'Diese Meldung ist nicht als Dublette verknüpft.',
    refusalOfficeNotFound: 'Dieses Amt ist unbekannt oder nicht mehr aktiv.',
    refusalReasonRequired:
      'Dieses Amt hat für diese Meldung schon einen Auftrag. Bitte begründen Sie den zweiten.',
    refusalReportIsDuplicate: 'Diese Meldung ist als Dublette verknüpft und nimmt keine Aufträge an.',
    refusalTargetIsDuplicate: 'Diese Meldung ist selbst eine Dublette. Verknüpfen Sie mit dem Original.',
    reviewApprove: 'Freigeben',
    reviewApproveDescription:
      'Die Meldung läuft ihren regulären Weg weiter. Die Zuordnung bleibt, wie sie ist.',
    reviewApproveTitle: 'Prüfung freigeben?',
    reviewClaim: 'Prüfung übernehmen',
    reviewClaimedByMe: 'Sie haben die Prüfung übernommen.',
    reviewClaimedByOther: 'Die Prüfung ist von einer anderen Person übernommen.',
    reviewEscalate: 'Eskalieren',
    reviewEscalateDescription:
      'Die Meldung geht an das Eskalationsziel der angewandten Regel. Das ist im Verlauf vermerkt und nicht zurücknehmbar.',
    reviewEscalateTitle: 'Prüfung eskalieren?',
    reviewNone: 'Für diese Meldung ist kein Prüfweg vorgesehen.',
    reviewSection: 'Prüfweg',
    reviewStateClaimed: 'In Prüfung übernommen',
    reviewStateDone: 'Prüfung abgeschlossen',
    reviewStatePending: 'Wartet auf Prüfung',
    routeDeadline: 'Frist',
    routeDirect: 'Direkt an das Amt',
    routeEscalation: 'Eskalation an',
    routeExhausted:
      'Die Zielkette war erschöpft — der Fall ist bei der Leitung gelandet, nicht beim ursprünglichen Ziel.',
    routeExternalAllowed: 'Auszug darf nach außen',
    routeExternalNotAllowed: 'Bleibt im Haus',
    routeIdentity: 'Identität gegenüber dem Amt',
    routeNoRule: 'Ohne Regel zugeordnet: es gilt das Ziel der Kategorie.',
    routeOpen: 'Noch offen',
    routeOffice: 'Zuständiges Amt',
    routeReviewNotRequired: 'Keine Prüfung vorgesehen',
    routeReviewRequired: 'Prüfung vorgesehen',
    routeSection: 'Zuordnung',
    routeViaDispatch: 'Über die Meldestelle',
    saveErrorDescription: 'Die Meldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    saveErrorTitle: 'Speichern nicht möglich',
    saving: 'Wird gespeichert',
    statusAnswered: 'Rückmeldung erfolgt',
    statusClosed: 'Abgeschlossen',
    statusColumn: 'Status',
    statusDeferred: 'Zurückgestellt',
    statusDone: 'Erledigt',
    statusDuplicate: 'Dublette',
    statusInProgress: 'In Arbeit',
    statusInReview: 'In Prüfung',
    statusOrdered: 'Beauftragt',
    statusReason: 'Hinweis',
    statusReceived: 'Eingegangen',
    statusRejected: 'Abgelehnt',
    statusReleased: 'Freigegeben',
    statusTaken: 'Übernommen',
    summarySection: 'Zusammenfassung',
    table: 'Meldungen',
    title: 'Meldung',
    titleField: 'Worum geht es?',
    titleRequired: 'Bitte geben Sie an, worum es geht.',
    truncatedNotice:
      'Es werden die neuesten {{count}} Meldungen gezeigt. Filtern oder suchen Sie, um ältere zu erreichen.',
    updatedAt: 'Zuletzt geändert am',
    valueTooLong: 'Diese Angabe ist zu lang.',
  },
  invoices: {
    backToList: 'Zu den Rechnungen',
    category: 'Kategorie',
    categoryAiAbo: 'KI-Abo',
    categoryBeratung: 'Beratung',
    categoryBuerobedarfVerpflegung: 'Bürobedarf und Verpflegung',
    categoryCloudInfrastruktur: 'Cloud-Infrastruktur',
    categoryFacility: 'Gebäude und Facility',
    categoryFuhrpark: 'Fuhrpark',
    categoryMarketing: 'Marketing',
    categoryPersonalBenefits: 'Personal und Benefits',
    categoryReisekosten: 'Reisekosten',
    categorySoftwareAbo: 'Software-Abo',
    categorySonstiges: 'Sonstiges',
    categorySteuernFinanzen: 'Steuern und Finanzen',
    categoryTelefonieInternet: 'Telefonie und Internet',
    confidence: 'Sicherheit der Erkennung',
    description: 'Beschreibung',
    detailTitle: 'Rechnung',
    documentERechnung: 'E-Rechnung',
    documentMail: 'Mail',
    documentOriginal: 'Originalbeleg',
    documentsAtOriginal: 'Der Beleg ist bei der Originalrechnung abgelegt.',
    documentsHint:
      'Öffnet im SharePoint des Arbeitsbereichs in einem neuen Tab; dort gelten Ihre SharePoint-Berechtigungen.',
    documentsSection: 'Dokumente',
    dueDate: 'Fällig am',
    duplicateExplanation:
      'Diese Rechnung liegt bereits vor. Der Datensatz verweist auf die zuerst eingegangene Originalrechnung.',
    duplicateSection: 'Doppelt eingegangene Rechnung',
    emptyDescription: 'Sobald Rechnungen im Postfach eingehen, erscheinen sie hier automatisch.',
    emptyFilteredDescription: 'Für diesen Status gibt es aktuell keine Rechnungen.',
    emptyFilteredTitle: 'Keine Rechnungen mit diesem Status',
    emptyTitle: 'Noch keine Rechnungen',
    extractionSection: 'Rechnungsdaten',
    filterAll: 'Alle Rechnungen',
    filterStatus: 'Status',
    forbiddenDescription:
      'Ihr Konto ist für die Rechnungsdaten dieses Arbeitsbereichs nicht freigeschaltet. Bitten Sie Ihren Ansprechpartner um die Freischaltung.',
    forbiddenTitle: 'Kein Zugriff auf Rechnungen',
    grossAmount: 'Brutto',
    invoiceNumber: 'Rechnungsnummer',
    issueDate: 'Rechnungsdatum',
    issuer: 'Aussteller',
    listTitle: 'Rechnungen',
    loadErrorDescription: 'Die Rechnungen konnten nicht geladen werden. Ihre Daten wurden nicht verändert.',
    loadErrorTitle: 'Rechnungen momentan nicht erreichbar',
    netAmount: 'Netto',
    newestPage: 'Neueste anzeigen',
    noDocuments: 'Zu diesem Eintrag wurde kein Dokument abgelegt.',
    notEntitledDescription: 'Der Rechnungseingang ist für diesen Arbeitsbereich nicht freigeschaltet.',
    notEntitledTitle: 'Rechnungen sind hier nicht verfügbar',
    notFoundDescription: 'Diese Rechnung gibt es nicht oder sie gehört nicht zu diesem Arbeitsbereich.',
    notFoundTitle: 'Rechnung nicht gefunden',
    olderPage: 'Ältere anzeigen',
    openOriginal: 'Originalrechnung öffnen',
    openOriginalNumbered: 'Originalrechnung {{number}} öffnen',
    paidAmount: 'Bezahlt',
    paymentKreditkarte: 'Kreditkarte',
    paymentLastschrift: 'Lastschrift',
    paymentMethod: 'Zahlungsart',
    paymentUeberweisung: 'Überweisung',
    receivedAt: 'Eingegangen am',
    statusColumn: 'Status',
    statusDuplicate: 'Dublette',
    statusProcessed: 'Verarbeitet',
    statusReason: 'Hinweis',
    statusUncertain: 'Punkte offen',
    statusUnclear: 'Unklar',
    summarySection: 'Zusammenfassung',
    table: 'Rechnungen',
    recipientMismatch: 'Der Rechnungsempfänger passt nicht eindeutig zu den hinterlegten Firmendaten.',
    uncertainExplanation:
      'Diese Rechnung wurde abgelegt, aber wegen offener Prüfpunkte nicht automatisch weitergeleitet. Änderungen an Einstellungen prüfen oder versenden diese Rechnung nicht erneut.',
    unclearExplanation:
      'Diese Mail wurde als Rechnung erkannt, konnte aber nicht automatisch verarbeitet werden. Sie bleibt zur Sichtung im Posteingang.',
    withoutNumber: 'Ohne Nummer',
  },
  invoiceOutgoing: {
    cancel: {
      reason: 'Grund',
    },
    customerUnconfirmedDetail:
      '{{name}} ist noch nicht bestaetigt. Der Entwurf bleibt bestehen, freigegeben werden kann er erst, wenn Adresse, USt-Id und Steuerbehandlung vervollstaendigt sind.',
    customerUnconfirmedShort: 'unbestaetigt',
    accessRefused:
      'Dieser Arbeitsbereich hat den Zugriff auf Ausgangsrechnungen abgewiesen. Melde dich neu an; bleibt es dabei, kann eine Administratorin oder ein Administrator die Mitgliedschaft pruefen.',
    forbidden:
      'Dein Konto darf Ausgangsrechnungen nicht sehen. Bitte eine Administratorin oder einen Administrator um die Rechnungsrechte dieses Arbeitsbereichs.',
    loadFailed: 'Die Rechnungen konnten nicht geladen werden.',
    notEntitled: 'Dieser Arbeitsbereich hat Ausgangsrechnungen nicht aktiviert.',
    retry: 'Erneut versuchen',
    taxCategories: {
      Exempt: 'Steuerfrei',
      Standard: 'Regelsatz',
      ZeroRated: 'Nullsatz',
    },
    reasons: {
      // The blockers. Each names what to do next, because a reason without a next step still leaves
      // the reader hunting — and for these customers the answer is often the standing permission
      // rather than an order number.
      NotADraft: 'Nur ein Entwurf kann freigegeben werden.',
      CustomerUnconfirmed:
        'Der Kunde ist noch nicht bestaetigt. Der Name kommt aus der Jira-Organisation, die Adresse ist ein Platzhalter — und ein Platzhalter darf nicht auf eine Rechnung.',
      NoLines: 'Die Rechnung hat keine Positionen.',
      ZeroTotal: 'Die Rechnung hat keinen Betrag.',
      SellerProfileMissing:
        'Die Firmendaten fehlen. Eine Rechnung muss sagen, wer sie stellt. Ein Tenant-Admin pflegt sie unter Administration → Firmendaten.',
      CustomerMissing: 'Zu dieser Rechnung existiert kein Kunde.',
      CustomerInactive: '{{customer}} ist kein aktiver Kunde.',
      // Das Urteil des Importers ueber ein extrahiertes Dokument (S4b). Nie eine Verweigerung: Der
      // Entwurf existiert, und diese Saetze sagen, warum er unter "nachschaerfen" statt "pruefen und
      // freigeben" steht.
      ImporterNoLines: 'Das Dokument hat keine Positionen.',
      ImporterLineWithoutAmount: 'Die Position "{{line}}" hat keinen Betrag.',
      ImporterNonPositiveTotal: 'Die Nettosumme ist nicht positiv.',
      ImporterCustomerUnresolved: 'Das Dokument nennt keinen Empfaenger.',
      ImporterCustomerUnknown: 'Kunde {{customerId}} gehoert nicht zu diesem Arbeitsbereich.',
      ImporterCustomerUnconfirmed: '{{customer}} ist noch kein bestaetigter Kunde.',
      ImporterOrderRecordUnknown:
        'Der Importer hat den Datensatz "{{key}}" der Liste "{{list}}" genannt, den es dort nicht gibt.',
      ImporterTicketNotBillable: 'Nach deinen Regeln ist dieses Ticket nicht abzurechnen: {{reason}}',
      ImporterExtractionAsksForRefinement: '{{why}}',
      ImporterSourceKeyMismatch: 'Das Dokument handelt von {{actual}}, wurde aber aus {{expected}} erzeugt.',

      // The findings a run raises per ticket. Every one names the Jira field it came from.
      IssueNotClosed: 'Das Ticket ist noch nicht abgeschlossen.',
      ResolutionMissing:
        'Das Jira-Feld "{{field}}" ist leer, das Ticket sagt also nicht, ob etwas geliefert wurde.',
      NothingDelivered:
        'Das Jira-Feld "{{field}}" ist "{{value}}" — es wurde nichts geliefert, also gibt es nichts abzurechnen.',
      ResolutionUnknown:
        'Das Jira-Feld "{{field}}" ist "{{value}}". Diese Regel kennt den Wert nicht; ein Mensch muss sagen, ob er geliefert bedeutet.',
      AlreadyInvoicedByHand:
        'Das Jira-Feld "{{field}}" ist "{{value}}" — die Leistung ist bereits abgerechnet. Ein Import wuerde dieselbe Arbeit doppelt in Rechnung stellen.',
      MarkedNotBillable:
        'Das Jira-Feld "{{field}}" ist "{{value}}" — jemand hat bereits entschieden, dass das nicht abgerechnet wird.',
      AcceptanceUnrecorded:
        'Das Jira-Feld "{{field}}" ist leer. Sobald der Kunde das Ergebnis abgenommen hat, dort "{{expected}}" eintragen.',
      AcceptanceUnevidenced:
        'Das Jira-Feld "{{field}}" ist "{{value}}", nicht "{{expected}}" — pruefen, ob der Kunde das Ergebnis abgenommen hat.',
      OrderExplicitlyPending:
        'Das Jira-Feld "{{field}}" ist "{{value}}" und sagt damit, dass es noch keinen Auftrag gibt. Die kaufmaennische Seite ist nicht geklaert.',
      OrderUnrecognised:
        'Das Jira-Feld "{{field}}" ist "{{value}}" und enthaelt keinen Auftrags- oder Angebotsbezug. Dort die Auftragsnummer oder das Angebot (QUO-…) eintragen.',
      OrderAmbiguous:
        'Das Jira-Feld "{{field}}" ist "{{value}}" — {{count}}. Welcher Auftrag gilt, entscheidet ein Mensch.',
      OrderCarriesACaveat:
        'Das Jira-Feld "{{field}}" nennt {{reference}}, macht aber einen Vorbehalt: "{{value}}".',
      OrderIsCollective:
        'Das Jira-Feld "{{field}}" nennt "{{value}}" — eine Sammelbestellung ohne Nummer. Die Rechnung tragt diese Bezeichnung; sie ist aber nur zusammen mit dem Kundennamen eindeutig, also pruefen, ob Bezeichnung und Kunde zusammenpassen.',
      NoAmount: 'Das Jira-Feld "{{field}}" ist leer, es gibt also keinen Betrag abzurechnen.',
      RecipientUnknown: 'Das Jira-Feld "{{field}}" ist leer, der Empfaenger ist damit unbekannt.',
      RecipientAmbiguous:
        'Das Jira-Feld "{{field}}" nennt {{count}} Organisationen ({{names}}). Wer die Rechnung erhaelt, entscheidet ein Mensch.',
      RecipientChanged:
        'Das Ticket nennt jetzt die Organisation "{{to}}", die Rechnung gehoert aber zu "{{from}}". Eine Rechnung wechselt nicht den Kunden — pruefen und den Entwurf gegebenenfalls verwerfen und neu importieren.',
      CustomerUnknown:
        'Zu dieser Organisation ist noch kein Kunde angelegt, ihre Abrechnungsregeln sind also unbekannt.',
      OrderCoverageUnknown:
        'Das Ticket nennt Auftrag {{reference}}, aber zum Auftrag liegen keine Daten vor: Festpreis oder Kontingent — und deckt er diesen Betrag noch?',
      OrderCoverageUnknownForCustomer:
        '{{customer}} wird gegen Auftraege abgerechnet, und es liegen keine Auftragsdaten vor: welcher Auftrag, Festpreis oder Kontingent, und deckt er diesen Betrag?',
    },
    aiAccess: {
      action: 'KI-Zugang',
      credentialReference: 'Name des Secrets im Secret Store (NICHT der Schluessel selbst)',
      delete: 'Zugang entfernen',
      deleteFailed: 'Der Zugang konnte nicht entfernt werden.',
      deployment: 'Name des Deployments',
      description:
        'Das Sprachmodell fuellt aus, was ein fluechtig geschriebenes Ticket nicht sagt. An kein Modell wird etwas geschickt, bis dieser Arbeitsbereich entscheidet: das Modell der Plattform einschalten (wo der Operator es freigegeben hat) oder eine eigene Azure-OpenAI-Ressource eintragen — eigener Schluessel, eigenes Modell, eigene Kosten, eigener Auftragsverarbeitungsvertrag.',
      endpoint: 'Endpoint der eigenen Azure-Ressource',
      formTitle: 'Zugang',
      isActive: 'Zugang ist aktiv',
      isActiveHint:
        'Aus: Es wird kein Ticket an ein Modell geschickt. Die Einstellungen bleiben erhalten — gedacht fuer den Nachmittag, an dem ein Schluessel getauscht wird.',
      loadFailed: 'Der KI-Zugang konnte nicht geladen werden.',
      loading: 'KI-Zugang wird geladen',
      none: 'Kein Modell in Benutzung: Es wird kein Ticket an ein Modell geschickt.',
      platformOn:
        'Dieser Arbeitsbereich nutzt das Modell, das die Plattform bereitstellt: {{model}} (Anthropic).',
      platformOnHint:
        'Kosten und Datenverarbeitung laufen ueber den Anthropic-Vertrag der Plattform; das Modell waehlt die Plattform, nicht der Arbeitsbereich. Eine unten eingetragene eigene Azure-OpenAI-Ressource ersetzt es.',
      platformOff:
        'Das Plattform-Modell ist fuer diesen Arbeitsbereich ausgeschaltet. Es wird kein Ticket an ein Modell geschickt.',
      platformNotEntitled:
        'Die Plattform stellt ein Modell bereit, aber der Operator hat es fuer diesen Arbeitsbereich nicht freigegeben. Frag den Operator oder trage unten eine eigene Azure-OpenAI-Ressource ein.',
      platformUnavailableOn:
        'Das Plattform-Modell ist eingeschaltet, steht diesem Arbeitsbereich aber gerade nicht zur Verfuegung ({{state}}). Es wird kein Ticket geschickt.',
      legacyAnthropic:
        'Dieser Arbeitsbereich traegt noch einen eigenen Anthropic-Zugang von frueher ({{model}}). Er ist nicht in Benutzung, es wird kein Ticket geschickt: Anthropic stellt jetzt die Plattform bereit. Schalte das Plattform-Modell ein, um diesen Eintrag zu ersetzen, oder entferne ihn.',
      usePlatform: 'Plattform-Modell benutzen',
      usePlatformHint:
        'Schaltet das Anthropic-Modell der Plattform fuer diesen Arbeitsbereich ein. Die Kosten traegt die Plattform; der Operator hat es fuer dich freigegeben.',
      switchOff: 'Plattform-Modell ausschalten',
      deleteHint:
        'Das Entfernen des Zugangs beendet jeden Modellaufruf. Das Plattform-Modell tritt nicht an seine Stelle, solange du es nicht einschaltest.',
      ownTitle: 'Eigene Azure-OpenAI-Ressource',
      paused:
        'Der Zugang ist eingerichtet, aber ausgeschaltet. Es wird gerade kein Ticket an ein Modell geschickt.',
      providerHint:
        'Je Arbeitsbereich wird nur eine eigene Azure-OpenAI-Ressource eingetragen; Anthropic stellt die Plattform bereit.',
      readOnly: 'Dein Konto darf den KI-Zugang lesen, aber nicht aendern.',
      save: 'Zugang speichern',
      saveFailed: 'Der Zugang konnte nicht gespeichert werden.',
      savedNotice: 'Der KI-Zugang ist gespeichert.',
      secretExplained:
        'Der Schluessel selbst wird hier nicht eingegeben und ist auch nirgends in diesem Formular zu sehen — das Feld oben will den NAMEN des Secrets. Der Schluessel wird ausserhalb der Anwendung abgelegt, genauso wie die Jira- und M365-Zugangsdaten. Dadurch steht in der Datenbank nie ein Schluessel, und diese Seite darf jeder lesen, der den Arbeitsbereich ohnehin verwaltet.',
      secretLocal:
        'Lokal: eine Datei ~/.das-platform/secrets/<name>.json mit {"schemaVersion": 1, "provider": "AzureOpenAI", "tenantIds": ["<Tenant-ID dieses Arbeitsbereichs>"], "endpoint": "https://<ressource>.openai.azure.com", "apiKey": "…"}. Der Name muss mit "ai-" beginnen, damit dev.ps1 run sie in die Umgebung uebernimmt — z. B. ai-azure-openai.json fuer den Namen "ai-azure-openai".',
      secretAzure:
        'In Azure: az keyvault secret set --vault-name <Vault> --name <name> --value <JSON wie oben>',
      title: 'KI-Zugang',
    },
    settingsMenu: 'Einstellungen',
    stages: {
      pdfTitle: 'Rechnung (PDF)',
      pdfLabel: 'ZUGFeRD-PDF für den Kunden',
      pdfMissing: 'Noch kein PDF. „Vorbereiten“ erzeugt es aus der Quelldatei.',
      linesSummary_one: '{{count}} Position',
      linesSummary_other: '{{count}} Positionen',
      eventsSummary_one: '{{count}} Eintrag',
      eventsSummary_other: '{{count}} Einträge',
      title: 'Stand',
      filesTitle: 'Dateien',
      viewsLabel: 'Ansicht',
      views: { open: 'Offen', delivered: 'Zugestellt', cancelled: 'Zurückgezogen' },
      columns: { source: 'Quelldatei', zugferd: 'ZUGFeRD', mail: 'E-Mail', deliveredAt: 'Zugestellt am' },
      states: {
        any: { Done: 'erstellt', Missing: '—', Failed: 'fehlgeschlagen' },
        source: { NotApplicable: 'entfällt (HTML-Vorlage)' },
        mail: { Prepared: 'vorbereitet', Queued: 'wird gesendet', Sent: 'gesendet' },
      },
      hint: 'Vorbereiten bringt die gewählten Rechnungen so weit wie möglich: Quelldatei, ZUGFeRD-PDF und E-Mail. Senden verschickt die vorbereiteten E-Mails. Nach einem Abrechnungslauf wird automatisch vorbereitet.',
      emptyTitle: 'Keine Rechnungen in dieser Ansicht',
      empty: {
        open: 'Alle Rechnungen sind zugestellt. Neue entstehen im Abrechnungslauf auf der Ticketseite oder über „Rechnung anlegen“.',
        delivered: 'Noch keine Rechnung zugestellt.',
        cancelled: 'Keine zurückgezogenen Rechnungen.',
      },
      actions: {
        prepare: 'Vorbereiten ({{count}})',
        prepareOne: 'Vorbereiten',
        send: 'Senden ({{count}} bereit)',
        sendOne: 'Senden',
        download: 'Herunterladen ({{count}})',
        edit: 'Bearbeiten',
        more: 'Weitere Aktionen',
        withdraw: 'E-Mail zurückziehen ({{count}})',
        deliver: 'Als zugestellt markieren ({{count}})',
        deliverHint: 'z. B. per Post versandt — ohne E-Mail',
        delete: 'Löschen ({{count}})',
        deleteHint: 'Die Nummer bleibt mit Grund dokumentiert; die Tickets werden wieder abrechenbar.',
        reopen: 'Zurück nach Offen ({{count}})',
        reopenHint: 'z. B. wenn die E-Mail nicht ankam',
        cancel: 'Zurückziehen ({{count}})',
        cancelHint: 'Eine zugestellte Rechnung wird zurückgezogen, nicht geändert.',
      },
      sendConfirm: {
        title: 'E-Mails jetzt senden?',
        description:
          'Diese E-Mails gehen sofort aus dem Absenderpostfach an die genannten Empfänger. Gesendet ist gesendet — das lässt sich nicht zurücknehmen.',
        item: '{{number}} · {{customer}} → {{to}} · Betreff: {{subject}}',
        confirm_one: '{{count}} E-Mail senden',
        confirm_other: '{{count}} E-Mails senden',
        cancel: 'Abbrechen',
        listLabel: 'Zu sendende E-Mails',
      },
      overrule: {
        deliver: 'Als zugestellt markieren',
        deliverHint:
          '{{count}} Rechnung(en) gelten als zugestellt, ohne dass eine E-Mail geht. Der Grund steht im Verlauf.',
        reopen: 'Zurück nach Offen',
        reopenHint:
          '{{count}} Rechnung(en) gehen zurück nach „Offen“ und können erneut vorbereitet und gesendet werden. Der Grund steht im Verlauf.',
        cancel: 'Zurückziehen',
        cancelHint:
          '{{count}} Rechnung(en) werden zurückgezogen. Die Nummer bleibt mit dem Grund dokumentiert, die Tickets werden wieder abrechenbar.',
        reason: 'Grund',
      },
      done: {
        prepare:
          '{{count}} Rechnung(en) vorbereitet. Die E-Mail zum Prüfen öffnet sich mit „vorbereitet“ in der Spalte E-Mail.',
        send: '{{count}} E-Mail(s) in den Postausgang gestellt.',
        withdraw: '{{count}} E-Mail(s) zurückgezogen.',
        deliver: '{{count}} Rechnung(en) als zugestellt markiert.',
        reopen: '{{count}} Rechnung(en) zurück nach Offen.',
        cancel: '{{count}} Rechnung(en) zurückgezogen.',
      },
      notDone: 'Nicht erledigt: {{reasons}}',
      running: 'Läuft … Die Rechnungen werden nacheinander bearbeitet.',
      runFailed: 'Die Aktion konnte nicht ausgeführt werden.',
      reasonMissing: 'Bitte einen Grund angeben.',
      noFiles: 'Noch keine Dateien. „Vorbereiten“ erzeugt Quelldatei und ZUGFeRD-PDF.',
      sourceHint:
        'Die Quelldatei ist für Formulierungen und Layout gedacht. Beträge und Positionen werden in der Rechnung geändert („Bearbeiten“) — die E-Rechnung entsteht aus diesen Daten, nicht aus der Datei.',
      sourceChoose: 'Bearbeitete Quelldatei wählen',
      sourceUpload: 'Hochladen',
      sourceMissing: 'Bitte zuerst eine Datei wählen.',
      sourceFailed: 'Die Datei konnte nicht hochgeladen werden.',
      sourceUploaded: 'Quelldatei ersetzt. „Vorbereiten“ erzeugt das ZUGFeRD-PDF daraus neu.',
      failures: {
        NOT_APPROVABLE: 'Rechnung noch nicht vollständig',
        NO_TEMPLATE: 'keine Rechnungsvorlage',
        SOURCE_FAILED: 'Quelldatei konnte nicht erzeugt werden',
        PDF_FAILED: 'PDF konnte nicht erzeugt werden',
        XML_FAILED: 'E-Rechnung konnte nicht erzeugt werden',
        TOTAL_MISMATCH: 'Betrag in der Quelldatei weicht ab',
        TOTAL_UNREADABLE: 'Gesamtbetrag in der Quelldatei nicht lesbar',
        NO_RECIPIENT: 'keine Rechnungs-E-Mail beim Kunden',
        INVOICE_CANCELLED: 'Rechnung ist nicht mehr offen',
        DOCUMENTS_MISSING: 'keine vorbereitete E-Mail',
        SENDER_MAILBOX_MISSING: 'kein Absenderpostfach verbunden',
        MAIL_CHANGED: 'die E-Mail wurde nach dem Bestätigen geändert — bitte erneut senden und bestätigen',
        DOCUMENT_DRIVE_MISSING: 'keine Dokumentablage verbunden',
        DOCUMENT_DRIVE_CONFIGURATION: 'Dokumentablage nicht nutzbar',
        EINVOICE_PACKER_NOT_CONFIGURED: 'ZUGFeRD-Packer nicht eingerichtet',
        EINVOICE_PACKER_UNREACHABLE: 'ZUGFeRD-Packer nicht erreichbar',
        MAIL_FAILED: 'E-Mail nicht zugestellt',
        NOTHING_PREPARED: 'keine vorbereitete E-Mail',
        REFUSED: 'abgelehnt',
        INVALID: 'nicht möglich',
      },
    },
    mail: {
      title: 'Versand per E-Mail',
      loadFailed: 'Der Versand konnte nicht geladen werden.',
      noSender:
        'Es ist kein Postfach für den Rechnungsversand verbunden. Der Betrieb wählt es in der Kundenverwaltung unter „Rechnungsausgang: Absenderpostfächer“.',
      to: 'Empfänger',
      toInvalid: 'Bitte genau eine E-Mail-Adresse angeben.',
      noBillingEmail: 'Beim Kunden ist keine Rechnungs-E-Mail hinterlegt.',
      replyTo: 'Antworten an',
      replyToSender: 'an das Absenderpostfach',
      subject: 'Betreff',
      body: 'Text',
      attachments: 'Anhänge',
      attachmentModes: {
        Zugferd: 'ZUGFeRD-PDF (E-Rechnung eingebettet)',
        PdfAndXml: 'PDF und E-Rechnung als XML',
      },
      edit: 'E-Mail bearbeiten',
      write: 'E-Mail schreiben',
      save: 'E-Mail speichern',
      saved: 'E-Mail gespeichert.',
      saveFailed: 'Die E-Mail konnte nicht gespeichert werden.',
      showing: {
        current: 'Die E-Mail dieser Rechnung — {{state}}.',
        sent: 'Die zuletzt gesendete E-Mail ({{at}}).',
        preview: 'Vorschau: So schreibt „Vorbereiten“ die E-Mail aus den Einstellungen.',
      },
      attachmentsLater: 'das ZUGFeRD-PDF, sobald es erzeugt ist',
      history: 'Bisherige Sendungen',
      at: 'Beauftragt',
      state: 'Stand',
      states: {
        Requested: 'beauftragt',
        Prepared: 'vorbereitet',
        Withdrawn: 'zurückgezogen',
        Queued: 'im Postausgang',
        Sent: 'gesendet',
        Failed: 'fehlgeschlagen',
      },
    },
    mailSettings: {
      action: 'Rechnungsversand',
      title: 'Rechnungsversand einstellen',
      loadFailed: 'Die Einstellungen konnten nicht geladen werden.',
      description:
        'So gehen Rechnungen per E-Mail hinaus: an die Rechnungs-E-Mail des Kunden, aus dem verbundenen Absenderpostfach. Betreff und Text lassen sich beim Senden noch anpassen.',
      replyToHint: 'Leer: Antworten gehen an das Absenderpostfach.',
      replyToInvalid: 'Bitte genau eine E-Mail-Adresse angeben.',
      placeholders: 'Platzhalter: {{placeholders}}',
      save: 'Speichern',
      saved: 'Gespeichert.',
      autoPrepare: 'Nach dem Abrechnungslauf automatisch vorbereiten',
      autoPrepareHint:
        'Quelldatei, ZUGFeRD-PDF und E-Mail entstehen gleich nach dem Lauf; gesendet wird erst auf „Senden“.',
      saveFailed: 'Die Einstellungen konnten nicht gespeichert werden.',
    },
    newInvoice: {
      action: 'Rechnung anlegen',
      title: 'Rechnung von Hand anlegen',
      loading: 'Wird geladen',
      loadFailed: 'Kunden und Bestellungen konnten nicht geladen werden.',
      description:
        'Eine Rechnung ohne Tickets: Kunde, Datum, optional eine Bestellung und die Positionen. Sie entsteht wie aus dem Abrechnungslauf als nummerierter Entwurf; Zahlungsziel und Umsatzsteuer folgen dem Kunden.',
      customer: 'Kunde',
      chooseCustomer: 'Kunde wählen',
      issueDate: 'Rechnungsdatum',
      order: 'Bestellung (optional)',
      noOrder: 'ohne Bestellung',
      paymentTermDays: 'Zahlungsziel in Tagen',
      paymentTermInvalid: 'Gib das Zahlungsziel als ganze Zahl zwischen 0 und 365 Tagen an.',
      taxTreatment: 'Steuerbehandlung',
      taxFromCustomer: 'wie beim Kunden',
      linesHint: 'Positionen: Einzelpreis netto in Euro.',
      lineName: 'Position {{position}}: Bezeichnung',
      quantity: 'Menge',
      unit: 'Einheit',
      unitPrice: 'Einzelpreis netto',
      remove: 'Entfernen',
      removeLine: 'Position {{position}} entfernen',
      addLine: 'Position hinzufügen',
      netTotal: 'Summe netto: {{amount}}',
      notes: 'Bemerkung (optional)',
      create: 'Entwurf anlegen',
      save: 'Speichern',
      saveFailed: 'Die Rechnung konnte nicht gespeichert werden.',
      editTitle: 'Rechnung {{number}} bearbeiten',
      editDescription:
        'Datum, Positionen und Bemerkung ändern, und was die Abrechnung vergeben hat überschreiben: Kunde, Bestellung, Zahlungsziel und Steuerbehandlung. Die Tickets behalten ihren Kunden und ihre Bestellung. Beim Speichern entfallen die Dateien und die vorbereitete E-Mail; „Vorbereiten“ erzeugt sie neu.',
      ticketLineName: 'Position {{position}} (Ticket): Bezeichnung',
      cancel: 'Abbrechen',
      customerMissing: 'Bitte einen Kunden wählen.',
      linesInvalid: 'Bitte die markierten Positionen korrigieren.',
      nameMissing: 'Eine Bezeichnung fehlt.',
      quantityInvalid: 'Eine Menge über 0 bis 100.000, höchstens vier Nachkommastellen.',
      priceInvalid: 'Ein Einzelpreis ab 0.',
      failed: 'Die Rechnung konnte nicht angelegt werden.',
    },
    orders: {
      changedMeanwhile:
        'Die Bestellung wurde inzwischen geändert, z. B. durch eine Zustellung. Das Formular zeigt sie jetzt, wie sie steht — prüfe deine Änderung und speichere erneut.',
      fieldErrors: {
        Required: 'Die Abrechnung braucht dieses Feld.',
        NotAnAmount: 'Gib einen Betrag ein, z. B. 11.500,00.',
        NotADate: 'Wähle ein Datum.',
        NotAnOption: 'Wähle einen der Werte, die diese Spalte schon enthält.',
        UnknownCustomer:
          'Kein aktiver Kunde in den Stammdaten hat diese Nummer oder diesen Namen. Wähle einen aus der Liste.',
        AmbiguousCustomer:
          'Mehrere aktive Kunden passen zu diesem Namen: {{names}}. Bereinige die doppelten Einträge in den Kundenstammdaten.',
        NotACashDiscount: 'Gib den Skonto als Prozent und Tage an, z. B. „3% 14 Tage“, oder „nein“.',
      },
      reconcile: {
        action: 'Datei abgleichen',
        title: 'Datei abgleichen: {{label}}',
        hint: 'Die Datei ersetzt die Liste nicht. Sie wird je Bestellnummer verglichen: neue Bestellungen kommen hinzu, fehlende bleiben, und bei jeder geänderten Bestellung entscheidest du, welche Seite gilt. Erst „Abgleich übernehmen“ ändert etwas.',
        choose: 'Datei wählen',
        fileHint: 'Excel oder CSV mit denselben Spalten wie die Liste.',
        compareFailed: 'Die Datei konnte nicht verglichen werden.',
        applyFailed: 'Der Abgleich konnte nicht übernommen werden.',
        summary:
          '{{added}} neu · {{changed}} geändert · {{unchanged}} unverändert · {{missing}} nicht in der Datei (bleiben)',
        skipped:
          'Übersprungen: {{withoutKey}} Zeile(n) ohne Bestellnummer, {{duplicates}} doppelte Bestellnummer(n) — es gilt jeweils die erste Zeile.',
        allFile: 'Alle aus der Datei',
        allOurs: 'Alle unsere behalten',
        changedTitle: 'Geänderte Bestellungen',
        order: 'Bestellung',
        differences: 'Unterschiede (unsere → Datei)',
        difference: '{{column}}: {{ours}} → {{file}}',
        deliveredSince:
          'Seit dem letzten Setzen von „offen“ wurden durch Zustellungen {{amount}} abgezogen — eine ältere Datei kennt das nicht.',
        decision: 'Was gilt',
        decisionFor: 'Was gilt für {{key}}',
        takeFile: 'Datei',
        keepOurs: 'Unsere',
        undecided: 'Entscheide noch für {{count}} geänderte Bestellung(en), welche Seite gilt.',
        addedList: 'Neu: {{keys}}',
        missingList: 'Nicht in der Datei, bleiben: {{keys}}',
        apply: 'Abgleich übernehmen',
        cancel: 'Abgleich abbrechen',
        done: '{{label}} abgeglichen: {{added}} neu, {{takenFromFile}} aus der Datei, {{keptOurs}} behalten, {{unchanged}} unverändert, {{missing}} nicht in der Datei.',
      },
      history: {
        open: 'Verlauf',
        openOne: 'Verlauf von „offen“ fuer {{key}}',
        title: 'Verlauf von „offen“: {{key}}',
        at: 'Zeitpunkt',
        what: 'Was',
        amount: 'Aenderung',
        by: 'Von',
        system: 'automatisch',
        none: 'Noch keine Aenderung erfasst.',
        loadFailed: 'Der Verlauf konnte nicht geladen werden.',
        close: 'Verlauf schliessen',
        kinds: {
          Set: 'gesetzt (von Hand oder per Upload)',
          Delivered: 'Rechnung {{invoice}} zugestellt',
          Reversed: 'Zustellung von {{invoice}} zurueckgenommen',
        },
      },
      title: 'Bestellungen',
      action: 'Bestellungen',
      loading: 'Bestellungen werden geladen',
      loadFailed: 'Die Bestellungen konnten nicht geladen werden.',
      description:
        'Alle bestätigten Bestelllisten mit ihren Bestellungen und dem Kunden, zu dem jede gehört. Eine Bestellung lässt sich hier hinzufügen und korrigieren; Tickets, die sie nennen, werden dabei neu abgeleitet.',
      none: 'Noch keine bestätigte Bestellliste. Lade unten unter „Bestelllisten (Dateien)“ eine hoch und gib einer Spalte das Feld „Bestellnummer“.',
      listTitle_one: '{{label}} ({{count}} Bestellung)',
      listTitle_other: '{{label}} ({{count}} Bestellungen)',
      empty: 'Diese Liste hat noch keine Bestellung.',
      customer: 'Kunde (Stammdaten)',
      noCustomer: 'nicht in den Stammdaten',
      actions: 'Aktion',
      edit: 'Bearbeiten',
      editOne: 'Bestellung {{key}} bearbeiten',
      add: 'Bestellung hinzufügen',
      addTitle: 'Bestellung zu „{{label}}“ hinzufügen',
      editTitle: 'Bestellung {{key}} bearbeiten',
      addHint:
        'Die Bestellnummer muss in dieser Liste neu sein. Den Kunden wählst du aus den aktiven Kunden der Stammdaten.',
      editHint:
        'Ein geleertes Feld wird in der Bestellung geleert. Tickets dieser Bestellung werden neu abgeleitet.',
      keyLabel: '{{column}} (Bestellnummer)',
      notOnFile: '{{value}} (nicht unter den aktiven Kunden)',
      requiredNote: 'Mit * markierte Felder braucht die Abrechnung; sie stehen vorn.',
      dayRateMissing: 'Ohne Tagessatz kann die Abrechnung nach Tagessatz die Zahl der Tage nicht berechnen.',
      customerNumberLabel: '{{column}} (Kundennummer)',
      save: 'Speichern',
      cancel: 'Abbrechen',
      saveFailed: 'Die Bestellung konnte nicht gespeichert werden.',
      addedNotice: 'Bestellung {{key}} ist hinzugefügt.',
      savedNotice: 'Bestellung {{key}} ist gespeichert.',
    },
    escalation: {
      chooseAll: 'Alle fälligen Erinnerungen wählen',
      title: 'Erinnerungen',
      action: 'Erinnerungen',
      loading: 'Erinnerungen werden geladen',
      loadFailed: 'Die Erinnerungen konnten nicht geladen werden.',
      description:
        'Fehlen einem Ticket Angaben für die Rechnung, fragt eine Erinnerung per E-Mail danach — Schritt für Schritt an die zuständige Person im Ticket und/oder eine feste Adresse. Die E-Mail nennt die fehlenden Angaben aus der Checkliste und warum sie gebraucht werden.',
      noSender:
        'Für diesen Arbeitsbereich ist kein Absenderpostfach für Erinnerungen angebunden. Fällige Erinnerungen werden angezeigt, aber nicht versendet. Der Betrieb wählt es in der Kundenverwaltung unter „Rechnungsausgang: Absenderpostfächer“.',
      dueTitle: 'Fällige Erinnerungen ({{count}})',
      dueTable: 'Fällige Erinnerungen',
      dueEmpty: 'Gerade ist keine Erinnerung fällig.',
      noSteps: 'Noch keine Schritte festgelegt — ohne Schritte wird nicht erinnert.',
      chooseOne: '{{key}}, Schritt {{step}} senden',
      ticket: 'Ticket',
      step: 'Schritt',
      recipient: 'Empfänger',
      recipients: {
        Assignee: 'Zuständig im Ticket',
        Fixed: 'Feste Adresse',
      },
      toAccountManager: 'Kundenverantwortlich (statt Zuständigem im Ticket)',
      blocked: {
        AssigneeWithoutAddress: 'Jira nennt keine E-Mail-Adresse, nicht versendbar',
        NothingForAssignee: 'nichts für die zuständige Person zu ergänzen, zurückgehalten',
        TicketNotDone: 'Ticket ist in Jira noch nicht abgeschlossen, zurückgehalten',
      },
      dueSince: 'Fällig seit',
      missing: 'Fehlend',
      send_one: '{{count}} Erinnerung senden',
      send_other: '{{count}} Erinnerungen senden',
      sentNotice_one: '{{count}} Erinnerung ist zum Versand übergeben.',
      sentNotice_other: '{{count}} Erinnerungen sind zum Versand übergeben.',
      sendFailed: 'Die Erinnerungen konnten nicht versendet werden.',
      preview: 'Vorschau {{key}}, Schritt {{step}}',
      subject: 'Betreff',
      body: 'Text der E-Mail',
      settingsTitle: 'Eskalationsstufen',
      autoSend: 'Fällige Erinnerungen täglich um 8 Uhr automatisch senden',
      autoSendHint:
        'Ausgeschaltet werden fällige Erinnerungen nur angezeigt und von Hand gesendet. Eingeschaltet sendet sie die Plattform einmal täglich um 8 Uhr (Berliner Zeit): alles, was bis dahin fällig ist.',
      stepsHint:
        'Schritt 1 wird die genannten Tage, nachdem das Ticket auf „Zu bearbeiten“ ging, fällig, jeder weitere die genannten Tage nach dem vorigen. Verlässt das Ticket „Zu bearbeiten“, endet die Leiter.',
      firstAfterDays: 'Schritt {{step}}: Tage nach „Zu bearbeiten“',
      afterDays: 'Schritt {{step}}: Tage nach Schritt davor',
      toAssignee: 'An die zuständige Person',
      toAssigneeOf: 'Schritt {{step}} an die zuständige Person',
      fixedAddress: 'Feste Adresse (optional)',
      remove: 'Entfernen',
      removeStep: 'Schritt {{step}} entfernen',
      addStep: 'Schritt hinzufügen',
      daysInvalid: 'Ganze Tage von 1 bis 365.',
      addressInvalid: 'Genau eine E-Mail-Adresse.',
      recipientMissing: 'An die zuständige Person, an eine feste Adresse oder an beide.',
      stepsInvalid: 'Bitte die markierten Schritte korrigieren.',
      placeholders: 'Platzhalter: {{names}}',
      restoreDefault: 'Standardtext wiederherstellen',
      save: 'Speichern',
      saveFailed: 'Die Eskalationsstufen konnten nicht gespeichert werden.',
      savedNotice: 'Gespeichert.',
      readOnly: 'Nur lesbar — Ändern braucht die Berechtigung für die Abrechnungsdaten.',
      on: 'an',
      off: 'aus',
      stepLabel: 'Schritt {{step}}',
      stepSummary: 'nach {{days}} Tagen an {{to}}',
      sentTitle: 'Zuletzt gesendet',
      sentTable: 'Zuletzt gesendete Erinnerungen',
      sentEmpty: 'Noch keine Erinnerung gesendet.',
      sentAt: 'Übergeben',
      byPerson: 'von Hand',
      automatic: 'automatisch',
      state: 'Stand',
      states: {
        Pending: 'wartet',
        Preparing: 'wird vorbereitet',
        Ready: 'bereit',
        SubmittedUnknown: 'übergeben, unbestätigt',
        Sent: 'gesendet',
        Failed: 'fehlgeschlagen',
      },
    },
    importSettings: {
      autoRefreshTitle: 'Tägliches Aktualisieren',
      autoRefreshReadOnly: 'Nur wer die Projekte ändern darf, schaltet das tägliche Aktualisieren.',
      autoRefresh: 'Täglich ab 6 Uhr automatisch aktualisieren und bewerten',
      autoRefreshHint:
        'Die Plattform liest einmal täglich ab 6 Uhr (Berliner Zeit) alle offenen Tickets aus Jira und bewertet die neuen und geänderten; neue Tickets ab dem 1. des Vormonats.',
      autoSaveFailed: 'Die Einstellung konnte nicht gespeichert werden.',
      action: 'Projekte',
      add: 'Projekt hinzufuegen',
      allowedHint:
        'Diese Liste kommt aus der Jira-Bindung des Arbeitsbereichs und ist hier nicht aenderbar. Sie zu erweitern ist eine administrative Aenderung an der Bindung — ein Projekt, fuer das das Token nicht freigeschaltet ist, wuerde Jira ohnehin verweigern.',
      allowedLabel: 'Freigeschaltete Projekte',
      allowedNone: 'Keine — fuer diesen Arbeitsbereich ist kein Jira-Zugang eingerichtet.',
      allowedTitle: 'Was der Zugang erlaubt',
      duplicate: 'Dieses Projekt steht schon in der Liste.',
      description:
        'Welche Jira-Projekte "Aus Jira bewerten" liest. Die Auswahl kann nur EINGRENZEN, was der Jira-Zugang ohnehin erlaubt.',
      loadFailed: 'Die Projektauswahl konnte nicht geladen werden.',
      loading: 'Projektauswahl wird geladen',
      notAKey: 'Ein Jira-Projektschluessel besteht aus Grossbuchstaben und Ziffern, z. B. DS.',
      outsideCeiling:
        '{{keys}} ist nicht freigeschaltet und wird beim Lauf uebersprungen. Entweder aus der Liste nehmen oder die Jira-Bindung erweitern lassen.',
      projectKeys: 'Zu durchsuchende Projekte',
      readOnly: 'Dein Konto darf die Projektauswahl lesen, aber nicht aendern.',
      remove: '{{key}} entfernen',
      save: 'Auswahl speichern',
      saveFailed: 'Die Projektauswahl konnte nicht gespeichert werden.',
      savedNotice: 'Die Projektauswahl ist gespeichert.',
      selectionEmpty:
        'Keine Auswahl — der Lauf durchsucht alle freigeschalteten Projekte. Das ist das Verhalten ohne eigene Auswahl.',
      selectionEmptyHint: 'Noch nichts eingegrenzt.',
      selectionTitle: 'Eigene Auswahl',
      title: 'Jira-Projekte',
    },
    documents: {
      preview: 'Vorschau als PDF',
      previewOffice: 'Vorschau als Excel-/Word-Datei',
      template: 'Vorlage',
      templateChoice: {
        Customer: 'Vorlage v{{version}} ({{kind}}), die eigene Vorlage dieses Kunden',
        Language: 'Vorlage v{{version}} ({{kind}}), die allgemeine Vorlage in der Sprache des Kunden',
        Fallback:
          'Vorlage v{{version}} ({{kind}}), die bevorzugte allgemeine Vorlage — keine in der Sprache des Kunden',
      },
    },
    importer: {
      templateLanguage: 'Sprache der Vorlage',
      languageAuto: 'unbekannt — aus dem Text erkennen',
      languages: { de: 'Deutsch', en: 'Englisch' },
      templates: {
        title: 'Rechnungsvorlagen',
        description:
          'In der Regel wird jede Rechnung aus der allgemeinen Vorlage in der Sprache des Kunden gefüllt, Deutsch oder Englisch, mit einer Position je Ticket. Nur für einzelne Kunden legst du eine eigene Vorlage als Ausnahme fest. Ohne Vorlage in seiner Sprache bekommt ein Kunde die bevorzugte allgemeine Vorlage. Je Sprache ist eine Version bevorzugt.',
        groups: {
          de: 'Allgemein · Deutsch',
          en: 'Allgemein · Englisch',
          unknown: 'Allgemein · Sprache unbekannt',
          customer: 'Ausnahmen für einzelne Kunden',
        },
        groupEmpty: {
          de: 'Noch keine deutsche Vorlage. Lade unten eine hoch oder leite eine aus einem Beispiel ab.',
          en: 'Noch keine englische Vorlage. Lade unten eine hoch oder leite eine aus einem Beispiel ab.',
          customer:
            'Keine. Öffne eine Version und lege sie für einen Kunden fest, wenn er eine eigene braucht.',
        },
        version: 'Version',
        format: 'Format',
        origin: 'Herkunft',
        customer: 'Kunde',
        usage: 'Verwendung',
        general: 'Allgemein, {{language}}',
        generalOption: 'Allgemein (nach Sprache)',
        onlyFor: 'Nur für {{customer}}',
        customerHint:
          'Eine Ausnahme: Rechnungen an diesen Kunden werden immer aus dieser Version gefüllt, alle anderen aus der allgemeinen Vorlage.',
        kinds: { Html: 'HTML', Xlsx: 'Excel', Docx: 'Word' },
        fromSample: 'Beispiel {{key}} ({{customer}})',
        uploaded: 'Hochgeladen, ohne Beispiel',
        languageUnknown: 'unbekannt',
        open: 'Vorlage v{{version}} öffnen',
        download: 'Vorlage v{{version}} herunterladen',
        downloadShort: 'Herunterladen',
        uploadedNew: 'Die Vorlage wurde hochgeladen und ist jetzt die bevorzugte ihrer Sprache.',
        correctedNew: 'Die korrigierte Kopie von v{{version}} wurde als neue Version gespeichert.',
        preferredNow: 'Vorlage v{{version}} ist jetzt die bevorzugte ihrer Sprache.',
        languageSaved: 'Die Sprache der Vorlage v{{version}} wurde gespeichert.',
        languageFailed: 'Die Sprache konnte nicht gespeichert werden.',
        customerSet: 'Vorlage v{{version}} gilt jetzt nur für {{customer}}.',
        generalAgain: 'Vorlage v{{version}} ist wieder eine allgemeine Vorlage.',
        customerFailed: 'Die Verwendung konnte nicht gespeichert werden.',
        remove: 'Löschen',
        removeAria: 'Vorlage v{{version}} löschen',
        leaveTitle: 'Sprache der einzigen Vorlage ändern?',
        leaveDescription:
          'Vorlage v{{version}} ist die einzige allgemeine Vorlage in {{language}}. Ändert sich ihre Sprache, erhalten Kunden dieser Sprache die bevorzugte Vorlage einer anderen Sprache, bis eine neue bevorzugt ist.',
        leaveConfirm: 'Sprache ändern',
        removeTitle: 'Vorlage löschen?',
        removeDescription:
          'Vorlage v{{version}} wird endgültig gelöscht. Bereits erzeugte Rechnungen behalten ihre Dateien.',
        removed: 'Vorlage v{{version}} wurde gelöscht.',
        removeFailed: 'Die Vorlage konnte nicht gelöscht werden.',
        htmlSaved: 'Die bearbeitete Vorlage wurde als neue Version gespeichert.',
      },
      examples: {
        title: 'Prompt aus Beispielen ableiten',
        open: 'Prompt aus Beispielen ableiten',
        continue: 'Begonnene Ableitung fortsetzen',
        unfinished: 'Eine Ableitung vom {{date}} ist offen.',
        description:
          'Tickets mit ihrer Rechnung hinzufügen, die richtige Antwort prüfen, Schritte ableiten und an denselben Beispielen probieren. Übernehmen und Verwerfen löschen die Beispiele.',
        started: 'Diese Ableitung wurde am {{date}} begonnen.',
        examplesTitle: 'Beispiele',
        empty: 'Noch keine Beispiele. Füge unten ein Ticket mit seiner Rechnung hinzu.',
        runColumn: 'Probelauf',
        templateNone: 'Noch keine Vorlage aus dieser Rechnung',
        templateHint: 'Optional. Die Vorlage bleibt, wenn das Beispiel gelöscht wird.',
        dryRunHint: 'Mit dem Vorschlag, wie er unten steht, ungespeichert.',
        proposalTitle: 'Vorschlag',
        proposalHint: 'Startet mit der aktiven Version; dein Text bleibt Vorgabe für das Modell.',
        finishTitle: 'Abschließen',
        finishHint: 'In beiden Fällen werden die Beispiele gelöscht.',
        confirm: 'Übernehmen',
        discard: 'Verwerfen',
        back: 'Zurück zum Importer',
        cancel: 'Abbrechen',
        confirmTitle: 'Vorschlag übernehmen?',
        confirmDescription:
          'Der Vorschlag wird die aktive Version. Die Beispiele werden gelöscht, abgeleitete Vorlagen bleiben.',
        discardTitle: 'Ableitung verwerfen?',
        discardDescription:
          'Die Beispiele werden gelöscht, der Vorschlag verworfen. Version und Vorlagen bleiben.',
        changeNote_one: 'Aus {{count}} Beispiel abgeleitet',
        changeNote_other: 'Aus {{count}} Beispielen abgeleitet',
        confirmed: 'Version {{version}} ist aktiv. Die Beispiele wurden gelöscht.',
        discarded: 'Die Ableitung wurde verworfen und die Beispiele gelöscht.',
        discardFailed: 'Die Beispiele konnten nicht gelöscht werden.',
      },
      action: 'Importer',
      title: 'Importer',
      description:
        'Der Importer lernt aus dem, was du schon hast, statt konfiguriert zu werden: deine Kunden- und Bestellliste, Tickets mit den Rechnungen, die du dafuer geschrieben hast, und deine Regeln in eigenen Worten. Die Rechnungen werden die Vorlagen. Heraus kommt ein Prompt, den das Modell fuer jedes Ticket liest — lesbar, aenderbar, versioniert — und ein Probelauf zeigt, was die aktuelle Version aus deinen Beispielen macht.',
      loading: 'Importer wird geladen',
      loadFailed: 'Der Importer konnte nicht geladen werden.',
      readOnly: 'Dein Konto darf den Importer lesen, aber nicht aendern.',
      noAi: 'Es ist kein Sprachmodell-Zugang eingerichtet. Listen und Beispiele hinzufuegen geht auch ohne, aber Spalten beschreiben, Vorlagen markieren, Erzeugen und Probelaeufe brauchen ein Modell.',
      noAiAction: 'Zugang einrichten',
      openShort: 'Oeffnen',
      lists: {
        orderListReconcile:
          'Diese Bestellliste wird nicht ersetzt: Gleiche die Datei mit „Datei abgleichen“ an der Liste oben ab, dort entscheidest du je geänderter Bestellung. Für andere Spalten die Liste zuerst entfernen.',
        title: 'Kunden und Bestellungen',
        movedHint:
          'Die Kundenliste und die Bestelllisten werden dort hochgeladen und bestätigt, wo sie gebraucht werden: auf der Seite Kunden und auf der Seite Bestellungen.',
        toCustomers: 'Kunden',
        toOrders: 'Bestellungen',
        customersTitle: 'Kundenliste (Datei)',
        customersDescription:
          'Deine Kundenliste als Excel oder CSV, genau so, wie sie ist. Das Modell schlägt vor, was jede Spalte bedeutet; du bestätigst oder korrigierst darunter. Das Bestätigen importiert ihre Zeilen als Kunden — zugeordnet über die Kundennummer, dann über den Namen.',
        ordersTitle: 'Bestelllisten (Dateien)',
        ordersDescription:
          'Deine Bestellliste als Excel oder CSV, genau so, wie sie ist. Das Modell schlägt vor, was jede Spalte bedeutet und welches Feld sie ist; du bestätigst oder korrigierst darunter. Von da an liest die Abrechnung die Bestellungen, und du pflegst sie in den Listen oben.',
        noneOfKind: 'Noch keine Liste hochgeladen.',
        otherTitle: 'Weitere Listen',
        otherDescription:
          'Listen, die weder Kunden- noch Bestellliste sind, etwa eine Preisliste. Die Abrechnung liest sie nicht; gibst du einer Spalte den Kundennamen oder die Bestellnummer, wird die Liste zur Kunden- oder Bestellliste.',
        otherRolesHint:
          'Neben jeder Spalte: das Feld, das sie füllt, wo sie eines der Felder ist, die eine Rechnung braucht.',
        listChanged:
          'Unter „{{label}}“ wurde inzwischen eine andere Liste gespeichert. Die Listen oben sind jetzt aktuell; prüfe sie und wähle die Datei erneut.',
        labelTaken:
          'Eine Liste namens „{{label}}“ wird auf einer anderen Seite gepflegt. Benenne die Datei um und wähle sie erneut.',
        orderRolesHint:
          'Neben jeder Spalte: das Bestellfeld, das sie füllt, wo die Abrechnung es liest — Bestellnummer, Kunde, offen, Tagessatz. Eine Bestellliste legt nie Kunden an; der Kunde wird in den Stammdaten gefunden.',
        noOrderNumberColumn:
          'Noch keine Spalte ist die Bestellnummer; ohne sie ist die Liste keine Bestellliste.',
        description:
          'Deine Kundenliste und deine Bestellliste als Excel oder CSV, genau so, wie sie sind. Das Modell schlaegt vor, was jede Spalte bedeutet und welche Spalte einen Datensatz benennt; du bestaetigst oder korrigierst rechts. Von da an liest der Import sie, um zu fuellen, was ein Ticket nicht sagt, und jeder Wert aus einer Liste wird auf der Rechnung benannt.',
        empty: 'Noch keine Listen. Beide sind optional; der Import funktioniert auch aus dem Ticket allein.',
        customers: 'Kunden',
        orders: 'Bestellungen',
        chooseCustomers: 'Kundenliste waehlen (Excel oder CSV)',
        chooseOrders: 'Bestellliste waehlen (Excel oder CSV)',
        headerOnlyHint:
          'Die erste Zeile benennt die Spalten. Die Kopfzeile allein genuegt, wenn du keine Kundendaten weitergeben willst; die Datei waehlen laedt sie hoch.',
        replaceHint:
          'Jede Datei wird eine eigene Liste mit dem Namen der Datei. Dieselbe Datei erneut ersetzt ihre Liste, solange sie unbestätigt ist; eine bestätigte Liste gleichst du mit „Datei abgleichen“ ab.',
        label: 'Liste',
        file: 'Datei',
        records: 'Datensaetze',
        recordsCount: '{{count}} Datensaetze',
        state: 'Spalten',
        confirmedState: 'bestaetigt',
        proposedState: 'vorgeschlagen, bitte pruefen',
        open: '{{label}} oeffnen',
        remove: '{{label}} entfernen',
        removeFailed: 'Die Liste konnte nicht entfernt werden.',
        addFailed: 'Die Liste konnte nicht hochgeladen werden.',
        added: '{{label}} wurde hochgeladen. Bitte pruefe, was die Spalten bedeuten.',
        addedAwaitingOrderNumber:
          '{{label}} wurde hochgeladen. Noch ist keine Spalte die Bestellnummer: Wähle sie unten und bestätige. Bis dahin steht die Liste unter „Weitere Listen“ auf der Seite Importer.',
        columnsTab: 'Spalten',
        recordsTab: 'Datensaetze',
        meaningsTitle: 'Was die Spalten von {{label}} bedeuten',
        meaningsHint:
          'Ein Satz je Spalte, wie das Modell ihn vorgeschlagen hat oder wie du es einer neuen Kollegin erklaeren wuerdest. Lass eine Spalte leer, wenn sie fuer Rechnungen nicht zaehlt. Die Schluesselspalte ist die, deren Wert einen Datensatz benennt, etwa die Kunden- oder Bestellnummer.',
        keyColumnField: 'Schluesselspalte',
        noKey: 'keine Schluesselspalte',
        rolesHint:
          'Neben jeder Spalte: das Kundenfeld, das sie fuellt, wo sie eines der Felder ist, die eine Rechnung braucht. Das Bestaetigen einer Liste mit einer Namensspalte importiert ihre Zeilen als bestaetigte Kunden — zugeordnet ueber die Kundennummer, dann ueber den Namen, sodass ein Kunde, den ein Import aus einem Ticket angelegt hat, vervollstaendigt statt doppelt angelegt wird.',
        roleOf: 'Feld fuer {{column}}',
        typeOf: 'Eingabe als, {{column}}',
        typeSuggested: 'Vorschlag aus den Werten der Spalte; gilt, sobald du bestätigst.',
        typesHint:
          'Auf einer Bestellliste legt die zweite Auswahl fest, wie ein Feld der Bestellung auf der Seite Bestellungen von Hand eingegeben wird: als Betrag, als Datum oder als einer der Werte, die die Spalte schon enthaelt. Offen und Tagessatz sind immer Betraege.',
        types: {
          Text: 'Text',
          Money: 'Betrag',
          Date: 'Datum',
          Choice: 'Auswahl aus den vorhandenen Werten',
        },
        noNameColumn:
          'Noch keine Spalte ist der Kundenname; ohne sie importiert das Bestaetigen keine Kunden.',
        roleTwice: 'Mehreren Spalten zugeordnet: {{fields}}. Nur die erste Spalte wird gelesen.',
        rolesMissing:
          'Keine Spalte fuellt diese Kundenfelder: {{fields}}. Sie bleiben bei importierten Kunden leer.',
        roles: {
          None: 'keines — nur das Modell liest es',
          OrderNumber: 'Bestellnummer (Bestellliste)',
          CustomerName: 'Kundenname, wie diese Liste ihn schreibt (Bestellliste)',
          OpenAmount: 'Offen — Restbetrag netto, sinkt mit jeder zugestellten Rechnung (Bestellliste)',
          DayRate: 'Tagessatz netto — die Abrechnung nach Tagessatz teilt den Betrag dadurch (Bestellliste)',
          CashDiscount:
            'Skonto, z. B. „3% 14 Tage“ oder „nein“ — steht auf der Rechnung und in der E-Rechnung (Bestellliste)',
          CustomerNumber: 'Kundennummer',
          Name: 'Name (die formelle Firmenbezeichnung)',
          Street: 'Strasse',
          Postcode: 'PLZ',
          City: 'Ort',
          Country: 'Land (Zwei-Buchstaben-Code)',
          VatId: 'USt-ID',
          PaymentTermDays: 'Zahlungsziel (Tage)',
          Language: 'Rechnungssprache',
          BillingEmail: 'Rechnungs-E-Mail',
          AddressAddition: 'Adresszusatz (Abteilung, c/o)',
          ShortName: 'Kurzname',
          DunningEmails: 'Mahn-E-Mail (eine oder mehrere Adressen)',
          AccountManagerEmail: 'Kundenverantwortlich (eine interne E-Mail-Adresse)',
          Region: 'Steuerregion (DE, EU, Nicht-EU)',
        },
        importWarnings: {
          BillingEmailFirstOfMany:
            '{{customer}}: Als Rechnungs-E-Mail gilt die erste von {{count}} Adressen — eine Rechnung geht an eine.',
          DunningEmailNotTaken:
            '{{customer}}: „{{value}}“ ist keine E-Mail-Adresse und wurde nicht als Mahnadresse übernommen.',
          AccountManagerEmailNotTaken:
            '{{customer}}: „{{value}}“ ist nicht genau eine E-Mail-Adresse und wurde nicht als Kundenverantwortliche übernommen.',
        },
        compare: {
          title: 'Abgleich mit den Kunden: {{label}}',
          hint: 'Noch ist nichts geändert. Hier siehst du, was die Liste an den Kunden ändert: Zeilen, die so nicht übernommen werden können, korrigierst du direkt, und bei jedem geänderten Feld entscheidest du, ob die Liste oder der vorhandene Wert gilt. Kunden, die die Liste nicht nennt, bleiben, wie sie sind. Erst „Übernehmen“ ändert etwas.',
          compareFailed: 'Die Liste konnte nicht mit den Kunden verglichen werden.',
          applyFailed: 'Die Liste konnte nicht übernommen werden.',
          changedMeanwhile:
            'Seit dem Vergleich hat sich die Liste oder ein Kunde geändert. Der Vergleich ist neu gezogen — bitte prüfe ihn noch einmal.',
          summary:
            '{{new}} neu · {{changed}} geändert · {{unchanged}} unverändert · {{notTaken}} so nicht übernehmbar · {{skipped}} ausgelassen · {{notInList}} Kunde(n) nicht in der Liste (bleiben)',
          problemsTitle: 'Zeilen zum Prüfen',
          row: 'Zeile',
          problem: 'Was auffällt',
          correction: 'Korrektur',
          problems: {
            NameMissing:
              'Kein Firmenname, und unter der Kundennummer ist kein Kunde bekannt — so wird die Zeile nicht übernommen.',
            NumberRepeated:
              'Die Kundennummer {{detail}} steht schon in einer früheren Zeile; es gilt die erste, diese wird nicht übernommen.',
            Refused: 'So kein gültiger Kunde, die Zeile wird nicht übernommen: {{detail}}',
            OtherNumber:
              'Der Name passt zu {{customer}}, der die Kundennummer {{detail}} hat; die Liste nennt eine andere.',
            CustomerRepeated:
              'Zeile {{detail}} ist schon dieser Kunde; es gilt die frühere, diese wird nicht übernommen. Ist es ein anderer Kunde, ändere Name oder Kundennummer.',
          },
          nameSuggested: 'Vorschlag aus dem Kurznamen — bitte prüfen.',
          fieldOf: '{{field}}, Zeile {{row}}',
          changedTitle: 'Geänderte Kunden',
          customer: 'Kunde',
          differences: 'Unterschiede (vorhanden → Liste) und was gilt',
          difference: '{{field}}: {{ours}} → {{list}}',
          decisionFor: 'Was gilt für {{field}} bei {{customer}}',
          takeList: 'Liste',
          keepOurs: 'Vorhanden',
          allList: 'Alles aus der Liste',
          allOurs: 'Alles Vorhandene behalten',
          matchFor: 'Zuordnung von Zeile {{row}}',
          sameCustomer: 'Derselbe Kunde',
          newCustomer: 'Neuer Kunde',
          unmatched: 'Entscheide noch für {{count}} Zeile(n), ob es derselbe Kunde oder ein neuer ist.',
          rowAction: 'Zeile',
          skip: 'Nicht übernehmen',
          skipRow: 'Zeile {{row}} nicht übernehmen',
          unskip: 'Zeile {{row}} wieder übernehmen',
          skippedList: 'Ausgelassen:',
          newList: 'Neu: {{names}}',
          notInList: 'Nicht in der Liste, bleiben unverändert: {{names}}',
          none: '—',
          recheck: 'Korrekturen prüfen',
          apply: 'Übernehmen',
          cancel: 'Abgleich abbrechen',
          done: '{{label}} übernommen: {{created}} Kunde(n) angelegt, {{updated}} aktualisiert, {{skipped}} Zeile(n) nicht übernommen.',
        },
        customersImported:
          '{{label}} bestaetigt: {{created}} Kunde(n) angelegt, {{updated}} vervollstaendigt, {{skipped}} Zeile(n) uebersprungen.',
        confirm: 'Spalten bestaetigen',
        confirmFailed: 'Die Spalten konnten nicht gespeichert werden.',
        confirmed: 'Die Spalten von {{label}} sind bestaetigt.',
        recordsTitle: 'Datensaetze von {{label}}',
        recordsShown: '{{shown}} von {{total}} angezeigt',
        recordsFailed: 'Die Datensaetze konnten nicht geladen werden.',
        noRecords: 'Diese Liste hat nur eine Kopfzeile.',
        recordActions: 'Aktion',
        recordRow: 'Zeile {{row}}',
        recordEdit: '{{record}} bearbeiten',
        recordEditShort: 'Bearbeiten',
        recordSave: 'Speichern',
        recordCancel: 'Abbrechen',
        recordSaveFailed: 'Der Datensatz konnte nicht gespeichert werden.',
        recordDelete: '{{record}} loeschen',
        recordDeleteShort: 'Loeschen',
        recordDeleteTitle: 'Diesen Datensatz loeschen?',
        recordDeleteDescription:
          '{{record}} wird aus der Liste {{label}} entfernt. Rechnungen, die ihn bereits nennen, behalten ihn; der Import findet den Datensatz nur nicht mehr. Ein erneuter Upload der Datei bringt alle Datensaetze zurueck.',
        recordDeleteFailed: 'Der Datensatz konnte nicht geloescht werden.',
      },
      sampleTicket: 'Ticket',
      sampleCustomer: 'Kunde',
      sampleCustomerNone: 'nicht hinterlegt',
      sampleInvoice: 'Rechnung',
      sampleActions: 'Aktion',
      openSample: 'Beispiel {{key}} oeffnen',
      removeSample: '{{key}} entfernen',
      removeSampleShort: 'Entfernen',
      removeFailed: 'Das Beispiel konnte nicht entfernt werden.',
      addTitle: 'Beispiel hinzufuegen',
      issueKey: 'Ticketschluessel',
      invoiceFile: 'Rechnung waehlen (Excel, Word oder PDF)',
      invoiceHint:
        'Optional: die Rechnung, die du fuer dieses Ticket verschickt hast. Sie zeigt dem Importer, wie die richtige Antwort aussieht — und wer der Kunde ist — und sie wird deine Vorlage.',
      add: 'Beispiel hinzufuegen',
      addFailed: 'Das Beispiel konnte nicht hinzugefuegt werden.',
      added: '{{key}} wurde hinzugefuegt.',
      saveExpected: 'Richtige Antwort speichern',
      previewOpen: 'Vorschau in neuem Tab oeffnen ({{what}})',
      saveExpectedFailed: 'Die Erwartung konnte nicht gespeichert werden.',
      close: 'Schliessen',
      templateTitle: 'Vorlage aus dieser Rechnung',
      templateWarnings:
        'Sieht noch nach einem Wert dieser einen Rechnung aus, nicht nach einer Vorlage — Zelle oeffnen und entscheiden:',
      templateVersion: 'Vorlage v{{version}}',
      templatePreferred: 'bevorzugt',
      kinds: {
        Html: 'HTML, vom Modell geschrieben',
        Xlsx: 'Excel, deine eigene Arbeitsmappe',
        Docx: 'Word, dein eigenes Dokument',
      },
      prefer: 'Diese Vorlage bevorzugen',
      preferFailed: 'Die Vorlage konnte nicht bevorzugt werden.',
      derive: 'Vorlage ableiten',
      deriveAgain: 'Vorlage neu ableiten',
      deriveFailed: 'Die Vorlage konnte nicht abgeleitet werden.',
      derived: 'Vorlage v{{version}} wurde abgeleitet.',
      downloadTemplate: 'Vorlage herunterladen',
      uploadCorrected: 'Korrigierte Vorlage hochladen',
      uploadTemplate: 'Fertige Vorlage hochladen',
      dryRunTitle: 'Probelauf',
      dryRunNotYet: 'noch nicht gelaufen',
      uploadTemplateHint:
        'Eine Excel- oder Word-Datei, die schon {{…}}-Platzhalter traegt — von Hand markiert oder hier heruntergeladen und korrigiert. Sie wird die bevorzugte Vorlage; eine Datei ohne Platzhalter gehoert zu einem Beispiel.',
      templateUploadFailed: 'Die Vorlage konnte nicht hochgeladen werden.',
      correctedHint:
        'Die heruntergeladene Vorlage, in Excel oder Word korrigiert: Platzhalter wie {{buyer.name}}, {{invoice.number}} oder {{net}} in der Positionszeile verschieben oder ergaenzen. Die Datei waehlen laedt sie als naechste Version hoch.',
      correctedFailed: 'Die korrigierte Vorlage konnte nicht gespeichert werden.',
      templateHtml: 'Vorlage (HTML mit Platzhaltern)',
      templateSave: 'Geaenderte Vorlage als neue Version speichern',
      templateSaveFailed: 'Die Vorlage konnte nicht gespeichert werden.',
      previewOffice: 'Vorschau als Excel-/Word-Datei herunterladen ({{what}})',
      templatePreview: 'Vorschau: {{key}} durch die Vorlage',
      instructionsTitle: 'Der Importer, Schritt fuer Schritt',
      instructionsHint:
        'Jeder Import geht fuenf Schritte; oeffne einen Schritt, um den Text zu lesen oder zu aendern, den das Modell dafuer bekommt. Schreib ihn selbst oder lass ihn mit „Aus Beispielen ableiten" aus deinen Beispielen schreiben: dein aktueller Text wird behalten und eingearbeitet, nie verworfen. Gespeichert wird erst mit „Speichern"; der gespeicherte Text bleibt unter einem geaenderten Feld zum Vergleich sichtbar. Speichern legt alle fuenf als eine neue Version ab.',
      steps: {
        Ready: 'Abzurechnen?',
        Order: 'Bestellung',
        Customer: 'Kunde',
        Invoice: 'Leistung und Betrag',
        Promotion: 'Abrechnungsreif',
      },
      candidatesTitle: 'Vorauswahl in Jira (JQL)',
      candidatesHint:
        'Die JQL-Klausel, die der Sammelimport beim Lesen aus Jira zu Projekt und Zeitraum hinzufuegt — der gespeicherte Filter Ihrer Finanzbuchhaltung, ohne sein ORDER BY. Das Modell liest sie nie: Sie entscheidet, welche Tickets das Modell ueberhaupt sieht. Leer heisst Plattform-Standard: Kosten gesetzt und noch nicht als fakturiert markiert.',
      candidatesEmpty: 'leer — der Plattform-Standard gilt',
      deriveStep: 'Aus Beispielen ableiten',
      deriveStepAria: '„{{step}}" aus Beispielen ableiten',
      deriveAll: 'Alle fuenf aus Beispielen ableiten',
      stepDeriveFailed: 'Der Schritt konnte nicht abgeleitet werden.',
      stepDerived: 'Vorschlag fuer „{{step}}" geschrieben; vergleichen und speichern.',
      saveSteps: 'Als neue Version speichern',
      savedText: 'Gespeicherter Text (Version {{version}})',
      savedEmpty: 'Gespeichert: leer',
      nothingToSave: 'Nichts gegenueber der aktiven Version geaendert.',
      stepEmpty: 'leer — es gilt der Standard des Rahmens',
      stepChanged: 'geaendert, nicht gespeichert',
      removeVersion: 'Version {{version}} entfernen',
      removeVersionFailed: 'Die Version konnte nicht entfernt werden.',
      stepHints: {
        Ready:
          'Welche Tickets ueberhaupt abgerechnet werden und welche ignoriert. Z. B. „Das Feld Abrechnen muss ja sein."',
        Order:
          'Wie die Bestellung zum Ticket in deiner Bestellliste gefunden wird. Z. B. „Nach Bestellnummer, sonst Angebots-Nr, sonst Ticket-Key, sonst Kunde; bei mehreren die mit dem aeltesten Termin, deren offen groesser als der Ticketpreis ist."',
        Customer:
          'Wer die Rechnung bekommt. Z. B. „Die Firma auf der Bestellung, nicht der im Ticket genannte Konzern."',
        Invoice:
          'Positionen, Betraege, Referenzen, Zahlungsziel, Bemerkungen. Z. B. „Kosten ist der Nettobetrag; die Beschreibung ist die Zusammenfassung."',
        Promotion:
          'Wann ein Entwurf direkt zur Freigabe darf. Z. B. „Nur wenn der Kunde in einem Kommentar zugestimmt hat."',
      },
      instructionsChangedNote: 'Schritte bearbeitet',
      generated: 'Version {{version}} ist jetzt aktiv.',
      activeTitle: 'Aktive Version',
      noVersion: 'Noch kein Importer. Fuege Beispiele hinzu und erzeuge einen.',
      version: 'Version {{version}}',
      createdAt: 'Erstellt',
      changeNoteLabel: 'Aenderung',
      savePromptFailed: 'Die Version konnte nicht gespeichert werden.',
      versionsTitle: 'Versionen',
      versionColumn: 'Version',
      activeColumn: 'Zustand',
      active: 'aktiv',
      inactive: '—',
      activate: 'Version {{version}} aktivieren',
      activateShort: 'Aktivieren',
      activateFailed: 'Die Version konnte nicht aktiviert werden.',
      dryRunSample: 'Probelauf fuer dieses Beispiel',
      dryRunFailed: 'Der Probelauf ist fehlgeschlagen.',
      dryRunFailure: 'Kein Dokument: {{failure}}',
      dryRunMatches: 'stimmt mit der Erwartung ueberein',
      dryRunDiffers: '{{count}} Abweichung(en) von der Erwartung',
      dryRunTable: '{{key}}: Probelauf',
      dryRunField: 'Feld',
      dryRunExpected: 'Richtige Antwort',
      dryRunExtracted: 'Probelauf',
      dryRunSame: '✓ gleich',
      dryRunWhy: 'Warum',
      dryRunStep: 'Schritt',
      fieldNames: {
        ready: 'Abzurechnen',
        order: 'Bestelldatensatz',
        recipient: 'Empfaenger',
        description: 'Positionen',
        netTotal: 'Netto gesamt',
        orderNumber: 'Bestellnummer',
        paymentTermDays: 'Zahlungsziel (Tage)',
        notes: 'Bemerkungen',
        currency: 'Waehrung',
        readiness: 'Reife',
      },
      previewExpectedShort: 'die richtige Antwort',
      previewRunShort: 'den letzten Probelauf',
      rightAnswerTitle: 'Die richtige Antwort fuer dieses Ticket',
      rightAnswerHint:
        'Was der Import erzeugen soll. Vom Modell aus Ticket und deiner Rechnung gelesen, als das Beispiel hinzukam; korrigiere hier, wo es falsch ist. Unter jedem Feld: was der letzte Probelauf extrahiert hat, und warum.',
      rightAnswerSaved: 'Die richtige Antwort fuer {{key}} ist gespeichert.',
      customerNotOnFile: 'nicht hinterlegt — Namen eintragen',
      fields: {
        recipient: 'Empfaenger',
        recipientName: 'Name des Empfaengers',
        lineDescription: 'Position {{position}}: Bezeichnung',
        lineQuantity: 'Position {{position}}: Menge',
        lineNet: 'Position {{position}}: Netto',
        removeLine: 'Position {{position}} entfernen',
        addLine: 'Position hinzufuegen',
        netTotal: 'Netto gesamt',
        orderNumber: 'Bestellnummer',
        paymentTermDays: 'Zahlungsziel (Tage)',
        notes: 'Bemerkungen',
        readiness: 'Reife',
      },
      none: '—',
      verdict: 'Urteil des Importers',
      reasoning: 'Begruendung des Modells',
      readiness: {
        ReadyForApproval: 'freigabebereit',
        NeedsRefinement: 'nachschaerfen',
        NotBillable: 'nicht abzurechnen',
        Billable: 'abzurechnen',
      },
    },
    listColumns: {
      numberAndDate: 'Nummer · Datum',
      net: 'Netto',
      open: 'Offen',
      openShort: 'reicht nicht',
      order: 'Bestellung {{order}}',
      dueOn: 'faellig {{date}}',
    },
    bulkInvoices: {
      selectOne: '{{number}} waehlen',
      selectAll: 'Alle waehlen',
    },
    tickets: {
      orderShort: 'nur {{open}} offen',
      orderShortHelp:
        'Die Bestellung hat noch {{open}} offen; ihre offenen Tickets und noch nicht zugestellten Rechnungen ergeben {{pending}} netto.',
      title: 'Tickets',
      action: 'Tickets',
      description:
        'Jedes Ticket wird einmal beurteilt und mit seinem Urteil aufbewahrt. Ein abrechnungsreifes Ticket wird auf der Seite Rechnungen unter „Abrechnungsreife Tickets“ abgerechnet; eines, das nachgeschaerft werden muss, sagt auf seiner Seite, was noch fehlt.',
      loading: 'Tickets werden geladen',
      loadingOne: 'Das Ticket wird geladen',
      loadFailed: 'Die Tickets konnten nicht geladen werden.',
      empty: 'Noch kein Ticket beurteilt',
      emptyDescription:
        'Ueber "Aus Jira bewerten" einen Zeitraum aus Jira lesen und die Bewertung starten. Nichts geht zweimal an ein Modell: ein unveraendertes Ticket wird uebersprungen.',
      ticket: 'Ticket',
      state: 'Zustand',
      summary: 'Leistung',
      customer: 'Kunde',
      order: 'Bestellung',
      amount: 'Betrag',
      quantity: 'Menge',
      openPoints: 'Offene Punkte',
      openInJira: 'In Jira oeffnen',
      keys: 'Zu bewertende Ticketnummern',
      keysRequired: 'Nenne mindestens eine Ticketnummer.',
      assess: 'Tickets bewerten',
      assessHint:
        'Nummern durch Leerzeichen oder Kommas trennen. Ein Ticket, dessen Inhalt und Importer-Version sich seit der letzten Bewertung nicht geaendert haben, wird ohne Modellaufruf uebersprungen.',
      remove: 'Aus der Ticketliste entfernen',
      removeTitle: 'Ticket entfernen',
      removeHint:
        'Fuer ein Ticket, das nicht in diese Liste gehoert, etwa aus einem Test oder einer vertippten Nummer. In Jira aendert sich nichts; wird das Ticket spaeter wieder bewertet, erscheint es erneut.',
      removeDescription:
        '{{key}} wird mit seiner Checkliste aus der Ticketliste entfernt. Das Ticket in Jira bleibt unveraendert.',
      removeConfirm: 'Entfernen',
      removeCancel: 'Abbrechen',
      removeFailed: 'Das Ticket konnte nicht entfernt werden.',
      byPerson: '(von Hand gesetzt)',
      selectOne: '{{key}} abrechnen',
      invoice: 'Rechnung',
      openInvoice: 'Rechnung oeffnen',
      billOne: 'Rechnung erzeugen',
      billFailed: 'Die Rechnung konnte nicht erzeugt werden.',
      progress:
        '{{todo}} zu bearbeiten · {{ready}} abrechnungsreif · {{notBillable}} nicht abzurechnen · {{billed}} mit erstellter Rechnung',
      sections: {
        new: 'Neue Tickets ({{count}})',
        newNotRead: '"Aktualisieren" liest die neuen Tickets aus Jira.',
        newEmpty: 'Seit {{since}} ist kein neues Ticket in Jira erledigt, das der Vorauswahl entspricht.',
        newHint:
          'In Jira erledigt und noch nie bewertet. Aktualisieren bewertet sie sofort, danach steht jedes in seinem Abschnitt darunter; eines, das nicht bewertet werden konnte, bleibt hier.',
        newTable: 'Neue Tickets',
        changed: 'Geaenderte Tickets ({{count}})',
        changedHint:
          'In Jira seit ihrer Bewertung geändert oder mit einem älteren Prompt bewertet. Aktualisieren bewertet sie sofort neu; bis dahin gilt ihr bisheriges Urteil nicht mehr, und sie werden weder abgerechnet noch erinnert.',
        changedTable: 'Geaenderte Tickets',
        todo: 'Zu bearbeiten ({{count}})',
        todoHint:
          'Diese Tickets haben offene Punkte. Oeffne ein Ticket, klaere, was fehlt (in Jira oder mit "Neu bewerten"), dann steht es auf der Seite Rechnungen unter „Abrechnungsreife Tickets“.',
        todoEmpty: 'Nichts zu bearbeiten.',
        todoTable: 'Zu bearbeitende Tickets',
        readyOnInvoices: 'Abrechnungsreife Tickets ({{count}})',
        readyHint:
          'Waehle Tickets und erzeuge die Rechnungen: eine je Kunde und Bestellung, eine Position je Ticket. Jede Rechnung erhaelt dabei ihre Nummer.',
        readyHintReadOnly:
          'Diese Tickets koennen abgerechnet werden. Rechnungen erzeugt, wer Rechnungen freigeben darf.',
        readyEmpty: 'Noch kein Ticket abrechnungsreif.',
        readyTable: 'Abrechnungsreife Tickets',
        notBillable: 'Nicht abzurechnen ({{count}})',
        notBillableSummary:
          'Tickets, die nach den Regeln nicht in Rechnung gestellt werden, etwa bereits fakturierte.',
        notBillableEmpty: 'Kein Ticket.',
        notBillableTable: 'Nicht abzurechnende Tickets',
        billed: 'Rechnung erstellt ({{count}})',
        billedSummary: 'Tickets auf einer erstellten Rechnung; ob sie versandt ist, zeigt „Rechnungen“.',
        billedEmpty: 'Noch für kein Ticket eine Rechnung erstellt.',
        billedTable: 'Tickets mit erstellter Rechnung',
      },
      invoicesLink: 'Rechnungen',
      refresh: 'Aktualisieren',
      refreshFailed: 'Die Tickets konnten nicht aus Jira gelesen werden.',
      refreshed: '{{checked}} Tickets aus Jira gelesen, {{changed}} seit ihrer Bewertung geaendert.',
      refreshUnreadable: 'Nicht lesbar: {{keys}}.',
      changedInJiraDetail:
        'In Jira seit der Bewertung geaendert (festgestellt {{at}}). Neu bewerten, bevor das Ticket abgerechnet wird.',
      otherImporterVersionDetail:
        'Mit einem älteren Prompt bewertet — der Importer wurde seitdem geändert. Neu bewerten, bevor das Ticket abgerechnet wird.',
      olderPrompt: '(älterer Prompt)',
      bill_one: '{{count}} Rechnung erzeugen',
      bill_other: '{{count}} Rechnungen erzeugen',
      billSelection_one: '{{count}} Ticket gewaehlt; eine Rechnung je Kunde und Bestellung.',
      billSelection_other: '{{count}} Tickets gewaehlt; eine Rechnung je Kunde und Bestellung.',
      issueDate: 'Rechnungsdatum (bestimmt auch den Monat der Rechnungsnummer)',
      billed_one: '{{count}} Rechnung erzeugt.',
      billed_other: '{{count}} Rechnungen erzeugt.',
      billSkipped: 'Nicht abgerechnet: {{reasons}}',
      since: 'Tickets seit (in Jira erledigt ab)',
      sinceHint:
        '"Aktualisieren" liest die seit diesem Tag in Jira erledigten Tickets unter Ihrer Vorauswahl (Importer-Seite), prüft alle bewerteten Tickets auf Änderungen und bewertet die neuen und geänderten sofort.',
      refreshedNew_one: '{{count}} neues Ticket seit {{since}}.',
      refreshedNew_other: '{{count}} neue Tickets seit {{since}}.',
      progressChanged: '{{fresh}} neu · {{changed}} geaendert',
      previousVerdict: 'Bisheriges Urteil',
      assessOne: '{{key}} bewerten',
      organization: 'Organisation',
      cost: 'Kosten (netto)',
      billingStatus: 'Billing process status',
      assessChosen_one: '{{count}} Ticket bewerten',
      assessChosen_other: '{{count}} Tickets bewerten',
      reassessChosen_one: '{{count}} Ticket neu bewerten',
      reassessChosen_other: '{{count}} Tickets neu bewerten',
      lastRefresh: 'Stand aller offenen Tickets: {{when}}',
      neverRefreshed: 'Noch nicht aktualisiert',
      lastRead: 'Stand {{when}}',
      retryHint:
        'Das Modell konnte seine Antwort nicht beenden. Mit weniger Aufwand denkt es vor der Antwort kürzer nach, dann passt die Antwort meist.',
      retryMedium_one: '{{count}} Ticket mit mittlerem Aufwand neu bewerten',
      retryMedium_other: '{{count}} Tickets mit mittlerem Aufwand neu bewerten',
      retryLow_one: '{{count}} Ticket mit geringem Aufwand neu bewerten',
      retryLow_other: '{{count}} Tickets mit geringem Aufwand neu bewerten',
      remindersSentHeader: 'Erinnert',
      nextReminderHeader: 'Nächste Erinnerung',
      nextReminderOn: 'Schritt {{step}} am {{date}}',
      nextReminderDue: 'Schritt {{step}}, fällig seit {{date}}',
      nextReminderThrough: 'Alle Schritte gesendet',
      nextReminderHeld: {
        AssigneeWithoutAddress: 'Angehalten: Jira nennt keine E-Mail-Adresse',
        NothingForAssignee: 'Angehalten: nichts für die Zuständigen',
        NothingToAsk: 'Angehalten: erst neu bewerten',
        TicketNotDone: 'Angehalten: Ticket in Jira nicht abgeschlossen',
      },
      chooseAll: 'Alle in „{{table}}“ wählen',
      remindOne: '{{key}} erinnern',
      remindChosen_one: '{{count}} Ticket jetzt erinnern',
      remindChosen_other: '{{count}} Tickets jetzt erinnern',
      remindNothing_one: 'Bei {{count}} Ticket war nichts mehr zu senden.',
      remindNothing_other: 'Bei {{count}} Tickets war nichts mehr zu senden.',
      remindBlocked_one: '{{count}} Erinnerung zurückgehalten (siehe Erinnerungen).',
      remindBlocked_other: '{{count}} Erinnerungen zurückgehalten (siehe Erinnerungen).',
      chooseOne: '{{key}} wählen',
      rederiveChosen_one: '{{count}} Ticket neu ableiten',
      rederiveChosen_other: '{{count}} Tickets neu ableiten',
      rederiveHint:
        'Neu ableiten wendet die aktuellen Regeln und Bestelllisten auf die gespeicherte Bewertung an – ohne Jira und ohne Modellaufruf.',
      rederived_one: '{{count}} Ticket neu abgeleitet.',
      rederived_other: '{{count}} Tickets neu abgeleitet.',
      rederiveLeft: 'Unverändert (abgerechnet, auf einer Rechnung oder ohne Bewertung): {{keys}}',
      rederiveFailed: 'Die Tickets konnten nicht neu abgeleitet werden.',
      assessRunning: 'Bewerte {{done}}/{{total}} …',
      assessProgress: '{{done}} von {{total}} Tickets bearbeitet.',
      assessStopped:
        'Die Bewertung ist nach {{done}} von {{total}} Tickets abgebrochen. Die beurteilten sind gespeichert; ein neuer Start ueberspringt sie.',
      byKey: 'Ticket nach Nummer bewerten',
      byKeySummary: 'Auch offene Tickets, die noch nicht erledigt sind und darum kein Datum findet.',
      reassess: 'Neu bewerten',
      reassessFailed: 'Das Ticket konnte nicht neu bewertet werden.',
      reassessed: 'Das Ticket wurde neu bewertet.',
      runDone: '{{assessed}} bewertet, {{skipped}} uebersprungen, {{failed}} fehlgeschlagen.',
      states: {
        NeedsRefinement: 'nachschaerfen',
        ReadyForBilling: 'abrechnungsreif',
        NotBillable: 'nicht abzurechnen',
        Billed: 'Rechnung erstellt',
      },
      notFound: 'Dieses Ticket gehoert nicht zu diesem Arbeitsbereich oder existiert nicht.',
      notFoundTitle: 'Ticket',
      whatWouldBeBilled: 'Was abgerechnet wuerde',
      checklist: 'Checkliste',
      checklistHint:
        'Eine Zeile je Sache, die die Rechnung braucht: was steht, woher es kommt und was noch fehlt. Abrechnungsreif ist das Ticket, wenn nichts fehlt.',
      checklistField: 'Feld',
      checklistStatus: 'Zustand',
      checklistText: 'Was dazu bekannt ist',
      checklistOrigin: 'Herkunft',
      checklistStatuses: { Ok: 'ok', Missing: 'fehlt', Doubtful: 'pruefen' },
      fields: {
        Billable: 'Abzurechnen',
        Customer: 'Kunde',
        Order: 'Bestellung',
        Description: 'Leistung',
        Amount: 'Betrag',
        Quantity: 'Menge',
        PaymentTerm: 'Zahlungsziel',
        TaxTreatment: 'Steuerbehandlung',
        Readiness: 'Noch offen',
      },
      origins: {
        Model: 'vom Modell gelesen',
        OrderList: 'aus der Bestellliste',
        CustomerRecord: 'aus den Kundenstammdaten',
        Computed: 'berechnet',
        Person: 'von einer Person gesetzt',
      },
      overruleTitle: 'Zustand von Hand setzen',
      overruleHint:
        'Deine Entscheidung schlaegt das Modell und ueberlebt die naechste Bewertung. Der Grund bleibt am Ticket, damit er spaeter erklaerbar ist.',
      overruleReason: 'Grund',
      overruleSave: 'Zustand setzen',
      chooseState: 'Zustand waehlen',
      stateSaved: 'Der Zustand ist gespeichert.',
      stateFailed: 'Der Zustand konnte nicht gespeichert werden.',
      checks: {
        Billable: 'Das Ticket ist abzurechnen.',
        NotBillable: 'Nach den Regeln dieses Arbeitsbereichs wird dieses Ticket nicht abgerechnet.',
        OrderFound: 'Bestellung {{order}} der Liste „{{list}}“.',
        OrderGuessed:
          'Bestellung {{order}} der Liste „{{list}}“ — das Ticket nennt keine, und es ist die einzige Bestellung von {{customer}}.',
        OrderUnknown:
          'Die Extraktion nennt Bestellung {{order}} der Liste „{{list}}“, und einen solchen Datensatz gibt es nicht.',
        OrderMissing:
          'Fuer dieses Ticket liess sich keine Bestellung aus den Listen des Arbeitsbereichs bestimmen.',
        NotAnOrderList:
          'Der genannte Datensatz {{order}} steht in der Liste „{{list}}“, die keine Bestellliste ist (sie hat keine Spalte mit der Rolle Bestellnummer).',
        OrderListUnkeyed:
          'Die Bestellung steht in der Liste „{{list}}“, die keine Schluesselspalte hat. Bestaetige ihre Schluesselspalte auf der Seite Bestellungen oder rechne gegen eine Liste mit Schluessel ab.',
        CustomerFound: '{{customer}}.',
        CustomerFromOrder: '{{customer}}, der Kunde der Bestellung.',
        CustomerUnconfirmed:
          '{{customer}} ist noch kein bestaetigter Kunde — Anschrift und Steuerbehandlung sind Platzhalter.',
        CustomerMissing: 'Fuer dieses Ticket liess sich kein Kunde aus den Stammdaten bestimmen.',
        DescriptionMissing:
          'Das Ticket enthaelt keinen Text, der die Leistung auf der Rechnung beschreiben koennte.',
        AmountStated: '{{amount}} netto.',
        AmountMissing: 'Das Ticket nennt keinen abrechenbaren Betrag.',
        QuantityComputed:
          '{{quantity}} {{unit}} zu {{rate}} — der Betrag geteilt durch den Satz der Bestellung.',
        QuantityWithoutRate:
          'Die Bestellung nennt keinen Satz; die Position wird als eine Einheit zum vollen Betrag abgerechnet.',
        QuantityFlat:
          '1 {{unit}} pauschal zum vollen Betrag — nach der Abrechnungsregel des Arbeitsbereichs. {{reason}}',
        QuantityDayRate:
          '{{quantity}} {{unit}} zu {{rate}} — nach Tagessatz gemäß der Abrechnungsregel des Arbeitsbereichs. {{reason}}',
        QuantityPricingIncomplete:
          'Die Bewertung hat eine Preisart ohne Einheit, Grund oder die gelesenen Bestellwerte geliefert. Bitte neu bewerten.',
        QuantityPricingStale:
          'Die Preisart wurde aus {{column}} = „{{stated}}“ bestimmt; die wirksame Bestellung sagt jetzt „{{current}}“. Bitte neu bewerten.',
        QuantityDayRateWithoutRate:
          'Die Abrechnungsregel des Arbeitsbereichs rechnet nach Tagessatz ab, die Bestellung nennt aber keinen. Bitte den Tagessatz der Bestellung ergänzen. {{reason}}',
        PaymentTerm: '{{days}} Tage.',
        PaymentTermSellerDefault:
          'Weder Ticket noch Kunde nennen eines; es gilt der Standard des Verkaeufers von {{days}} Tagen.',
        PaymentTermMissing: 'Weder Ticket noch Kunde nennen ein Zahlungsziel.',
        TaxTreatment: '{{treatment}}, aus den Kundenstammdaten.',
      },
      stateOverruled: 'Von Hand gesetzt: {{reason}}',
    },
    customers: {
      notFound: 'Dieser Kunde gehoert nicht zu diesem Arbeitsbereich oder existiert nicht.',
      title: 'Kunden',
      action: 'Kunden',
      cancel: 'Abbrechen',
      city: 'Ort',
      confirmed: 'bestaetigt',
      countryCode: 'Land (2 Buchstaben)',
      description:
        'Kunden, die ein Import angelegt hat, sind zunaechst unbestaetigt: der Name stammt aus der Jira-Organisation, alles andere ist Platzhalter. Speichern bestaetigt den Kunden.',
      actions: 'Aktion',
      delete: '{{name}} loeschen',
      deleteShort: 'Loeschen',
      deleteTitle: 'Diesen Kunden loeschen?',
      deleteDescription:
        '{{name}} wird aus den Kunden dieses Arbeitsbereichs entfernt. Rechnungen und Beispiele bleiben unberuehrt — nennt eines davon diesen Kunden noch, wird nichts geloescht und du erfaehrst, wie viele es sind.',
      deleteFailed: 'Der Kunde konnte nicht geloescht werden.',
      removedNotice: '{{name}} ist geloescht.',
      edit: '{{name}} bearbeiten',
      editShort: 'Bearbeiten',
      editTitle: '{{name}} vervollstaendigen',
      create: 'Neuer Kunde',
      createTitle: 'Neuen Kunden anlegen',
      empty: 'Noch keine Kunden. Der erste entsteht beim ersten Import.',
      listTitle: 'Kunden',
      countSummary_one: '{{count}} Kunde',
      countSummary_other: '{{count}} Kunden',
      loadFailed: 'Die Kunden konnten nicht geladen werden.',
      loading: 'Kunden werden geladen',
      name: 'Name',
      postcode: 'PLZ',
      readOnly: 'Dein Konto darf Kundendaten lesen, aber nicht aendern.',
      save: 'Speichern und bestaetigen',
      saveFailed:
        'Der Kunde konnte nicht gespeichert werden. Bei Reverse Charge ist die USt-Id des Kunden Pflicht.',
      savedNotice: '{{name}} ist gespeichert und bestaetigt.',
      state: 'Zustand',
      street: 'Strasse',
      taxTreatment: 'Steuerbehandlung',
      taxTreatments: {
        Exempt: 'Steuerfrei',
        Export: 'Ausfuhr (ausserhalb EU)',
        ReverseCharge: 'Reverse Charge (EU-Unternehmen)',
        Standard: 'Regelsatz 19 %',
      },
      customerNumber: 'Kundennummer',
      masterDataHint:
        'Weitere Stammdaten. Beides ist freiwillig: Ein Kunde aus einem Ticket kennt diese Angaben nicht und muss trotzdem bestaetigt werden koennen. In die Notizen gehoert alles Weitere, was du ueber den Kunden weisst — Ansprechpartner, Zahlungsgewohnheiten, Abrechnungsregeln — in beliebiger Form; der Import liest sie.',
      notes: 'Notizen',
      unconfirmed: 'unbestaetigt',
      vatId: 'USt-Id',
      billingEmail: 'Rechnungs-E-Mail (steht im Empfaengerblock)',
      addressAddition: 'Adresszusatz (Abteilung, Kostenstelle, c/o)',
      shortName: 'Kurzname (wie deine Listen und Tickets den Kunden nennen)',
      shortNameColumn: 'Kurzname',
      dunningEmails: 'Mahn-E-Mail (mehrere Adressen mit ; trennen)',
      accountManagerEmail:
        'Kundenverantwortlich (interne E-Mail-Adresse; erhält die Erinnerungen, wenn Jira keine Adresse eines Zuständigen nennt)',
      paymentTermDays: 'Zahlungsziel in Tagen (leer: Standard deiner Firma)',
      language: 'Rechnungssprache (de, en; leer: Standard)',
    },
    dueDate: 'Fällig am',
    emptyDescription: 'Legen Sie die erste Ausgangsrechnung an.',
    emptyTitle: 'Noch keine Ausgangsrechnungen',
    events: {
      Imported: 'Importiert',
      Refreshed: 'Aus der Quelle neu gelesen',
      Edited: 'Bearbeitet',
      Approved: 'Freigegeben',
      Dispatched: 'Versendet',
      PaymentReceived: 'Zahlung eingegangen',
      StatusChanged: 'Status geaendert',
      Cancelled: 'Zurückgezogen',
      Approve: 'Freigegeben',
      Cancel: 'Zurückgezogen',
      CreateCorrection: 'Als Rechnungskorrektur angelegt',
      CreateCreditNote: 'Als Gutschrift angelegt',
      Created: 'Angelegt',
      Dispatch: 'Versendet',
      MarkPaid: 'Als bezahlt markiert',
      MarkPartiallyPaid: 'Als teilweise bezahlt markiert',
    },
    grossAmount: 'Brutto',
    netAmount: 'Netto',
    taxAmount: 'USt.',
    cashDiscount: {
      label: 'Skonto',
      value: '{{percent}} bei Zahlung bis {{dueDate}} ({{amount}}), Zahlbetrag {{payable}}',
    },
    units: {
      LE: 'LE (Leistungseinheit)',
      PT: 'PT (Personentag)',
      Std: 'Std (Stunde)',
      Stk: 'Stk (Stück)',
      pauschal: 'pauschal',
    },
    history: {
      detail: 'Einzelheiten',
      at: 'Zeitpunkt',
      event: 'Ereignis',
    },
    historyTitle: 'Verlauf',
    issueDate: 'Rechnungsdatum',
    jira: {
      completeCustomer: 'Kunden vervollstaendigen',
    },
    listTitle: 'Ausgangsrechnungen',
    notFoundDescription: 'Diese Rechnung existiert nicht oder gehoert zu einem anderen Arbeitsbereich.',
    notFoundTitle: 'Dieser Beleg wurde nicht gefunden',
    position: {
      description: 'Bezeichnung',
      quantity: 'Menge',
      unitPrice: 'Einzelpreis',
      number: 'Pos.',
      ticket: 'Ticket',
      vatRate: 'USt.',
    },
    positionsTitle: 'Positionen',
    recipient: 'Empfänger',
    status: 'Status',
    statuses: {
      Approved: 'Freigegeben',
      Cancelled: 'Zurückgezogen',
      Dispatched: 'Versendet',
      Draft: 'Entwurf',
      Overdue: 'Überfällig',
      Paid: 'Bezahlt',
      PartiallyPaid: 'Teilweise bezahlt',
    },
    summaryTitle: 'Übersicht',
  },
  payTransparency: {
    analyseAction: 'Auswerten',
    analyseFailed: 'Die Auswertung ist fehlgeschlagen.',
    analyseNoSnapshot: 'Zuerst müssen die Profile geladen werden – als Excel-Arbeitsmappe.',
    profilesChanged: 'Die Profile wurden während der Auswertung neu geladen. Bitte erneut auswerten.',
    analyseTitle: 'Auswerten',
    analysisTitle: 'Entgelttransparenz – Ergebnis',
    backToOverview: 'Zur Übersicht',
    baseGap: 'Gap Grund',
    cancel: 'Abbrechen',
    chooseHrFile: 'HR-Datei wählen (CSV oder Excel)',
    chooseProfileFile: 'Excel-Arbeitsmappe (.xlsx) wählen',
    coverage: 'Abdeckung',
    distinct: 'Ausprägungen',
    dropHint: 'oder Datei hierher ziehen',
    emptyDescription:
      'Für diesen Datenstand liegt noch kein Ergebnis vor. Auswerten geht auf der Übersicht in Schritt 3.',
    emptyTitle: 'Noch kein Ergebnis',
    employeeId: 'Personalnummer',
    feature: 'Merkmal',
    featureCareerLevel: 'HR-Stufe',
    featureEducation: 'Ausbildung',
    featureEntryDate: 'Eintrittsjahr',
    featureExperience: 'Erfahrung',
    featureJobTitle: 'Jobtitel',
    featureManagementSpan: 'Führungsspanne',
    featureProjectPositions: 'Projektpositionen',
    featureResourceManagementFlag: 'Ressourcenplanung',
    featureRoleEvaluation: 'Rollenbewertung',
    featureRoles: 'Rollen',
    featureSkills: 'Skills',
    featureTeam: 'Team',
    featureWeeklyHours: 'Wochenstunden',
    fileHint:
      'CSV oder Excel (.xlsx), höchstens 2 MB. Wird nur für die Auswertung gelesen, nicht gespeichert.',
    fileRejected: 'Diese Datei wird hier nicht angenommen: {{name}}. Erlaubt sind CSV oder Excel (.xlsx).',
    fileRequired: 'Für die Auswertung fehlt noch die HR-Datei (Schritt 2).',
    forbidden: 'Ihnen fehlt die Berechtigung dafür.',
    gender: 'Geschlecht',
    group: 'Gruppe',
    importSuccess_one: 'Ein Profil importiert.',
    importSuccess_other: '{{count}} Profile importiert.',
    loadFailed: 'Der Stand konnte nicht geladen werden.',
    meanGap: 'Gap Mittel',
    medianGap: 'Gap Median',
    men: 'Männer',
    minPerGender: 'Mindestgröße je Geschlecht',
    minPerGenderHint: 'Kleinere Gruppen zeigen keine Werte; das EntgTranspG verlangt sechs.',
    no: 'nein',
    noAccessTitle: 'Kein Zugang zur Entgelttransparenz',
    noFile: 'Keine Datei gewählt',
    notEntitled: 'Diese Solution ist für Ihren Mandanten nicht freigeschaltet.',
    notImported: 'Noch keine Profile geladen.',
    numberFormat: 'Zahlenformat der Datei',
    numberFormatEnglish: '1,234.56 (englisch)',
    numberFormatGerman: '1.234,56 (deutsch)',
    numberFormatHint: 'Für Beträge, die als Text in der Datei stehen; wird nie geraten.',
    payChangeFile: 'Entgelt ändern',
    payCoverageCount: '{{usable}}/{{total}} Profile mit Entgelt',
    payCoverageHelpLabel: 'Erklärung zur Entgelt-Ampel',
    payCoverageHelpText:
      'Grün: Alle Profile haben ein Entgelt, und jeder Entgeltsatz trifft ein Profil. Gelb: weniger als 10 % ohne Zuordnung. Rot: 10 % oder mehr ohne Zuordnung. Dazu zählen Profile ohne Entgeltsatz, Entgeltsätze ohne Profil und unlesbare Zeilen.',
    payCoverageToneAllMatched: 'alle zugeordnet',
    payCoverageToneFewUnmatched: 'wenige ohne Zuordnung',
    payCoverageToneManyUnmatched: 'zu viele ohne Zuordnung',
    payPurpose: 'Die HR-Datei mit Geschlecht und Jahresentgelt je Person.',
    payPurposeOptional: 'Optional: Eine HR-Datei ersetzt das Entgelt aus der Arbeitsmappe.',
    paySummaryFile: 'HR-Datei {{name}}',
    paySummaryLastFile: 'HR-Datei der letzten Auswertung (nicht gespeichert)',
    paySummaryOpen: 'Noch keine HR-Datei gewählt.',
    paySummaryWaiting: 'Nach den Profilen.',
    paySummaryWorkbook: 'Entgelt aus der Arbeitsmappe',
    profileFileHint: 'Höchstens 10 MB. Wird gelesen, nicht gespeichert; Namen werden übergangen.',
    profileFileRejected:
      'Diese Datei wird hier nicht angenommen: {{name}}. Erlaubt sind Excel-Arbeitsmappen (.xlsx).',
    profileFileRequired: 'Bitte eine Excel-Arbeitsmappe (.xlsx) wählen.',
    profileImportAction: 'Profile hochladen',
    profileImportFailed: 'Der Upload ist fehlgeschlagen.',
    profileImportHint: 'Eine Arbeitsmappe, die Sie selbst pflegen – auf Wunsch mit Entgelt.',
    profileImportTitle: 'Profile aus Excel hochladen',
    profilePayRecords_one: 'Eine Entgeltzeile übernommen – Schritt 2 ist erledigt.',
    profilePayRecords_other: '{{count}} Entgeltzeilen übernommen – Schritt 2 ist erledigt.',
    profileSkipped_one: 'Eine Zeile wurde übersprungen.',
    profileSkipped_other: '{{count}} Zeilen wurden übersprungen.',
    profilesChange: 'Profile ändern',
    profilesPurpose: 'Woher kommen die Profile?',
    profilesSummaryWorkbook: '{{count}} Profile aus Excel-Arbeitsmappe',
    quartiles: 'Frauen je Quartil (Q1→Q4)',
    readinessCount: '{{usable}}/{{total}} Merkmale nutzbar',
    readinessHelpLabel: 'Erklärung zur Ampel',
    readinessHint_one:
      'Nutzbar ab 80 % Abdeckung und zwei Ausprägungen; nur nutzbare Merkmale bilden Gruppen. Bezugsmenge: ein importiertes Profil.',
    readinessHint_other:
      'Nutzbar ab 80 % Abdeckung und zwei Ausprägungen; nur nutzbare Merkmale bilden Gruppen. Bezugsmenge: alle {{count}} importierten Profile.',
    readinessTitle: 'Datenqualität je Merkmal',
    reason: 'Grund',
    reasonDistinctValues_one: 'nur eine Ausprägung',
    reasonDistinctValues_other: 'nur {{count}} Ausprägungen',
    redoAnalysis: 'Neu auswerten',
    referenceDate: 'Stichtag',
    referenceDateInvalid: 'Bitte ein Datum im Format JJJJ-MM-TT angeben.',
    reportCopied: 'Der Bericht liegt in der Zwischenablage.',
    reportCopyFailed: 'Der Bericht konnte nicht in die Zwischenablage kopiert werden.',
    resultPurpose: 'Stichtag wählen und auswerten. Danach wird bei neuen Daten automatisch neu ausgewertet.',
    resultSummary: 'Ausgewertet am {{date}}',
    resultSummaryWaiting: 'Nach Profilen und Entgelt.',
    resultTitle: 'Ergebnis vom {{date}}',
    suppressed: 'n. a.',
    title: 'Entgelttransparenz',
    triggerExplain:
      'Verbleibender Unterschied von mindestens 5 % – ein Hinweis zur Prüfung, keine automatische rechtliche Bewertung.',
    usable: 'Nutzbar',
    variableGap: 'Gap variabel',
    women: 'Frauen',
    yes: 'ja',
    featureLegalEntity: 'Rechtsträger',
    featureLocation: 'Standort',
    hrTemplate: 'Vorlage mit allen Personalnummern herunterladen (Excel)',
    profileTemplate: 'Excel-Vorlage herunterladen',
    checkData: 'Angaben prüfen',
    openResult: 'Ergebnis öffnen',
    payMatched_one: '{{usable}} von {{count}} Profil mit Gehalt zugeordnet',
    payMatched_other: '{{usable}} von {{count}} Profilen mit Gehalt zugeordnet',
    payRowErrors_one: 'eine Zeile unlesbar',
    payRowErrors_other: '{{count}} Zeilen unlesbar',
    payUnchecked: 'Wird bei der Auswertung geprüft',
    payWithoutPay: '{{count}} ohne Entgelt',
    payWithoutProfile_one: 'ein Entgeltsatz ohne Profil',
    payWithoutProfile_other: '{{count}} Entgeltsätze ohne Profil',
    profilesNoGroups: 'Keine Vergleichsgruppen – nur Firmenwerte',
    profilesUsable: 'Auswertung möglich',
    resultAnalysing: 'Wird ausgewertet …',
    resultLine: 'Ergebnis vom {{date}} · {{raw}} gemessen, {{adjusted}} bereinigt',
    resultLineNoModel: 'Ergebnis vom {{date}}',
    resultPurposeRetry: 'Die automatische Auswertung hat nicht geklappt. Bitte erneut auswerten.',
    resultSettings: 'Stichtag {{date}} · Mindestgröße {{min}} je Geschlecht – ändern auf der Ergebnisseite',
    resultStale: 'Die Daten haben sich geändert – das Ergebnis ist nicht mehr aktuell.',
    resultStaleNeedsPay:
      'Die Daten haben sich geändert – für die neue Auswertung fehlt noch die HR-Datei (Schritt 2).',
    resultStaleUpdating: 'Die Daten haben sich geändert – Auswertung wird aktualisiert …',
    profilesUpdated: 'Aktualisiert {{date}}',
    sourceWorkbook: 'Quelle: selbst gepflegte Excel-Arbeitsmappe',
    featureFamily: 'Tätigkeitsfamilie',
    featureRequirementLevel: 'Anforderungsstufe',
    toneSuccess: 'Grün',
    toneWarning: 'Gelb',
    toneError: 'Rot',
    toneNeutral: 'Grau',
    paySeverityWarning: 'Abweichung prüfen',
    paySeverityError: 'zu viele ohne Zuordnung für eine belastbare Auswertung',
    profilesNoHourly: 'Stundenentgelt nicht berechenbar',
    profilesHourlyPartial_one: 'Stundenentgelt für ein Profil nicht berechenbar',
    profilesHourlyPartial_other: 'Stundenentgelt für {{count}} Profile nicht berechenbar',
    featureUnused: '{{feature}} unberücksichtigt',
    featuresUnused_one: 'ein Merkmal unberücksichtigt',
    featuresUnused_other: '{{count}} Merkmale unberücksichtigt',
    profilesAllInResourcePlanning:
      'Alle in der Ressourcenplanung – interne Funktionen werden nicht getrennt.',
    profilesNoResourcePlanning: 'Ressourcenplanung fehlt – interne Funktionen werden nicht getrennt.',
    profilesMatrixOnly: 'Gruppen nach Anforderungsmatrix statt Rollenbewertung.',
    fileUnreadable: 'Die Datei konnte im Browser nicht gelesen werden. Bitte erneut wählen.',
    fileTooLarge: 'Die Datei ist größer als {{max}} MB.',
    readinessRule:
      'Grün: Rollenbewertung möglich. Gelb: nur die Anforderungsmatrix möglich, oder einzelnen Profilen fehlen die Wochenstunden (dann kein Stundenentgelt für sie). Rot: keine Vergleichsgruppen, nur Werte für die ganze Firma, oder niemand hat Wochenstunden. Fehlende optionale Angaben machen die Ampel nicht rot; sie werden nur nicht berücksichtigt.',
  },
  payTransparencySteps: {
    ariaLabel: 'Ablauf',
    pay: 'Entgelt',
    profiles: 'Profile',
    result: 'Ergebnis',
    stateCurrent: 'Jetzt',
    stateDone: 'Erledigt',
    stateOpen: 'Offen',
  },
  // „Angaben prüfen“ auf der Übersicht (DP-50): Ursache, Auswirkung und Korrektur je Merkmal bzw. Entgelt.
  payTransparencyCheck: {
    allFeatures: 'Alle Merkmale anzeigen',
    columnCareerLevel: 'Karrierestufe HR',
    columnEducation: 'Höchster Abschluss',
    columnEntryDate: 'Eintrittsdatum',
    columnExperience: 'Eintrittsdatum und Vorerfahrung Jahre',
    columnJobTitle: 'Jobtitel',
    columnManagementSpan: 'Führungskraft',
    columnProjectPositions: 'Projektpositionen',
    columnResourceManagementFlag: 'Ressourcenplanung',
    columnRoles: 'Rollen',
    columnSkills: 'Skills',
    columnTeam: 'Team',
    columnWeeklyHours: 'Wochenstunden',
    examples: 'Beispiele',
    feature: 'Merkmal',
    fixGeneric: 'In der Profil-Arbeitsmappe ergänzen und neu hochladen.',
    fixRowErrors: 'Die unten genannten Zeilen in der HR-Datei korrigieren und die Datei neu wählen.',
    fixWithoutPay:
      'In der HR-Datei eine Zeile mit genau dieser Personalnummer ergänzen – oder das Profil ist zum Stichtag nicht mehr beschäftigt.',
    fixWithoutProfile:
      'Personalnummer prüfen: Sie muss genau wie im Profil geschrieben sein. Ohne Profil zählt der Satz nicht.',
    fixWorkbook: 'In der Excel-Spalte „{{column}}“ ergänzen und die Arbeitsmappe neu hochladen.',
    impactNoGroups: 'Bildet keine Vergleichsgruppen',
    impactRoleEvaluation: 'Keine Rollenbewertung – die Anforderungsstufe kommt aus der Anforderungsmatrix',
    payRowMessagesTitle: 'Unlesbare Zeilen der HR-Datei',
    payTitle: 'Entgelt-Abgleich prüfen',
    problem: 'Befund',
    problemRowErrors_one: 'Eine Zeile unlesbar',
    problemRowErrors_other: '{{count}} Zeilen unlesbar',
    problemWithoutPay_one: 'Ein Profil ohne Entgelt',
    problemWithoutPay_other: '{{count}} Profile ohne Entgelt',
    problemWithoutProfile_one: 'Ein Entgeltsatz ohne Profil',
    problemWithoutProfile_other: '{{count}} Entgeltsätze ohne Profil',
    profileNothing: 'Keine fehlenden oder unerkannten Angaben.',
    profileTitle: 'Angaben je Merkmal prüfen',
    quoted: '‚{{value}}‘',
    impactResourceManagement: 'Interne Funktionen werden nicht von Delivery getrennt',
    moreSingleValues_one: '+1 weiterer Einzelwert',
    moreSingleValues_other: '+{{count}} weitere Einzelwerte',
    singleValues_one: 'ein Einzelwert',
    singleValues_other: '{{count}} Einzelwerte',
    coverage: 'Angabe',
    coverageMissing_one: 'Bei einem Profil fehlt die Angabe',
    coverageMissing_other: 'Bei {{count}} Profilen fehlt die Angabe',
    coverageUnrecognized_one: 'Bei einem Profil nicht erkannt',
    coverageUnrecognized_other: 'Bei {{count}} Profilen nicht erkannt',
    coverageUnrecognizedValues_one: 'Bei einem Profil nicht erkannt: {{values}}',
    coverageUnrecognizedValues_other: 'Bei {{count}} Profilen nicht erkannt: {{values}}',
    coverageNoVariance: 'Alle Profile haben denselben Wert',
    coverageAllInResourcePlanning: 'Alle Profile stehen in der Ressourcenplanung',
    inModel: 'Im Modell',
    useUsed: 'Berücksichtigt',
    useOmitted: 'Nicht berücksichtigt',
    useOmittedInsufficientData: 'Nicht berücksichtigt – zu wenige verwertbare Angaben',
    useOmittedNoVariance: 'Nicht berücksichtigt – kaum Unterschiede zwischen den Profilen',
    useOmittedNotSeparable: 'Nicht berücksichtigt – nicht von anderen Merkmalen trennbar',
    useExpectedUsed: 'Voraussichtlich berücksichtigt',
    useExpectedOmitted: 'Voraussichtlich nicht berücksichtigt',
    impactWeeklyHours: 'Ohne Wochenstunden kein Stundenentgelt für diese Profile',
    fix: 'Was tun',
    fixUnrecognized: 'Die Angabe ist vorhanden, aber ihre Schreibweise wird noch nicht zugeordnet.',
    recognizedEducation:
      'Erkannte Schreibweisen: Realschule, Ausbildung, Abitur, Meister, Techniker, Bachelor, Diplom (FH), Master, Diplom, Staatsexamen, Promotion.',
    fixNoVariance: 'Nur nötig, wenn sich die Profile hier tatsächlich unterscheiden.',
    fixResourcePlanningWorkbook:
      'In der Excel-Spalte „Ressourcenplanung“ interne Funktionen mit „nein“ kennzeichnen und die Arbeitsmappe neu hochladen.',
    fixVariety: 'Für Vergleiche braucht es mindestens zwei unterschiedliche Angaben.',
    payNothing: 'Alle Profile haben ein Entgelt, und jeder Entgeltsatz trifft ein Profil.',
  },
  // Aussagen, Diagramme und Gruppen des Ergebnisses (DP-50). „Im Modell berücksichtigt“ statt „erklärt“,
  // „verbleibender Unterschied“ statt „unerklärt“; nie „fair“ oder „alles in Ordnung“.
  payTransparencyResult: {
    and: 'und',
    annualCost: 'Kosten pro Jahr',
    budget_one:
      'Modellrechnung: Anhebung einer Frau auf den Erwartungswert kostet rund {{cost}} pro Jahr, danach verbleiben {{after}}. Nur intern.',
    budget_other:
      'Modellrechnung: Anhebung von {{count}} Frauen auf den Erwartungswert kostet rund {{cost}} pro Jahr, danach verbleiben {{after}}. Nur intern.',
    budgetNoRest_one:
      'Modellrechnung: Anhebung einer Frau auf den Erwartungswert kostet rund {{cost}} pro Jahr, danach kein messbarer Unterschied. Nur intern.',
    budgetNoRest_other:
      'Modellrechnung: Anhebung von {{count}} Frauen auf den Erwartungswert kostet rund {{cost}} pro Jahr, danach kein messbarer Unterschied. Nur intern.',
    budgetHint:
      'Was es kostet, jede Frau unter dem Erwartungswert auf diesen anzuheben – nur als Summe und nur ab der Mindestgröße.',
    budgetTitle: 'Kostensimulation',
    careerLevel: 'HR-Stufe',
    personFemale: 'weiblich',
    personMale: 'männlich',
    personDiverse: 'divers',
    caseReviewTitle: 'Entgelt prüfen · {{count}} Personen',
    caseReviewTitle_one: 'Entgelt prüfen · {{count}} Person',
    caseReviewWhy: 'Warum werden diese Personen angezeigt?',
    caseReviewBasis:
      'Das Stundenentgelt dieser Personen liegt mehr als 10 % unter dem Vergleichswert des Modells. Dieser Wert wird aus den berücksichtigten Merkmalen berechnet, ohne den Geschlechtseffekt.',
    caseReviewLimit:
      'Das ist ein Prüfhinweis, kein Nachweis einer Unterbezahlung. Individuelle Entgeltbeträge und genaue Abstände stehen in dieser Ansicht nicht zur Verfügung. Die Reihenfolge bewertet nicht die Dringlichkeit.',
    caseReviewAction:
      'Das Entgelt liegt mehr als 10 % unter dem Modellwert. Zuerst Entgelt, Arbeitszeit und Profilangaben abgleichen; dann mögliche Gründe für die Abweichung klären.',
    checkPayData: 'Entgeltdaten prüfen',
    checkProfileData: 'Profilangaben prüfen',
    assignmentReviewTitle: 'Gruppenzuordnung prüfen · {{count}} Personen',
    assignmentReviewTitle_one: 'Gruppenzuordnung prüfen · {{count}} Person',
    assignmentReviewWhy: 'Warum fallen diese Zuordnungen auf?',
    assignmentReviewBasis:
      'Die Auswertung sortiert die Anforderungsgruppen und die HR-Stufen jeweils nach ihrem mittleren Stundenentgelt. Diese Personen landen in beiden Rangfolgen an deutlich unterschiedlichen Positionen.',
    assignmentReviewLimit:
      'Das belegt weder eine falsche HR-Stufe noch eine Unterbezahlung. Die Liste liefert keine Richtung oder individuelle Entgeltdifferenz. Auch unterschiedliche Zuschnitte der Gruppen können den Hinweis erklären.',
    assignmentReviewAction:
      'Beginnen Sie mit den häufigsten Kombinationen: Passen Tätigkeitsanforderung und hinterlegte HR-Stufe zusammen? Ein Klick auf die Anzahl zeigt die betroffenen Personen.',
    assignmentPairs: 'Auffällige Kombinationen aus Anforderungsgruppe und HR-Stufe',
    reviewPeople: 'Betroffene Personen',
    showReviewPeople: '{{count}} Personen ansehen',
    showReviewPeople_one: '{{count}} Person ansehen',
    selectedReviewPeople: '{{group}} · {{level}} · {{count}} Personen',
    selectedReviewPeople_one: '{{group}} · {{level}} · {{count}} Person',
    allReviewPeople: 'Alle {{count}} Personen anzeigen',
    allReviewPeople_one: '{{count}} Person anzeigen',
    casesHint:
      'Stundenentgelt mehr als 10 % unter dem, was Erfahrung, Ausbildung und Anforderungsstufe erwarten lassen. Ohne Beträge, nie im Bericht.',
    casesTitle: 'Einzelfälle: deutlich unter Erwartung',
    classBelow: 'unter 5 %',
    classUncertain: 'Richtung unsicher',
    classification: 'Einordnung',
    copyReport: 'Bericht als Text kopieren',
    deviationsHint:
      'Personen, deren Anforderungsgruppe deutlich höher oder tiefer bezahlt liegt als ihre HR-Stufe.',
    deviationsTitle: 'Einzelfälle: Anforderung und HR-Stufe weit auseinander',
    effectEducation: 'Eine Ausbildungsstufe höher',
    effectExperience: 'Ein Jahr mehr Erfahrung (Ø {{mean}} Jahre)',
    effectFemale: 'Frau statt Mann, sonst gleich',
    effectLevel: 'Eine Anforderungsstufe höher',
    effectPay: 'Stundenentgelt',
    effectsFit: 'R² = {{r2}}, n = {{n}} Beschäftigte im Modell. Nur Summen, keine Einzelwerte.',
    explained: 'im Modell berücksichtigt',
    factorEducation: 'Ausbildung',
    factorExperience: 'Erfahrung',
    factorLevel: 'Anforderungsstufe',
    groupColumn: 'Vergleichsgruppe',
    groupsTableLabel: 'Vergleichsgruppen',
    incomparable:
      'Diese Quellen lassen sich nicht vergleichen: Kein Entgeltsatz passt zu einem Profil. Schlüssel in Datei oder Profilen angleichen.',
    internalSummary: 'Entgelt prüfen: {{cases}} · Gruppenzuordnung prüfen: {{deviations}} · Kostensimulation',
    internalTitle: 'Einzelfälle und Kostensimulation (intern)',
    interval: '95 %-Intervall',
    matrixGroup: 'Anforderungsgruppe',
    measured: 'Gemessen',
    noModel:
      'Modell nicht verfügbar: {{reason}}. Die Gruppen sind rein beschreibend – das heißt nicht, dass es keinen Unterschied gibt.',
    part: 'Anteil',
    quartile: 'Quartil',
    quartile1: 'Q1 (niedrigstes Viertel)',
    quartile2: 'Q2',
    quartile3: 'Q3',
    quartile4: 'Q4 (höchstes Viertel)',
    quartilesDescription:
      'Anteil der Frauen und Männer in jedem Viertel der Stundenentgelte, vom niedrigsten (Q1) zum höchsten (Q4).',
    quartilesTitle: 'Verteilung über die Gehaltsquartile',
    range: '{{low}} bis {{high}}',
    reportExternal: 'Für die Behörde (a–f, HTML)',
    reportExternalHint: 'Gesamtunternehmen, ohne Gruppen',
    reportJsonExternal: 'Kennzahlen a–f (JSON)',
    reportJsonWorkforce: 'Kennzahlen a–g (JSON)',
    reportMenu: 'Bericht nach Art. 9',
    reportWorkforce: 'Für Beschäftigte und Betriebsrat (a–g, HTML)',
    reportWorkforceHint: 'Mit Gruppen; ohne HR-Stufe, Einzelfälle, Budget. Als PDF druckbar.',
    scope: 'Stichtag {{date}} · {{model}} Beschäftigte im Modell',
    value: 'Wert',
    waterfallDescription:
      'Vom Ausgangswert im Modell ({{raw}}) über die Beiträge der Merkmale zum bereinigten Unterschied ({{unexplained}}).',
    waterfallTitle: 'Vom gemessenen zum bereinigten Unterschied',
    withheld: 'kein Wert (zu klein)',
    womenLifted: 'angehobene Frauen',
    pointsShort: '{{points}} Pp',
    budgetNoAfter_one:
      'Modellrechnung: Anhebung einer Frau auf den Erwartungswert kostet rund {{cost}} pro Jahr; der Unterschied danach ist nicht berechenbar. Nur intern.',
    budgetNoAfter_other:
      'Modellrechnung: Anhebung von {{count}} Frauen auf den Erwartungswert kostet rund {{cost}} pro Jahr; der Unterschied danach ist nicht berechenbar. Nur intern.',
    budgetReversed_one:
      'Modellrechnung: Anhebung einer Frau auf den Erwartungswert kostet rund {{cost}} pro Jahr; danach lägen Frauen rechnerisch {{after}} über Männern. Nur intern.',
    budgetReversed_other:
      'Modellrechnung: Anhebung von {{count}} Frauen auf den Erwartungswert kostet rund {{cost}} pro Jahr; danach lägen Frauen rechnerisch {{after}} über Männern. Nur intern.',
    scopeNoModel: 'Stichtag {{date}} · {{hourly}} mit berechenbarem Stundenentgelt · Modell nicht verfügbar',
    unavailableNoMainLens: 'keine zulässige Hauptgruppierung',
    unavailableNotSolvable: 'die Merkmale lassen sich nicht voneinander trennen (z. B. alle gleich)',
    unavailableTooFew: 'zu wenige vergleichbare Beobachtungen (unter 10)',
    biasBelow:
      '{{factor}} (Belegschaft {{workforce}}) – Frauen erreichen das seltener; ein Teil des Unterschieds kann hier statt im Entgelt liegen.',
    biasShare: '{{factor}} (Belegschaft {{workforce}}).',
    effectCategory: '{{factor}} {{value}} statt {{reference}}',
    effectLeadingPositions: 'Eine leitende Projektposition mehr',
    effectResponsibility1: 'Personalverantwortung 1–5 Berichtende',
    effectResponsibility2: 'Personalverantwortung 6–15 Berichtende',
    effectResponsibility3: 'Personalverantwortung über 15 Berichtende',
    effectSkillDepth: 'Skill-Tiefe eine Stufe höher',
    factorFamily: 'Tätigkeitsfamilie',
    factorLeadingPositions: 'leitende Projektpositionen',
    factorLegalEntity: 'Rechtsträger',
    factorLocation: 'Standort',
    factorResponsibility: 'Personalverantwortung',
    factorSkillDepth: 'Skill-Tiefe',
    factorsDescription:
      'Balken = Wirkung auf das Stundenentgelt in Prozent, Linie = 95 %-Intervall; alles andere gleich.',
    factorsDropped:
      'Nicht im Modell (zu wenige Beobachtungen oder nicht von anderen Merkmalen trennbar): {{factors}}.',
    factorsExcluded: 'Ohne Angabe und deshalb nicht im Modell: {{list}}.',
    factorsPurpose: 'Wie sich das Stundenentgelt ändert, wenn nur dieses Merkmal um eine Stufe anders ist.',
    factorsTitle: 'Zusammenhang zwischen Merkmalen und Entgelt',
    otherFactors: 'Übrige',
    biasTitle: 'Wer erreicht diese Merkmale? Frauenanteil je Merkmal',
    classAboveAgainst: '≥ 5 % zulasten der Frauen',
    classAboveFor: '≥ 5 % zugunsten der Frauen',
    directionAgainst: '{{gap}} zulasten der Frauen',
    directionFor: '{{gap}} zugunsten der Frauen',
    pageTitle: 'Entgeltanalyse',
    pageSubtitle: 'Stichtag {{date}} · ausgewertet {{run}}',
    figuresLabel: 'Kennzahlen',
    measuredTitle: 'Gemessener Unterschied',
    measuredBasis_one: 'Stundenentgelt im Mittelwert (Art. 9), eine Person',
    measuredBasis_other: 'Stundenentgelt im Mittelwert (Art. 9), {{count}} Frauen und Männer',
    measuredWithheld: 'Zu wenige Frauen oder Männer für einen Wert.',
    payCoverage: '{{usable}} von {{total}} Profilen mit Entgelt',
    adjustedTitle: 'Bereinigter Unterschied',
    uncertaintyRange: 'Unsicherheitsbereich: {{range}}',
    uncertaintyHeader: 'Unsicherheitsbereich (95 %)',
    directionUnclear: 'Die Richtung ist statistisch nicht eindeutig.',
    inModel_one: 'im Modell: eine Person',
    inModel_other: 'im Modell: {{count}} Personen',
    notConsidered: 'ohne Berücksichtigung von: {{factors}}',
    noModelShort: 'Nicht berechenbar: {{reason}}.',
    groupsFigureTitle: 'Vergleichsgruppen',
    groupsFigureValue: '{{count}} von {{total}}',
    checkInputs: 'Angaben prüfen',
    directionAgainstShort: 'zulasten der Frauen',
    directionForShort: 'zugunsten der Frauen',
    directionNone: 'kein messbarer Unterschied',
    directionNoneWithGap: '{{gap}}, kein messbarer Unterschied',
    comparisonTitle: 'Gehaltsunterschiede nach Vergleichsgruppe',
    legendAdjusted: 'bereinigter Unterschied',
    legendMeasured: 'gemessener Unterschied',
    overallRow: 'Gesamt',
    adjusted: 'Bereinigt',
    updating: 'Ergebnis wird aktualisiert … Bis dahin gilt das bisherige Ergebnis.',
    updateFailed: 'Die neue Auswertung ist fehlgeschlagen. Das bisherige Ergebnis bleibt sichtbar.',
    hrFileAgain: 'Für eine neue Auswertung die HR-Datei erneut hochladen.',
    toPayStep: 'Zu Schritt 2: Entgelt',
    incomparableTitle: 'Keine gültige Zuordnung',
    art9Title: 'Kennzahlen nach Art. 9 je Gruppe',
    art9Total: 'Gesamtentgelt',
    art9Base: 'Grundentgelt',
    art9Variable: 'Variables Entgelt',
    art9Mean: 'Durchschnitt',
    art9Median: 'Mittlerer Wert (Median)',
    art9Share: 'Frauenanteil',
    art9Quarters: 'Niedrigstes → höchstes Viertel',
    art9Count: 'Personen',
    art9Mark: '5-%-Marke',
    art9MeanHelp:
      'Unterschied zwischen dem durchschnittlichen Stundenentgelt der Männer und dem der Frauen, einschließlich variabler Bestandteile. +18,3 % bedeutet: Frauen verdienen im Durchschnitt 18,3 % weniger pro Stunde. Der Wert ist nicht um Modellmerkmale bereinigt.',
    art9MedianHelp:
      'Für Frauen und Männer wird jeweils der mittlere Wert der nach Höhe sortierten Stundenentgelte verglichen: Eine Hälfte liegt darunter, die andere darüber. Einzelne sehr hohe Entgelte beeinflussen diesen Wert weniger als den Durchschnitt.',
    art9BaseHelp:
      'Unterschied beim durchschnittlichen festen Grundentgelt je Stunde. Variable Bestandteile werden hier nicht mitgezählt.',
    art9VariableHelp:
      'Unterschied beim durchschnittlichen variablen Entgelt je Stunde, etwa Boni oder Prämien. Die Prozentzahl bezieht sich nur auf diese Bestandteile, nicht auf das Gesamtentgelt.',
    art9QuartersHelp:
      'Alle berücksichtigten Personen der Zeile werden nach ihrem Stundenentgelt in vier möglichst gleich große Gruppen aufgeteilt. Die vier Zahlen zeigen den Frauenanteil je Viertel, von den niedrigsten bis zu den höchsten Entgelten. 67 % / 46 % / 15 % / 13 % heißt zum Beispiel: Im niedrigsten Viertel sind 67 % Frauen, im höchsten 13 %. Die vier Anteile müssen zusammen nicht 100 % ergeben.',
    art9MarkHelp:
      'Diese Markierung bezieht sich ausschließlich auf die Spalte Gesamtentgelt / Durchschnitt: Der gemessene Unterschied beträgt mindestens 5 % in eine der beiden Richtungen. Sie bewertet nicht die anderen Spalten und nicht das bereinigte Modell.',
    art9NotShown: 'Nicht ausgewiesen',
    art9ReadHint: 'Entgeltunterschiede in % · + Frauen verdienen weniger · − Frauen verdienen mehr',
    art9SuppressedHint:
      '„Nicht ausgewiesen“: Die Mindestgröße von {{min}} Personen je Geschlecht wird nicht erreicht.',
    art9Summary: 'Mittelwert, Median, Grund- und variables Entgelt, Frauenanteil je Entgeltviertel',
    methodSummary: 'Zuordnung, Modell, Gruppenbildung und Datenqualität',
    waterfallLevelLegend: 'Unterschied in %',
    waterfallDeltaLegend: 'Beitrag eines Merkmals (Änderung in Pp)',
    excludedExperience_one: 'eine ohne Erfahrung',
    excludedExperience_other: '{{count}} ohne Erfahrung',
    excludedHourlyPay_one: 'eine ohne Stundenentgelt',
    excludedHourlyPay_other: '{{count}} ohne Stundenentgelt',
    excludedEducation_one: 'eine ohne Ausbildung',
    excludedEducation_other: '{{count}} ohne Ausbildung',
    excludedLevel_one: 'eine ohne Anforderungsstufe',
    excludedLevel_other: '{{count}} ohne Anforderungsstufe',
    excludedFactor_one: 'eine ohne {{factor}}',
    excludedFactor_other: '{{count}} ohne {{factor}}',
    notInGenderComparison_one: 'eine Person divers nicht im Frauen-Männer-Vergleich',
    notInGenderComparison_other: '{{count}} divers nicht im Frauen-Männer-Vergleich',
    payWithoutProfile_one: 'ein Entgeltsatz ohne Profil',
    payWithoutProfile_other: '{{count}} Entgeltsätze ohne Profil',
    rangeAgainst: '{{low}} bis {{high}} zulasten der Frauen',
    rangeFor: '{{low}} bis {{high}} zugunsten der Frauen',
    rangeAcross: 'von {{for}} zugunsten bis {{against}} zulasten der Frauen',
    directionUnclearShort: 'Richtung unklar',
    notInGenderComparisonFew: 'einzelne Personen mit Geschlecht divers sind nicht im Frauen-Männer-Vergleich',
    allGroups: 'Alle {{count}} Gruppen anzeigen',
    fewerGroups: 'Nur die {{count}} auffälligsten Gruppen zeigen',
    waterfallHelpTitle: 'Wie entsteht der bereinigte Unterschied?',
    waterfallHelp:
      'Die blauen Säulen zeigen Start und Ergebnis. Die grauen Schritte zeigen, wie die Merkmale den Unterschied verändern. Pp bedeutet Prozentpunkte. Die gestrichelte Linie markiert 5 %. Der Startwert stammt aus der Modellrechnung. Die gemessene Kennzahl verwendet einen anderen Durchschnitt; deshalb können die Werte voneinander abweichen.',
    comparisonHelpTitle: 'Diagramm verstehen',
    comparisonHelp:
      'Punkt: geschätzter Unterschied. Orange Raute: der Schätzwert liegt bei mindestens 5 % in eine der beiden Richtungen. Die senkrechten gestrichelten Linien markieren diese 5-%-Grenzen.',
    comparisonUncertaintyHelp:
      'Die waagerechte Linie zeigt den Unsicherheitsbereich (95 %). Je länger sie ist, desto ungenauer die Schätzung. Reicht sie über die 0, ist die Richtung unklar. Eine Raute allein bedeutet daher noch kein gesichertes Ergebnis.',
    detailHelpTitle: 'Was zeigt dieser Vergleich?',
    modelStartShort: 'Ausgangswert im Modell',
    groupPeople: '{{women}} · {{men}}',
    groupWomen_one: '{{count}} Frau',
    groupWomen_other: '{{count}} Frauen',
    groupMen_one: '{{count}} Mann',
    groupMen_other: '{{count}} Männer',
    reviewValue: 'Prüfen',
    modelStart: 'Ausgangswert im Modell (geometrisches Mittel)',
    people_one: 'eine Person',
    people_other: '{{count}} Personen',
    art10Hint: 'Hinweis: bereinigt ab 5 % – gemeinsame Entgeltbewertung prüfen',
    infoLabel: 'Mehr zu: {{figure}}',
    rangeShort: 'Bereich {{range}}',
    rangeAcrossSigned: '{{low}} bis {{high}}',
    adjustedExplain:
      'Der Unterschied, der bleibt, wenn Frauen und Männer mit gleichen Merkmalen verglichen werden (Modell, geometrisches Mittel).',
    groupsInfoLabel: 'Bewertungsgrundlage',
    groupsBasis: 'Gruppierung: {{lens}} ({{basis}})',
    groupsCountAdjusted:
      'Gezählt werden Vergleichsgruppen, deren bereinigter Unterschied 5 % oder mehr beträgt – zulasten oder zugunsten der Frauen.',
    groupsCountMeasured:
      'Ohne Modell: gezählt werden Vergleichsgruppen, deren gemessener Unterschied 5 % oder mehr beträgt – zulasten oder zugunsten der Frauen.',
    groupsFigureNone: 'Keine Vergleichsgruppe mit auswertbarem Wert.',
    markAdjusted: 'bereinigt ab 5 %',
    markMeasured: 'gemessen ab 5 %',
    markUncertain: '(unsicher)',
    signLegend: '+ zulasten der Frauen · − zugunsten der Frauen',
    comparisonSubtitle: '{{metric}} · {{lens}}',
    metricChoice: 'Kennzahl im Diagramm',
    metricMeasured: 'Gemessen',
    metricAdjusted: 'Bereinigt',
    chartTitleMeasured: 'Gemessener Unterschied nach Vergleichsgruppe',
    chartTitleAdjusted: 'Bereinigter Unterschied nach Vergleichsgruppe',
    comparisonDescriptionMeasured:
      'Gemessener Unterschied (Mittelwert nach Art. 9) je Vergleichsgruppe, Gesamt zuerst; gestrichelt die 5-%-Marke. Zu kleine Gruppen ohne Wert.',
    comparisonDescriptionAdjusted:
      'Bereinigter Unterschied (Modell) je Vergleichsgruppe mit Unsicherheitsbereich, Gesamt zuerst; gestrichelt die 5-%-Marke. Zu kleine Gruppen ohne Wert.',
    groupsCounter: '{{count}} von {{total}} Gruppen {{mark}}',
    peopleUngrouped: '{{people}}, davon ohne Gruppe: {{count}}',
    thresholdMeasured: '5-%-Marke (gemessen)',
    thresholdAdjusted: '5-%-Marke (bereinigt)',
    uncertainLegend: 'gestrichelt: Bereich reicht unter 5 %',
    showValues: 'Werte anzeigen',
    directionColumn: 'Richtung',
    directionAgainstWord: 'zulasten',
    directionForWord: 'zugunsten',
    directionUnclearWord: 'unklar',
    directionNoneWord: 'keiner',
    classAt: 'ab 5 %',
    classAtUncertain: 'ab 5 % (unsicher)',
    classTooSmall: 'zu klein',
    groupCheck: 'Gruppe {{group}} prüfen',
    waterfallPurpose: 'Wie viele Prozentpunkte die Merkmale im Modell vom Unterschied erklären.',
    modelStartMeasured: 'Ausgangswert im Modell (geometrisches Mittel; gemessen {{measured}})',
    quartilesPurpose: 'Anteil Frauen und Männer je Viertel der Stundenentgelte.',
    factorsCaution: 'Modellzusammenhänge, keine nachgewiesenen Ursachen.',
    factorsAxisTitle: 'Wirkung auf das Stundenentgelt, %',
    factorsBarLegend: 'Wirkung, alles andere gleich',
    factorsInfo: 'Details zum Modell',
    classDescriptive: 'nur beschreibend',
    classNone_one: 'nicht auswertbar (n = {{count}}, Frauen {{women}})',
    classNone_other: 'nicht auswertbar (n = {{count}}, Frauen {{women}})',
    uncertainGroupsHint_one:
      'Bereich reicht unter 5 % – Gruppe prüfen, bevor eine gemeinsame Entgeltbewertung eingeleitet wird',
    uncertainGroupsHint_other:
      'Bereiche reichen unter 5 % – Gruppen prüfen, bevor eine gemeinsame Entgeltbewertung eingeleitet wird',
    markSomeUncertain_one: '(davon {{count}} unsicher)',
    markSomeUncertain_other: '(davon {{count}} unsicher)',
  },
  // Eine Vergleichsgruppe der Hauptlinse (DP-50): Befund, Herkunft der Gruppe, Zerlegung, Prüffragen.
  payTransparencyGroup: {
    back: 'Zum Ergebnis',
    checkCases_one: 'Eine Person dieser Gruppe liegt deutlich unter Erwartung – Einzelfall prüfen (intern).',
    checkCases_other:
      '{{count}} Personen dieser Gruppe liegen deutlich unter Erwartung – Einzelfälle prüfen (intern).',
    checkJustify:
      'Lässt sich der bereinigte Unterschied von {{gap}} durch objektive, geschlechtsneutrale Kriterien begründen? Sonst die gemeinsame Entgeltbewertung nach Art. 10 vorbereiten.',
    checkNegative: 'Frauen verdienen hier mehr: Ist die Einstufung der Männer dieser Gruppe stimmig?',
    checkNothing: 'Keine Auffälligkeit in dieser Gruppe; beim nächsten Stichtag erneut ansehen.',
    checkPlacement:
      'Ein großer Teil des Unterschieds liegt an Erfahrung, Ausbildung oder Anforderungsstufe: Sind Einstufung und Beförderungen der Frauen sachlich begründet?',
    checkTitle: 'Was jetzt prüfen',
    checkTooSmall:
      'Für ein Modell ist die Gruppe zu klein: das Ergebnis der ganzen Belegschaft heranziehen und die Gruppe beim nächsten Stichtag erneut ansehen.',
    checkUncertain: 'Die Richtung ist unsicher: Zeigt sich der Unterschied auch beim nächsten Stichtag?',
    decompositionTitle: 'Vom gemessenen zum bereinigten Unterschied in dieser Gruppe',
    descriptive:
      'Im Mittelwert beträgt der Unterschied hier {{gap}} ({{women}} Frauen, {{men}} Männer) – nur beschreibend, für ein Modell zu wenige vergleichbare Beobachtungen.',
    findingTitle: 'Befund: {{classification}}',
    measuredLess:
      'Frauen verdienen in dieser Gruppe pro Stunde {{gap}} weniger als Männer ({{women}} Frauen, {{men}} Männer im Modell).',
    measuredMore:
      'Frauen verdienen in dieser Gruppe pro Stunde {{gap}} mehr als Männer ({{women}} Frauen, {{men}} Männer im Modell).',
    missingDescription:
      'Diese Gruppe gibt es im aktuellen Ergebnis nicht – vielleicht wurde inzwischen neu ausgewertet.',
    missingTitle: 'Gruppe nicht gefunden',
    none_one: 'Zu klein für Werte: eine Person – unter der Mindestgröße von {{min}} je Geschlecht.',
    none_other:
      'Zu klein für Werte: {{count}} Personen, davon {{women}} Frauen – unter der Mindestgröße von {{min}} je Geschlecht.',
    remaining:
      'Im Modell berücksichtigt: {{points}} Pp. Bereinigter Unterschied: {{gap}} (Unsicherheitsbereich {{range}}).',
    whyFamily:
      'Die ganze Tätigkeitsfamilie „{{family}}“: Einzelne Stufen hatten weniger als {{min}} Frauen oder Männer und wurden bis zur ganzen Familie zusammengelegt.',
    whyLens: 'Gruppenbildung: {{lens}} – vor jeder Auswertung festgelegt, nie nach dem Entgelt.',
    whyLevel: 'Tätigkeitsfamilie „{{family}}“, Anforderungsstufe {{level}}.',
    whyMerged:
      'Tätigkeitsfamilie „{{family}}“, Anforderungsstufen {{from}} bis {{to}}: zusammengelegt, weil einzelne Stufen weniger als {{min}} Frauen oder Männer hatten.',
    whyTitle: 'Warum diese Gruppe',
    familyDelivery:
      'Tätigkeitsfamilie Delivery: in der Ressourcenplanung, ohne Vertriebsmarker in Jobtitel oder Team.',
    familyInternal: 'Tätigkeitsfamilie Intern: nicht in der Ressourcenplanung (interne Funktionen).',
    familyOther: 'Tätigkeitsfamilie {{family}}.',
    familySales:
      'Tätigkeitsfamilie Vertrieb: Jobtitel oder Team mit Vertriebsmarker (Vertrieb, Sales, Account, Business Development).',
    levelSingle: 'Anforderungsstufe {{level}}.',
    levelsMerged:
      'Anforderungsstufen {{levels}} zusammengelegt, weil einzelne Stufen weniger als {{min}} Frauen oder Männer hatten.',
    lifted_one:
      'Eine Person mit Personalverantwortung um eine Stufe angehoben ({{large}} mit mehr als 15 Berichtenden um eine weitere).',
    lifted_other:
      '{{count}} Personen mit Personalverantwortung um eine Stufe angehoben ({{large}} mit mehr als 15 Berichtenden um eine weitere).',
    moreRoles_one: 'Eine weitere Rolle.',
    moreRoles_other: '{{count}} weitere Rollen.',
    outsideModel_one:
      'Beschreibend {{women}} Frauen / {{men}} Männer; eine Person ohne Modellmerkmale (z. B. Ausbildung) ist im Modell nicht enthalten.',
    outsideModel_other:
      'Beschreibend {{women}} Frauen / {{men}} Männer; {{count}} Personen ohne Modellmerkmale (z. B. Ausbildung) sind im Modell nicht enthalten.',
    role_one: 'Rolle {{role}} (eine Person): {{points}} Punkte → Stufe {{level}} · {{profile}}.',
    role_other: 'Rolle {{role}} ({{count}} Personen): {{points}} Punkte → Stufe {{level}} · {{profile}}.',
    roleCertificates_one: 'ein Zertifikat',
    roleCertificates_other: '{{count}} Zertifikate',
    roleLeadership: 'Führungsrolle',
    roleLevels: 'Ø Stufe {{mean}}, höchste {{max}}',
    roleSkills_one: 'eine geforderte Kompetenz',
    roleSkills_other: '{{count}} geforderte Kompetenzen',
    unassigned_one:
      'Eine Person dieser Familie konnte keiner Gruppe zugeordnet werden (keine bewertete Rolle).',
    unassigned_other:
      '{{count}} Personen dieser Familie konnten keiner Gruppe zugeordnet werden (keine bewertete Rolle).',
    familyAll:
      'Tätigkeitsfamilie: alle Tätigkeiten – ohne Angabe zur Ressourcenplanung nicht nach Delivery und Intern getrennt.',
    familyAllName: 'alle Tätigkeiten',
    familyAllLabel: 'Alle Tätigkeiten',
  },
  // Datengrundlage und Methode der Entgelttransparenz-Analyse (DP-50): eingeklappt am Ende.
  payTransparencyDataBasis: {
    detailData: 'Verwendete Daten',
    detailImport: 'Import und Zuordnung im Detail',
    detailSign:
      'Positive Werte: Frauen verdienen weniger. Negative Werte: Frauen verdienen mehr. Verglichen wird das Entgelt pro Stunde.',
    detailFormula: 'Formel, Bezugsgrößen und fehlende Werte erklären',
    detailModel: 'So entsteht der bereinigte Vergleich',
    detailCalculation: 'Berechnung und Unterschied zum gemessenen Wert',
    detailLimits: 'Teilzeit und fehlende Angaben',
    detailGrouping: 'Gruppenbildung und zusätzliche Prüfungen erklären',
    detailModelMethod:
      'Die Berechnung umfasst {{n}} Personen. Eine Regression schätzt den Zusammenhang zwischen Stundenentgelt und den oben genannten Merkmalen. Die Oaxaca-Blinder-Zerlegung mit gemeinsamen Koeffizienten trennt den durch diese Merkmale erklärten Anteil vom verbleibenden Unterschied. Die Vergleichsgruppen werden vorher gebildet, ohne das Entgelt dafür zu verwenden.',
    summaryMatched: 'Personen mit Profil und Entgeltdaten',
    summaryHourly: 'Davon mit berechenbarem Stundenentgelt',
    summaryModel: 'Personen im bereinigten Vergleich',
    summaryGroups: 'Wer wird miteinander verglichen?',
    summaryGroupsHelp: 'Wie werden die Vergleichsgruppen gebildet?',
    summaryGroupsText:
      'Verglichen werden Gruppen mit ähnlichen Tätigkeiten und Anforderungen. Kleine Gruppen werden zusammengefasst. Für einen Vergleich braucht es mindestens {{min}} Frauen und {{min}} Männer.',
    summaryFactors: 'Was berücksichtigt der bereinigte Vergleich?',
    summaryUncertainty: 'Wie genau sind die Ergebnisse?',
    summaryUncertaintyText:
      'Der Bereich um einen Schätzwert zeigt die statistische Unsicherheit: Je breiter er ist, desto ungenauer lässt sich der Unterschied bestimmen. Dafür wird die Berechnung mit wiederholt gezogenen Stichproben aus den vorhandenen Personen durchgeführt.',
    summaryConcordance: 'Was sagt der Gruppenabgleich aus?',
    summaryConcordanceText:
      'Hier wird geprüft, ob andere Merkmale dieselben Personen zu Gruppen zusammenfassen. Der ARI beschreibt die Übereinstimmung: 1 bedeutet identische Gruppierung, Werte nahe 0 entsprechen etwa einer zufälligen Übereinstimmung. Negative Werte liegen darunter. Das ist kein Urteil über die Qualität der Entgeltanalyse.',
    summaryDetails: 'Daten und Berechnung im Detail ansehen',
    summaryRun: 'Berechnet am {{run}}',
    adjustedGapLine:
      'Gegenprobe ohne Gruppenmerkmal (nur Erfahrung und Ausbildung): verbleibender Unterschied {{gap}} (95 %: {{low}} bis {{high}}), n = {{n}}.',
    decompositionHint:
      'Eine Regression über alle Beschäftigten (Oaxaca-Blinder mit gemeinsamen Koeffizienten) berücksichtigt Erfahrung, Ausbildung und die Anforderungsstufe aus „{{lens}}“; die Gruppen entstehen vorher und ohne Blick aufs Entgelt. Teilzeit und HR-Stufe werden nicht berücksichtigt. n = {{n}}.',
    decompositionSign:
      'Gerechnet mit logarithmierten Stundenentgelten (Jahresentgelt ÷ (Wochenstunden × 52)), also im geometrischen Mittel; der gemessene Unterschied weicht deshalb leicht vom arithmetischen Mittel nach Art. 9 ab. Berücksichtigte Anteile und verbleibender Unterschied ergeben zusammen den gemessenen Unterschied.',
    decompositionTitle: 'Modell',
    excluded:
      'Nicht einbezogen: {{education}} ohne verwertbare Ausbildungsangabe, {{level}} ohne Anforderungsstufe – sie werden gezählt, nicht mit einem Standardwert gerechnet.',
    excludedForReferenceDate: 'Profile zum Stichtag nicht beschäftigt',
    factorsTitle: 'Im Modell berücksichtigte Anteile je Merkmal',
    gapBasis_one:
      'Grundlage der Gap-Werte: ein zugeordneter Beschäftigter mit Wochenstunden; nur diese zählen in den Spalten Frauen und Männer.',
    gapBasis_other:
      'Grundlage der Gap-Werte: {{count}} zugeordnete Beschäftigte mit Wochenstunden; nur diese zählen in den Spalten Frauen und Männer.',
    gapMissing:
      '– = nicht berechenbar: Die Bezugsgröße fehlt, weil der Wert der Männer 0 ist – etwa beim variablen Entgelt, wenn kein Mann der Gruppe variables Entgelt erhält.',
    gapRange:
      'Ein positiver Wert erreicht höchstens 100 %, ein negativer kann beliebig groß werden: Verdienen Frauen im Mittel doppelt so viel wie Männer, steht dort −100 %. Große negative Werte sind deshalb kein Rechenfehler.',
    gapSign:
      'Gap = (Männer − Frauen) ÷ Männer über das Stundenentgelt; positiv heißt: Frauen verdienen weniger als Männer, bezogen auf das Entgelt der Männer. „Gap Mittel“ vergleicht Mittelwerte, „Gap Median“ Mediane.',
    gapSuppressed:
      'n. a. = nicht ausgewiesen: In der Gruppe sind weniger als {{min}} Frauen oder weniger als {{min}} Männer mit Wochenstunden (Mindestgröße). Die Anzahl wird trotzdem gezeigt.',
    groupingMain:
      'Gruppen nach „{{lens}}“: Familie × Anforderungsstufe. Stufen mit weniger als {{min}} Frauen oder Männern werden mit der Stufe darunter zusammengelegt, bis hin zur ganzen Familie.',
    groupingTitle: 'Gruppenbildung',
    inadmissible: 'Wegen fehlender Daten nicht zulässig: {{lenses}}.',
    matched: 'Zugeordnete Beschäftigte',
    matchedWithWeeklyHours: 'davon mit Wochenstunden (in den Gap-Werten)',
    matchingTitle: 'Zuordnung',
    methodTitle: 'Datengrundlage und Methode',
    none: 'keine',
    notExplaining:
      'Teilzeit wird nicht berücksichtigt – verglichen wird ohnehin je Stunde. Nur zur Beschreibung: Teilzeitquote Frauen {{women}}, Männer {{men}}.',
    payRecords: 'Eingelesene Entgeltsätze',
    payRowErrors: 'Nicht lesbare Zeilen der Entgeltdatei',
    payRowErrorsTitle: 'Nicht lesbare Zeilen der Entgeltdatei',
    plausibility: 'Plausibilität: Übereinstimmung der Hauptgruppierung {{pairs}}.',
    plausibilityPair: 'mit {{lens}} {{ari}} (ARI)',
    profileRowMessagesTitle: 'Hinweise zu Zeilen der Profil-Arbeitsmappe',
    profiles: 'Importierte Profile',
    profilesByUserIdKey: 'Profile ohne Personalnummer (Schlüssel U<Nutzer-ID>)',
    readinessMembers_one:
      'Bezugsmenge: ein zugeordneter Beschäftigter dieser Auswertung – nicht alle importierten Profile.',
    readinessMembers_other:
      'Bezugsmenge: {{count}} zugeordnete Beschäftigte dieser Auswertung – nicht alle importierten Profile.',
    readinessTitle: 'Datenqualität je Merkmal',
    readingTitle: 'Wie lese ich die Werte?',
    reason: 'Grund',
    row: 'Zeile',
    rowMessages_one: 'Eine Zeile wurde nicht oder nicht vollständig gelesen.',
    rowMessages_other: '{{count}} Zeilen wurden nicht oder nicht vollständig gelesen.',
    rowMessagesShown: '{{shown}} von {{count}} Meldungen gezeigt.',
    samplesHint:
      'Beispiele nicht zugeordneter Schlüssel, höchstens fünf je Seite. Stehen hier dieselben Menschen unterschiedlich geschrieben – etwa mit oder ohne führende Nullen oder als U<Nutzer-ID> statt Personalnummer –, muss der Schlüssel in einer der beiden Quellen angeglichen werden.',
    samplesPay: 'Schlüssel aus der Entgeltdatei ohne Profil',
    samplesProfiles: 'Schlüssel aus den Profilen ohne Entgeltsatz',
    withoutPay: 'Profile ohne Entgeltsatz',
    withoutProfile: 'Entgeltsätze ohne Profil',
    counts: 'Lauf {{run}} · {{matched}} zugeordnet / {{hourly}} mit Stundenentgelt / {{model}} im Modell.',
    descriptive:
      'Beschreibend nach Art. 9 (arithmetisch, ein anderes Maß als die Aussagen oben): Mittelwert {{mean}}, Median {{median}}.',
    allDetails: 'Alle Details',
    detailsTitle: 'Datengrundlage und Methode – alle Details',
    factorsUsed: 'Im Modell: {{factors}}.',
    intervalMethod:
      '95 %-Intervalle aus {{samples}} Bootstrap-Stichproben mit festem Startwert – gleiche Daten, gleiche Werte.',
  },
  // Entgelt nach Merkmal (DP-50).
  payTransparencyPayBy: {
    chartTitle: 'Mittleres Stundenentgelt nach {{feature}}',
    choice: 'Merkmal',
    count: 'n = {{count}}',
    description:
      'Je Kategorie ein Balken für Männer und einer für Frauen: mittleres Stundenentgelt, darunter die Anzahl.',
    education0: 'Haupt-/Realschule',
    education1: 'Ausbildung/Abitur',
    education2: 'Meister/Techniker',
    education3: 'Bachelor',
    education4: 'Master/Diplom',
    education5: 'Promotion',
    experience0: 'unter 3 Jahre',
    experience1: '3–7 Jahre',
    experience2: '7–12 Jahre',
    experience3: 'ab 12 Jahre',
    feature_careerLevel: 'HR-Stufe (intern)',
    feature_education: 'Ausbildung',
    feature_family: 'Tätigkeitsfamilie',
    feature_level: 'Anforderungsstufe',
    feature_role: 'Rolle',
    feature_skillDepth: 'Skill-Tiefe',
    feature_span: 'Personalverantwortung',
    levelValue: 'Stufe {{level}}',
    noComparison: 'In keiner Kategorie sind genug Frauen und Männer für einen Vergleich.',
    other: 'Übrige',
    span0: 'ohne',
    span1: '1–5 Berichtende',
    span2: '6–15 Berichtende',
    span3: 'über 15 Berichtende',
    title: 'Entgelt nach Merkmal',
    tooSmall: 'n zu klein ({{count}})',
    chooseCategory: 'Vergleichskategorie',
    chooseInterval: 'Erfahrungsgruppe',
    detail:
      '{{feature}} · {{category}}: Frauen {{women}} je Stunde ({{womenCount}} Personen), Männer {{men}} ({{menCount}} Personen) – Frauen gegenüber Männern.',
    detailLabel: 'Detailvergleich',
    difference: 'Unterschied',
    feature_experience: 'Berufserfahrung',
    lines: 'Lineare Trends anzeigen',
    linesHint: 'Durchgezogen: Frauen · gestrichelt: Männer. Einfache Regression, keine bereinigte Lücke.',
    menCount: 'Männer (n)',
    menMean: 'Männer Ø je Stunde',
    pointsWithheld: 'Einzelpunkte sehen nur Berechtigte, die Analysen ausführen; hier die Trends aus Summen.',
    purpose:
      'Beobachtete Stundenentgelte von Frauen und Männern je Merkmal – Berufserfahrung als Verlauf, alle anderen Merkmale im Balkenvergleich.',
    scatterDescription:
      'Jeder Punkt eine Person: x = Jahre Berufserfahrung, y = Stundenentgelt; Kreise Frauen, Rauten Männer; je Geschlecht eine Gerade.',
    scatterTitle: 'Stundenentgelt nach Jahren Berufserfahrung',
    scatterX: 'Jahre Berufserfahrung',
    shortCounts: 'F {{women}} · M {{men}}',
    table: 'Werte als Tabelle anzeigen',
    womenCount: 'Frauen (n)',
    womenMean: 'Frauen Ø je Stunde',
    hint: 'Beobachtete Werte: Gleiches Merkmal bedeutet nicht gleiche Tätigkeit; diese Ansicht zeigt keine bereinigte Lücke und keine Ursache. Kategorien mit weniger als {{min}} Frauen oder Männern zeigen keine Werte.',
    tooFewForChart_one: '{{gender}}: n = {{count}}, zu wenige für eine Darstellung.',
    tooFewForChart_other: '{{gender}}: n = {{count}}, zu wenige für eine Darstellung.',
    tooFewForLine_one: '{{gender}}: n = {{count}}, zu wenige für eine Trendlinie.',
    tooFewForLine_other: '{{gender}}: n = {{count}}, zu wenige für eine Trendlinie.',
  },
  navigation: {
    issues: 'Meldungen',
    collapse: 'Navigation einklappen',
    compliance: 'Compliance-Monitor',
    expand: 'Navigation öffnen',
    fundingRadar: 'Förder-Radar',
    payTransparency: 'Entgelttransparenz',
    language: 'Sprache',
    languageEnglish: 'Englisch',
    languageGerman: 'Deutsch',
    invoiceOutgoing: 'Ausgangsrechnungen',
    invoices: 'Rechnungen',
    absenceProtocol: 'Abwesenheitsprotokoll',
    absenceReview: 'Urlaubsanträge klären',
    absenceResourcePlan: 'Abwesenheitsplan',
    notes: 'Notizen',
    switchWorkspace: 'Arbeitsbereich wechseln',
    workspaceLookupFailed:
      'Ihre Arbeitsbereiche konnten nicht geladen werden. Sie können die Auswahl trotzdem öffnen.',
    workspaces: 'Arbeitsbereiche',
  },
  notFound: {
    description: 'Prüfen Sie den Link oder öffnen Sie Ihren Arbeitsbereich.',
    title: 'Diese Seite wurde nicht gefunden',
  },
  notes: {
    backToList: 'Zu den Notizen',
    body: 'Inhalt',
    bodyOptional: 'Inhalt (optional)',
    create: 'Notiz anlegen',
    createTitle: 'Neue Notiz',
    created: 'Notiz wurde angelegt.',
    createdAt: 'Erstellt am',
    createdBy: 'Erstellt von',
    detailTitle: 'Notiz',
    emptyDescription: 'Legen Sie die erste Notiz für diesen Arbeitsbereich an.',
    emptyTitle: 'Noch keine Notizen',
    forbiddenDescription: 'Sie dürfen in diesem Arbeitsbereich keine Notizen anlegen.',
    listTitle: 'Notizen',
    loadErrorDescription: 'Die Notizen konnten nicht geladen werden. Ihre Daten wurden nicht verändert.',
    loadErrorTitle: 'Notizen momentan nicht erreichbar',
    new: 'Neu',
    notFoundDescription: 'Diese Notiz gibt es nicht oder sie gehört nicht zu diesem Arbeitsbereich.',
    notFoundTitle: 'Notiz nicht gefunden',
    saveErrorDescription: 'Die Notiz konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    saveErrorTitle: 'Speichern nicht möglich',
    saving: 'Wird gespeichert',
    table: 'Notizen',
    title: 'Titel',
    titleRequired: 'Bitte geben Sie einen Titel ein.',
    titleTooLong: 'Der Titel darf höchstens {{max}} Zeichen lang sein.',
    unknownAuthor: 'Unbekannt',
  },
} as const;
